<template>
  <div class="calendar-wrapper">
    <div class="wrapper-border" :style="wrapperCssVars">
      <div class="main-row inner-layer" :style="innerCssVars">
        <div
          class="days-months-container"
          :class="{
            'select-date-for-request': checkForRequestDate('date')
          }"
        >
          <div class="main-tabs-container">
            <div class="main-cal-div" :style="innerCssVars">
              <CalendarSubMenuClientsTable
                :mainTabsList="mainTabsList"
                @setGroupCalendar="getGroupColor"
                :selected-calendar="selectedCal"
                :innerCssVars="innerCssVars"
              />
            </div>
            <div
              class="dropdown main-cal-div calendars-dropdown"
              :style="wrapperCssVars"
            >
              <div class="dropdown-toggle calendar-tab" @click.stop="openCalTabMenu($event)">
                <!--                <i-->
                <!--                  v-if="-->
                <!--                    dateRange[reg].date.start ||-->
                <!--                      (selectedHours[reg].from !== null &&-->
                <!--                        selectedHours[reg].to)-->
                <!--                  "-->
                <!--                  title="Reset date range"-->
                <!--                  @click.stop="resetOneCalendar(reg)"-->
                <!--                  class="fas fa-times cancel-cal-main"-->
                <!--                ></i>-->
                <i
                  class="fas fa-clock"
                  v-if="
                    selectedHours[reg].from !== null && selectedHours[reg].to
                  "
                ></i>
                <div>
                  <!--                  <i class="fas fa-bars"></i>-->
                </div>
                <!--                <div class="arrow" v-if="!ifShowAdd">-->
                <!--                  <span></span>-->
                <!--                  <span></span>-->
                <!--                  <span></span>-->
                <!--                </div>-->
                <div class="toggle-left-side-second">
                  <span>
                    {{
                      selectedCal !== "GR ASNG"
                        ? selectedCal
                        : calNameForCountries.calName
                    }}
                  </span>
                  <!--                  <span v-if="selectedMainTab === 'users'">-->
                  <!--                    SHIFTS-->
                  <!--                  </span>-->
                </div>

                <!--          <span class="caret"></span>-->
                <div class="toggle-left-side numInPercents">
                  <span v-if="selectedCal !== 'SHIFTS'">{{
                    dateRange[reg].date.start && dateRange[reg].date.end
                      ? countSumAvgReg().sum_total
                        ? countSumAvgReg().sum_total
                        : countSumAvgReg().sum
                      : ""
                  }}</span>
                </div>
                <span class="right-add-second" v-if="ifShowAdd"></span>
                <div class="pagination-callTab-wrapper">
                  <!--  <span class="tab-pagination-left" v-show="callTabPaginationIndex > 0">-->
                  <!--        <i class="fa fa-chevron-left"-->
                  <!--           @click="tabPagination($event,'left', selectedCal, calTabs)"></i>-->
                  <!--      </span>-->
                  <!--            <span class="tab-pagination-right" v-show="callTabPaginationIndex != getCalTabList(calTabs).length"> <i class="fa fa-chevron-right"-->
                  <!--                                                                                                                    @click="tabPagination($event,'right', selectedCal, calTabs)"-->
                  <!--            ></i> </span>-->
                </div>
              </div>
              <div class="gnm-menu sub-menu-calTabs" v-show="showCalTabMenu" :style="{ position: 'fixed', top: calTabMenuPos.top + 'px', left: calTabMenuPos.left + 'px' }">
                <button
                  class="dropdown-item btn btn-block"
                  v-for="tab in getCalTabList(calTabs)"
                  :class="getBtnClass(tab.name)"
                  :key="tab.name"
                  @click="
                    selectedCalTab = tab.alias;
                    selectedCal = tab.short;
                    displayedCal = tab.name;
                    showCalTabMenu = false;
                  "
                >
                  <span class="dropdown-item-left-callTabs">
                    {{
                      tab.alias !== "GR_ASGN"
                        ? tab.name
                        : calNameForCountries.calName
                    }}
                  </span>
                </button>
              </div>

              <!--        <ul class="dropdown-menu ul-cals">-->
              <!--          <li v-for="tab in calTabs"-->
              <!--              :key="tab.id"-->
              <!--              :class="{ activedrop: selectedCalTab === tab.alias ,-->
              <!--              monthBetween: calHasRange(tab)-->
              <!--              }"-->
              <!--              @click="selectedCalTab = tab.alias;-->
              <!--          selectedCal = tab.short;-->
              <!--          displayedCal = tab.name;-->
              <!--          ">-->

              <!--            <a>-->
              <!--              <i-->
              <!--                  v-if="dateRange[tab.alias].date.start"-->
              <!--                  title="Reset date range"-->
              <!--                  @click.stop="resetOneCalendar(tab.alias)"-->
              <!--                  class="fas fa-times cancel-cal"-->
              <!--              ></i>-->
              <!--              {{ tab.name }}-->
              <!--            </a >-->
              <!--          </li>-->

              <!--&lt;!&ndash;          <li v-for="tab in spcTabs"&ndash;&gt;-->
              <!--&lt;!&ndash;              :key="tab.id"&ndash;&gt;-->
              <!--&lt;!&ndash;              :class="{ activedrop: selectedCalTab === tab.alias }"&ndash;&gt;-->
              <!--&lt;!&ndash;              @click="selectedCalTab = tab.alias;&ndash;&gt;-->
              <!--&lt;!&ndash;          selectedCal = tab.short;&ndash;&gt;-->
              <!--&lt;!&ndash;          displayedCal = tab.name; "&ndash;&gt;-->
              <!--&lt;!&ndash;          v-show="tab.short != selectedCal"&ndash;&gt;-->
              <!--&lt;!&ndash;          >&ndash;&gt;-->

              <!--&lt;!&ndash;            <a>&ndash;&gt;-->
              <!--&lt;!&ndash;              <i&ndash;&gt;-->
              <!--&lt;!&ndash;                  v-if="dateRange[tab.alias].date.start"&ndash;&gt;-->
              <!--&lt;!&ndash;                  title="Reset date range"&ndash;&gt;-->
              <!--&lt;!&ndash;                  @click.stop="resetOneCalendar(tab.alias)"&ndash;&gt;-->
              <!--&lt;!&ndash;                  class="fas fa-times cancel-cal"&ndash;&gt;-->
              <!--&lt;!&ndash;              ></i>&ndash;&gt;-->
              <!--&lt;!&ndash;              {{ tab.name }}&ndash;&gt;-->
              <!--&lt;!&ndash;            </a >&ndash;&gt;-->
              <!--&lt;!&ndash;          </li>&ndash;&gt;-->
              <!--        </ul>-->
            </div>
          </div>

          <div
            @click="moveDate('back')"
            :class="{
              active_arrow: checkBoundaries('<', 'M')
            }"
            class="arrow-button"
          >
            <i class="fas fa-angle-left"></i>
          </div>
          <ul :class="[s.days]" :key="r" v-for="r in 6">
            <div
              v-if="
                checkIfNextWeek(r) &&
                  userFilledAllShifts &&
                  selectedMainTab === 'users' &&
                  shiftOverviewWeek === null && !checkIfAllMyShiftsApproved()
              "
              style="top: 572px; width: 355px; height: 1px; background-color: #e96868;  position: absolute"
              v-tooltip.top="{
                content: 'Waiting Approval for your shifts, continue to work.',
                show: !checkIfAllMyShiftsApproved() && !userSelectShiftPopup,
                autoHide: false,
                trigger: 'manual'
              }"
            ></div>

            <div
                v-if="
                checkIfNextWeek(r) &&
                  !userFilledAllShifts &&
                  selectedMainTab === 'users'
              "
                style="top: 550px; width: 355px; height: 20px; background-color: #910909;  position: absolute"
                v-tooltip.right="{
                content: 'Fill shifts for monday to friday',
                show: true,
                autoHide: false,
                trigger: 'manual'
              }"
            ></div>

            <div
                v-tooltip.top="{
                content: 'Copy my previous choices',
                show: true,
                autoHide: false,
                trigger: 'manual'
              }"
                class="copy_last_week_shifts"
                style="position: absolute; right: 17px; top: 515px;"
                v-if="
                copyLastWeekShifts &&
                  selectedMainTab === 'users' &&
                  filledLastWeek
              "
            >
              <button
                  class="btn btn-danger"
                  style="border-radius: 0; font-weight: 700"
                  @click="copyShiftsFromLastWeek(r)"
              >
                Copy my previous choices<span style="margin-left: 3px"
              ><i class="far fa-copy"></i
              ></span>
              </button>
            </div>
            <div
                class="shift-choice-overview"
                v-if="
                  r === shiftOverviewWeek &&
                  overviewShifts.length > 0 &&
                  selectedMainTab === 'users'
              "
            >
              <div class="table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th style="text-align: center">Next Week</th>
                    <th style="text-align: center">My choice</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(os, index) in overviewShifts" :key="index">
                    <td style="text-align: center">
                      {{ os.day_name }}
                    </td>
                    <td style="text-align: center">
                      {{ os.shift_name }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <button
                  class="btn btn-success btn-block"
                  style="margin-top: 15px"
                  @click="confirmMyShifts()"
              >
                CONFIRM
              </button>
              <button
                  class="btn btn-danger btn-block"
                  style="margin-top: 1px"
                  @click="cancelAndReChoose()"
              >
                Cancel & Re-Choose
              </button>
            </div>
            <div
                @mouseenter="weekHover = r"
                @mouseleave="weekHover = null"
                @mouseover="checkIfNextWeek(r)"
                class="presets-selector"
                :class="{
                active: checkForActiveWeek(r),
                active_compare: checkForActiveWeekCompare(r)
              }"
                @click="selectWeek(r)"
                v-if="checkForFutureWeek(r)"
            >
              <div
                  class="week-com-buttons-wrapper"
                  v-if="weekHover === r"
                  @mouseenter="weekHover = r"
                  @mouseleave="weekHover = null"
              >
                <!--select new week selection button-->
                <button
                    class="btn btn-success new-btn"
                    v-if="
                    dateRange[reg].date.start &&
                      dateRange[reg].date.end &&
                      !checkForActiveWeek(r)
                  "
                    @click.stop="selectWeek(r)"
                >
                  <img width="20" src="/img/icons/method_draw.svg" />
                </button>
                <!--                select merge week selection button-->
                <button
                    class="btn btn-info merge-btn"
                    v-if="
                    !checkForActiveWeek(r) &&
                      checkForSelectingWeek(r) &&
                      !checkForActiveWeekCompare(r)
                  "
                    @click.stop="
                    checkForSelectingWeek(r) ? selectWeekForCompare(r) : ''
                  "
                >
                  <img width="20" src="/img/icons/method_merge.svg" />
                </button>
              </div>
              <span class="week-num"> WEEK #{{ r }} </span>
              <span>
                {{
                  getDatesForWeek(r).start === getDatesForWeek(r).end
                      ? getDatesForWeek(r).start
                      : getDatesForWeek(r).start + "-" + getDatesForWeek(r).end
                }}
              </span>
            </div>
            <span class="days-wrapper">
              <li
                  :class="[
                  {
                    [s.paintPrevWeekGrey]:
                      checkIfCurrentWeek(r) && selectedMainTab === 'users',

                    [s.daysIsTodayUsers]:
                      markTodayDay(
                      getDayCell(r, i, startMonthDay, endMonthDate),
                      monthsLocale[activeMonthStart],
                      startMonthDay
                    ) && selectedMainTab === 'users',

                    [s.paintUserShiftChoice]:
                      checkIfNextWeek(r) &&
                      selectedMainTab === 'users' &&
                      userFilledAllShifts,

                    [s.paintUserShiftChoiceApproved]:
                      selectedMainTab === 'users' &&
                      checkIfShiftApproved(r, i) &&
                      userFilledAllShifts,
                    [s.daysSelected]: isDateSelected(
                      r,
                      i,
                      'first',
                      startMonthDay,
                      endMonthDate
                    ),
                    [s.userModeAndDateIsWeekend]:
                      isDateIsWeekend(r, i) && selectedMainTab === 'users',
                    [s.daysSelectedInCompare]: isDateInCompareSelected(
                      r,
                      i,
                      'first',
                      startMonthDay,
                      endMonthDate
                    ),
                    [s.daysInRange]: isDateInRange(
                      r,
                      i,
                      'first',
                      startMonthDay,
                      endMonthDate
                    ),
                    [s.daysInRangeCompare]: isDateInRangeCompare(
                      r,
                      i,
                      'first',
                      startMonthDay,
                      endMonthDate
                    ),
                    [s.dateDisabled]:
                      getDayCellDis(r, i, startMonthDay, endMonthDate) < 1 ||
                      startDayZero(i, startMonthDay) ||
                      getDayCell(r, i, startMonthDay, endMonthDate) > 31,
                    // dateAfterMonth(r, i),
                    [s.daysIsToday]: markTodayDay(
                      getDayCell(r, i, startMonthDay, endMonthDate),
                      monthsLocale[activeMonthStart],
                      startMonthDay
                    ),

                    [s.dateAfterToday]:
                      isDateIsFuture(
                        getDayCell(r, i, startMonthDay, endMonthDate),
                        monthsLocale[activeMonthStart]
                      ) ||
                      (getDayCellDis(r, i, startMonthDay, endMonthDate) >
                        endMonthDate &&
                        selectedMainTab !== 'users' &&
                        reg !== 'CA_F' &&
                        isDateIsPast(
                          getDayCell(r, i, startMonthDay, endMonthDate),
                          monthsLocale[activeMonthStart]
                        )),

                    [s.dateAfterToday]:
                      selectedMainTab === 'users'
                        ? isDateIsPast(
                            getDayCell(r, i, startMonthDay, endMonthDate),
                            monthsLocale[activeMonthStart]
                          )
                        : isDateIsFuture(
                            getDayCell(r, i, startMonthDay, endMonthDate),
                            monthsLocale[activeMonthStart]
                          ) ||
                          (isDateIsWeekend(r, i, startMonthDay, endMonthDate) &&
                            !countTheWeekends) ||
                          (getDayCellDis(r, i, startMonthDay, endMonthDate) >
                            endMonthDate &&
                            selectedMainTab !== 'users'),
                    [s.dateIsWeekend]: isDateIsWeekend(
                      r,
                      i,
                      startMonthDay,
                      endMonthDate
                    ),
                    [s.haveBirthDay]: markBirthDay(
                      getDayCell(r, i, startMonthDay, endMonthDate),
                      monthsLocale[activeMonthStart]
                    ),
                    [s.aboveTheAvg]: checkAvgStat(
                      fitStatsToRange(
                        getDayCell(r, i, startMonthDay, endMonthDate),
                        monthsLocale[activeMonthStart]
                      ),
                      'above'
                    ),
                    [s.belowTheAvg]: checkAvgStat(
                      fitStatsToRange(
                        getDayCell(r, i, startMonthDay, endMonthDate),
                        monthsLocale[activeMonthStart]
                      ),
                      'below'
                    ),
                    [s.sameAsAvg]: checkAvgStat(
                      fitStatsToRange(
                        getDayCell(r, i, startMonthDay, endMonthDate),
                        monthsLocale[activeMonthStart]
                      ),
                      'same'
                    ),
                    [s.dateFromTag]: checkDateFromTag(
                      formatCADate(
                        getDayCell(r, i, startMonthDay, endMonthDate),
                        monthsLocale[activeMonthStart]
                      )
                    )
                  }
                ]"
                  :style="{
                  // background: daysBgMethod(
                  //   fitStatsToRange(
                  //     getDayCell(r, i, startMonthDay, endMonthDate),
                  //     monthsLocale[activeMonthStart]
                  //   ),
                  //   fitStatsToRangeTotal(
                  //     getDayCell(r, i, startMonthDay, endMonthDate),
                  //     monthsLocale[activeMonthStart]
                  //   )
                  // ),
                  innerCssVars
                }"
                  :id="'day' + getDayCell(r, i, startMonthDay, endMonthDate)"
                  :key="i"
                  v-for="i in numOfDays"
              >
                <!--users shift selection-->
                <div
                    v-tooltip.top="{
                    content: 'Select a shift from the choices!',
                    show: true,
                    autoHide: false,
                    trigger: 'manual'
                  }"
                    v-if="
                     selectedMainTab === 'users' &&
                    formatCADate(getDayCell(r, i, startMonthDay, endMonthDate),
                     monthsLocale[activeMonthStart]) === shiftsSelectionDate
                      && !userFilledAllShifts && (i !== 6) && (i !== 7)
                  "
                    class="shift-selection"
                    v-click-outside="closeShiftSelection"
                >
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <tr>
                        <td>PRESS TO SELECT</td>
                      </tr>
                      <tbody>
                        <tr v-for="shift in  i === 5 ? fridayChoices : shiftChoices" :key="shift.id">
                          <td
                              class="shift-name"
                              @click="submitShift(shiftsSelectionDate, shift, r)"
                          >
                            {{ shift.name }}
                          </td>
<!--                          <td>-->
<!--                            <div class="form-group" style="float: right; margin-right: 10px;">-->
<!--                              <input type="checkbox" name="shift_priority" id="shift_priority" class="form-check-input"-->
<!--                                     @change="setShiftPriority(shift, r, i)">-->
<!--                            </div>-->
<!--                          </td>-->
<!--                          <td v-if="shiftPriority.choice.id !== null && shiftPriority.choice.id === shift.id && shiftPriority.r === r && shiftPriority.i === i">-->
<!--                            <div class="form-group" style="float: right; margin-right: 10px;">-->
<!--                              <input type="text" name="priority_reason" id="priority_reason" class="form-control reason_input" v-model="shiftPriority.reason" placeholder="type reason">-->
<!--                            </div>-->
<!--                          </td>-->
                        </tr>
                        <span
                            class="shift-costume-window"
                            v-if="openCostumeShiftWindow"
                        >
                          <div class="shift-costume-window-inner">
                            <form>
                              <div class="form-group">
                                <label>
                                  start
                                </label>
                                <input
                                    class="form-control"
                                    step="3600000"
                                    type="time"
                                    v-model="costumeShift.start"
                                />
                              </div>
                              <div class="form-group">
                                <label>
                                  end
                                </label>
                                <input
                                    class="form-control"
                                    step="3600000"
                                    type="time"
                                    v-model="costumeShift.end"
                                />
                              </div>

                              <label>
                                reason
                                <input
                                    id="costume"
                                    class="form-control"
                                    placeholder="reason for this"
                                    type="text"
                                    v-model="costumeShift.reason"
                                />
                              </label>

                              <button
                                  class="btn btn-block btn-success"
                                  @click="saveCostumeShiftChoice(r, i)"
                              >
                                save
                              </button>
                            </form>
                          </div>
                        </span>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!--all users shifts in this day-->
                <div
                    v-if="
                    selectedMainTab === 'users' &&
                      userHoverShiftPopup &&
                      hoverUsersShift.i === i &&
                      hoverUsersShift.r === r &&
                      !userSelectShiftPopup
                  "
                    class="hover-shift-selection"
                >
                  <div class="table-responsive">
                    <table class="table">
                      <tr>
                        <td>
                          users shifts for today
                        </td>
                      </tr>
                      <tbody>
                        <tr
                            v-for="(shift, index) in showUsersShiftsForToday(
                            r,
                            i
                          )"
                            :key="index"
                        >
                          <td class="shift-name">{{ shift.user.full_name }}</td>
                          <td class="shift-name">{{ shift.choice_name }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!--            CA COMPONENT-->
                <div
                    class="hover-shift-selection "
                    :class="{ 'move-pop-up': checkPopUpDate(i, r) }"
                    v-if="
                    openCaComponent.clientId != null &&
                      openCaComponent.ifOpen &&
                      openCaComponent.date ===
                        formatCADate(
                          getDayCell(r, i, startMonthDay, endMonthDate),
                          monthsLocale[activeMonthStart]
                        ) &&
                      openCaComponent.fromTable
                  "
                >
                  <scheduled-calls-pop-up
                      @filterSCByToday="filterSCByToday"
                      @fetchScStats="fetchScStatsEmit"
                      :mode="'add'"
                      :schedule-call-date="openCaComponent.date"
                  ></scheduled-calls-pop-up>
                </div>
                <span
                    @click="
                    () => {
                      //check if select users tab
                      selectedMainTab === 'users'
                        ? showUserSelectShiftPopup(r, i)
                        : '';
                      //check if select scheduled calls calendar
                      //selectedMainTab !== 'users' &&
                      //  reg === 'CA_F' &&
                      openCaComponent.date && openCaComponent.clientId
                        ? openCAPopup(
                            formatCADate(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            )
                          )
                        : '';

                      checkForDatePickForTag()
                        ? sendDateToTag(
                            formatCADate(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ),
                            null
                          )
                        : openCaComponent.date && openCaComponent.clientId
                        ? ''
                        : selectFirstItem(r, i);
                    }
                  "
                    @mousedown.stop="holdDayClick(r, i)"
                    @mouseup.stop="clearHoldDay"
                    @mouseenter="
                    selectedMainTab === 'users' && !isDateIsWeekend(i)
                      ? showHoverShiftsPopup(r, i)
                      : ''
                  "
                    @mouseleave="userHoverShiftPopup = !userHoverShiftPopup"
                >
                  <div
                      class="days-label"
                      :class="[
                      {
                        [s.dateIsWeekendTop]: isDateIsWeekend(r, i),
                        'schedule-day-title':  ifOpenViewMode
                      }
                    ]"
                      :id="
                      r > 5
                        ? checkLastWeek(r, i, startMonthDay, endMonthDate, reg)
                        : (lastWeek = 0)
                    "
                      @mouseleave="
                      [
                        showCaPopUp(null, null),
                        showDpPopUp(null, null),
                        (mouseOverDayTitle = false),
                        clearTimeoutPopUp(timeout)
                      ]
                    "
                      @mouseenter="
                      () => {
                        reg === 'CA_F' ? showCaPopUp(r, i) : '';
                        reg === 'DEP' ? showDpPopUp(r, i) : '';
                      }
                    "
                  >
                    {{
                      markEconomicEvents(
                          getDayCell(r, i, startMonthDay, endMonthDate),
                          monthsLocale[activeMonthStart]
                      ) ||
                      markBirthDay(
                          getDayCell(r, i, startMonthDay, endMonthDate),
                          monthsLocale[activeMonthStart]
                      )
                          ? getDayLabel(r, i).substring(0, 1)
                          : getDayLabel(r, i).substring(0, 2)
                    }}
                    <!--<div class="hover-shift-selection "-->

                    <!--&gt;FOK</div>-->
                    <div
                        class="hover-shift-selection no-calls-tooltip"
                        v-if="
                        !ifOpenViewMode &&
                          hoverUserCA.r === r &&
                          hoverUserCA.i === i
                      "
                    >
                      <span>No calls</span>
                    </div>
                    <!--                      v-if="!ifOpenViewMode && hoverUserCA.r === r &&-->
                    <!--                          hoverUserCA.i === i"-->
                    <div
                        @mouseleave="showCaPopUp(null, null)"
                        class="hover-shift-selection"
                        @mouseenter="
                        () => {
                          reg === 'CA_F' ? showCaPopUp(r, i) : '';
                        }
                      "
                        :class="{
                        'move-pop-up': checkPopUpDate(i, r),
                        'move-pop-up-left': checkPopUpDateLeft(i, r)
                      }"
                        v-if="
                        // reg === 'CA_F' &&
                        ifOpenViewMode &&
                          hoverUserCA.r === r &&
                          hoverUserCA.i === i &&
                          openCaComponent.clientId === null &&
                          //openCaComponent.ifOpen &&
                          openCaComponent.date === null &&
                          !openCaComponent.fromTable &&
                          shouldPresentPopUp(i, r)
                      "
                    >
                      <scheduled-calls-pop-up
                          @filterSCByToday="filterSCByToday"
                          @fetchScStats="fetchScStatsEmit"
                          @setIfOpenViewMode="setIfOpenViewMode"
                          :mode="'view'"
                          :ifOpenViewMode="ifOpenViewMode"
                          :day="i"
                          :week="r"
                          :month="activeMonthStart"
                          :year="activeYearStart"
                          :date-from-calendar="
                          formatCADate(
                            getDayCell(r, i, startMonthDay, endMonthDate),
                            monthsLocale[activeMonthStart]
                          )
                        "
                      ></scheduled-calls-pop-up>
                    </div>

                    <div
                        class="hover-shift-selection-deposit"
                        @click.stop=""
                        @mouseenter="
                        () => {
                          reg === 'DEP' ? showDpPopUp(r, i) : '';
                        }
                      "
                        @mouseleave="clearTimeoutPopUp()"
                        :style="getValueForMoveDepositPopup(i, r)"
                        v-if="
                        // mouseOverDayTitle &&
                        hoverUserDP.r === r &&
                          hoverUserDP.i === i &&
                          CheckUserPermission([1, 2, 3, 4, 12])
                      "
                    >
                      <!--                                              @mouseleave="showDpPopUp(null, null)"-->

                      <!--                      <DepositsPopup-->
                      <!--                          :date-from-calendar="-->
                      <!--                          formatCADate(-->
                      <!--                            getDayCell(r, i, startMonthDay, endMonthDate),-->
                      <!--                            monthsLocale[activeMonthStart]-->
                      <!--                          )-->
                      <!--                        "-->
                      <!--                      />-->

                      <DepositsReportsPopup
                          v-if="showPopUp"
                          :date-from-calendar="
                          formatCADate(
                            getDayCell(r, i, startMonthDay, endMonthDate),
                            monthsLocale[activeMonthStart]
                          )
                        "
                      />
                      <!--                   <DepositsReports-->
                      <!--:dep-tab="'stats'"-->
                      <!--:from-chart="false"-->
                      <!--                   />-->
                      <!--                       :from-chart="true"-->
                      <!--                       :dep-tab="selectedTab"-->

                      <!--                      <scheduled-calls-pop-up-->
                      <!--                          @filterSCByToday="filterSCByToday"-->
                      <!--                          @fetchScStats="fetchScStatsEmit"-->
                      <!--                          @setIfOpenViewMode="setIfOpenViewMode"-->
                      <!--                          :mode="'view'"-->
                      <!--                          :ifOpenViewMode="ifOpenViewMode"-->
                      <!--                          :day="i"-->
                      <!--                          :week="r"-->
                      <!--                          :month="activeMonthStart"-->
                      <!--                          :year="activeYearStart"-->
                      <!--                          :date-from-calendar="-->
                      <!--                          formatCADate(-->
                      <!--                            getDayCell(r, i, startMonthDay, endMonthDate),-->
                      <!--                            monthsLocale[activeMonthStart]-->
                      <!--                          )-->
                      <!--                        "-->
                      <!--                      ></scheduled-calls-pop-up>-->
                    </div>
                    <div class="date-number-inline">
                      {{ getDayCellShow(r, i, startMonthDay, endMonthDate) }}
                    </div>
                    <span
                        @click.stop="showBDTable = !showBDTable"
                        v-if="
                        markBirthDay(
                          getDayCell(r, i, startMonthDay, endMonthDate),
                          monthsLocale[activeMonthStart]
                        )
                      "
                        class="cake-img"
                    ><i
                        class="fas fa-birthday-cake"
                        @click="
                          () => {
                            reg === 'CA_F' ? showCaPopUp(r, i) : '';
                          }
                        "
                    ></i>

                      <div
                          v-if="showBDTable"
                          class="bd-table"
                          v-click-outside="closeBDTable"
                      >
                        <div class="table-responsive">
                          <table class="table">
                            <tbody class="bd-container">
                              <tr
                                  class="bd-text"
                                  v-for="user in birthDaysStats.users"
                                  v-if="checkIfCongrated(user.id)"
                                  :key="user.id"
                              >
                                <td><i class="fas fa-crown"></i></td>
                                <td>{{ user.full_name }}</td>
                                <td>{{ userAge(user) }}</td>
                                <button
                                    class="btn-danger btn-cong"
                                    @click="onSayCongrats(user)"
                                    v-if="checkIfCongrated(user.id)"
                                >
                                  Say Congratulations
                                </button>
<!--                                <button disabled class="btn-cong-dis"-->
<!--                                        v-if="!checkIfCongrated(user.id)">Sent Congratulations</button>-->
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </span>

                    <span
                        @click.stop="showEcEVTTable = !showEcEVTTable"
                        v-if="
                        markEconomicEvents(
                          getDayCell(r, i, startMonthDay, endMonthDate),
                          monthsLocale[activeMonthStart]
                        )
                      "
                        class="events-img"
                    ><i
                        :class="{ pastEvent: checkPastAllEventsDate() }"
                        class="fas fa-flag"
                    ></i>

                      <div
                          v-if="showEcEVTTable"
                          class="evt-table"
                          v-click-outside="closeBDTable"
                      >
                        <div class="table-responsive">
                          <table class="table">
                            <tbody>
                              <tr class="evt-header-text">
                                <td>
                                  {{ "STATUS" }}
                                </td>
                                <td>
                                  {{ "EVENT" }}
                                </td>
                                <td>
                                  {{ "CURRENCY" }}
                                </td>
                                <td>
                                  {{ "FORCAST" }}
                                </td>
                                <td>
                                  {{ "PREVIOUS" }}
                                </td>
                                <td>
                                  {{ "DATE" }}
                                </td>
                              </tr>
                              <tr
                                  :class="{
                                  pastEvent: checkPastEventDate(event.date)
                                }"
                                  class="evt-text"
                                  v-for="event in economicEventsStats"
                                  :key="event"
                              >
                                <td><i class="fas fa-compact-disc"></i></td>
                                <td>{{ event.title }}</td>
                                <td>{{ event.country }}</td>
                                <td>{{ event.forecast }}</td>
                                <td>{{ event.previous }}</td>
                                <td>
                                  {{ momentFormmater(event.date)
                                  }}{{ " (GMT -5:00)" }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </span>
                  </div>
                  <div
                      class="date-number"
                      @mouseleave="showCaPopUp(null, null)"
                  >
                    <!--          validate last range date-->
                    <p
                        v-if="
                        isDateLastRange(
                          getDayCell(r, i, startMonthDay, endMonthDate),
                          monthsLocale[activeMonthStart]
                        )
                      "
                        title="Reset date range"
                        class="edit-text-cancel-btn-cal-day"
                        href="javascript:void(0)"
                        @click.stop="resetOneCalendar(reg)"
                    >
                      <span class="fas fa-times"></span>
                    </p>
                    <!--          validate last compare date-->
                    <p
                        v-if="
                        isDateLastCompare(
                          getDayCell(r, i, startMonthDay, endMonthDate),
                          monthsLocale[activeMonthStart]
                        )
                      "
                        title="Reset date range"
                        class="edit-text-cancel-btn-cal-day"
                        href="javascript:void(0)"
                        @click.stop="resetSecondDate(reg)"
                    >
                      <span class="fas fa-times"></span>
                    </p>

                    <p class="days-numbers animate">
                      {{
                        fitStatsToRange(
                            getDayCell(r, i, startMonthDay, endMonthDate),
                            monthsLocale[activeMonthStart]
                        )
                      }}
                    </p>

                    <p
                        class="days-numbers animate total-number"
                        v-if="
                        fitStatsToRangeTotal(
                          getDayCell(r, i, startMonthDay, endMonthDate),
                          monthsLocale[activeMonthStart]
                        ) !== ''
                      "
                    >
                      {{
                        fitStatsToRangeTotal(
                            getDayCell(r, i, startMonthDay, endMonthDate),
                            monthsLocale[activeMonthStart]
                        )
                      }}
                    </p>

                    <p
                        class="days-numbers numbers-compare animate bg-compare"
                        v-if="
                        dateRange[reg].secondDate.start &&
                          dateRange[reg].secondDate.end
                      "
                    >
                      <span
                          :class="{
                          negativeDiff:
                            fitStatsToCompare(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) !== '' &&
                            fitStatsToCompare(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) < 0,
                          positiveDiff:
                            fitStatsToCompare(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) !== '' &&
                            fitStatsToCompare(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) > 0,
                          sameDiff:
                            fitStatsToCompare(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) !== '' &&
                            fitStatsToCompare(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) === 0
                        }"
                      >
                        {{
                          fitStatsToCompare(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                          )
                        }}
                      </span>
                      <span
                          v-if="
                          dateRange[reg].secondDate.start &&
                            dateRange[reg].secondDate.end &&
                            fitStatsToCompareTotal(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) !== '' &&
                            fitStatsToCompareTotal(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) !== 0
                        "
                          :class="{
                          negativeDiff:
                            fitStatsToCompareTotal(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) !== '' &&
                            fitStatsToCompareTotal(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) < 0,
                          positiveDiff:
                            fitStatsToCompareTotal(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) !== '' &&
                            fitStatsToCompareTotal(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) > 0,
                          sameDiff:
                            fitStatsToCompareTotal(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) !== '' &&
                            fitStatsToCompareTotal(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                            ) === 0
                        }"
                      >
                        {{
                          "/" +
                          fitStatsToCompareTotal(
                              getDayCell(r, i, startMonthDay, endMonthDate),
                              monthsLocale[activeMonthStart]
                          )
                        }}
                      </span>
                    </p>
                  </div>
                </span>
              </li>
            </span>
          </ul>
        </div>

        <div class="filters-container">
          <ul class="filters-unit">
            <div
                @click="moveDate('forward')"
                class="arrow-button"
                :class="{
                active_arrow: checkBoundaries('>', 'M')
              }"
            >
              <i class="fas fa-angle-right"></i>
              <img
                  v-if="
                  requestRegCalDaysBusy ||
                    requestSupportCalDaysBusy ||
                    requestDepCalDaysBusy ||
                    requestRefCalDaysBusy ||
                    requestAssignCalBusy ||
                    requestTransCalDaysBusy ||
                    requestCaCalDaysBusy ||
                    requestLastModCalDaysBusy
                "
                  class="loader-img"
                  width="5"
                  src="../../../../../../../src/assets/svg_icons/calendar_loader.svg"
              />
            </div>

            <li>
              <div class="filters-label-end">SUM</div>
              <!--              v-tooltip="{ content: `Reset`, show: reg === 'DEP', trigger: 'manual'}"-->
              <p
                  class="filters-number animate"
                  v-if="
                  dateRange[reg].date.start &&
                    dateRange[reg].date.end &&
                    selectedCal !== 'SHIFTS'
                "
              >
                {{ countSumAvgReg().sum }}
                <span
                    class="filters-number total-number animate"
                    v-if="countSumAvgReg().sum_total"
                >{{ countSumAvgReg().sum_total }}</span
                >

                <!--              compare SUM numbers-->
                <span
                    v-if="
                    checkForCalCompareStats() &&
                      dateRange[reg].date.start &&
                      dateRange[reg].date.end
                  "
                    :class="{
                    negativeDiff:
                      countSumAvgRegCompare().sum < countSumAvgReg().sum,
                    positiveDiff:
                      countSumAvgRegCompare().sum > countSumAvgReg().sum,
                    sameDiff:
                      countSumAvgRegCompare().sum === countSumAvgReg().sum
                  }"
                    class="filters-number animate"
                >
                  {{ countSumAvgRegCompare().sum }}
                  <span
                      v-if="
                      checkForCalCompareStats() &&
                        countSumAvgRegCompare().sum_total > 0
                    "
                      :class="{
                      negativeDiff:
                        countSumAvgRegCompare().sum_total <
                        countSumAvgReg().sum_total,
                      positiveDiff:
                        countSumAvgRegCompare().sum_total >
                        countSumAvgReg().sum_total,
                      sameDiff:
                        countSumAvgRegCompare().sum_total ===
                        countSumAvgReg().sum_total
                    }"
                  >
                    {{ "/" + countSumAvgRegCompare().sum_total }}
                  </span>
                </span>
              </p>
            </li>
            <li>
              <div
                  class="filters-label-end"
                  :class="[
                  {
                    [s.dateIsWeekendTop]: countTheWeekends
                  }
                ]"
                  @click="countTheWeekends = !countTheWeekends"
              >
                AVG
              </div>
              <p
                  class="filters-number animate"
                  v-if="dateRange[reg].date.start && dateRange[reg].date.end"
              >
                {{ countSumAvgReg().avg.toFixed(1) }}
                <span
                    class="filters-number total-number animate"
                    v-show="
                    countSumAvgReg().avg_total &&
                      dateRange[reg].date.start &&
                      dateRange[reg].date.end
                  "
                >
                  {{ countSumAvgReg().avg_total.toFixed(1) }}
                </span>

                <!--              compare AVG numbers-->

                <span
                    v-if="checkForCalCompareStats()"
                    :class="{
                    negativeDiff:
                      parseFloat(countSumAvgRegCompare().avg.toFixed(1)) <
                      parseFloat(countSumAvgReg().avg.toFixed(0)),
                    positiveDiff:
                      parseFloat(countSumAvgRegCompare().avg.toFixed(1)) >
                      parseFloat(countSumAvgReg().avg.toFixed(0)),
                    sameDiff:
                      parseFloat(countSumAvgRegCompare().avg.toFixed(1)) ===
                      parseFloat(countSumAvgReg().avg.toFixed(0))
                  }"
                    class="filters-number animate"
                >
                  {{ countSumAvgRegCompare().avg.toFixed(0) }}
                  <span
                      v-if="
                      checkForCalCompareStats() &&
                        countSumAvgRegCompare().avg_total !== 0
                    "
                      :class="{
                      negativeDiff:
                        parseFloat(
                          countSumAvgRegCompare().avg_total.toFixed(1)
                        ) < parseFloat(countSumAvgReg().avg_total.toFixed(0)),
                      positiveDiff:
                        parseFloat(
                          countSumAvgRegCompare().avg_total.toFixed(1)
                        ) > parseFloat(countSumAvgReg().avg_total.toFixed(0)),
                      sameDiff:
                        parseFloat(
                          countSumAvgRegCompare().avg_total.toFixed(1)
                        ) === parseFloat(countSumAvgReg().avg_total.toFixed(0))
                    }"
                  >
                    {{ "/" + countSumAvgRegCompare().avg_total.toFixed(0) }}
                  </span>
                </span>
              </p>
            </li>
          </ul>

          <ul class="filters-unit-bottom">
            <li>
              <div class="filters-label-end">
                COUNT
              </div>
            </li>
            <li>
              <div class="filters-label-end">
                <span>
                  {{
                    countSumAvgReg().count !== 0 ? countSumAvgReg().count : ""
                  }}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="calendar-wrapper">
      <div class="tabs-selector">
        <!--hours tabs-->
        <div class="months-text-new">
          <div class="cal-select">
            <ul class="ul-hours style2">
              <!--              <div-->
              <!--                @click="hoursPaginate === 1 ? (hoursPaginate = 0) : ''"-->
              <!--                class="left"-->
              <!--                :class="{ disabled: hoursPaginate === 0 }"-->
              <!--              >-->
              <!--                <i class="fas fa-angle-left"></i>-->
              <!--              </div>-->

              <li
                  v-for="(hour, idx) in availableHoursNum"
                  :key="idx"
                  :class="{
                  is_hour: checkIsHour(hour),
                  active:
                    selectedHours[reg].from === hour - 1 ||
                    selectedHours[reg].to === hour - 1,
                  disabled:
                    hour - 1 < selectedHours[reg].from &&
                    selectedHours[reg].to === null,
                  monthBetween:
                    (selectedHours[reg].from < hour - 1 &&
                      selectedHours[reg].to > hour - 1 &&
                      !checkRangeHour) ||
                    hoverTheHour(hour - 1),
                  [s.dateFromTag]: checkDateFromTag(hour - 1),
                  'select-date-for-request': checkForRequestDate('hour')
                }"
                  @mouseover="
                  !checkForDatePickForTag() ? (checkRangeHour = hour - 1) : ''
                "
                  @mouseout="
                  !checkForDatePickForTag() ? (checkRangeHour = false) : ''
                "
                  @click="
                  checkForDatePickForTag()
                    ? sendDateToTag(null, hour - 1)
                    : clickHourTime(hour - 1)
                "
              >
                <div
                    v-if="
                    (selectedHours[reg].from === hour - 1 &&
                      selectedHours[reg].to === null) ||
                      (selectedHours[reg].from !== null &&
                        selectedHours[reg].to === hour - 1)
                  "
                    @click.stop="resetHours"
                    class="cancel-hour"
                >
                  <i @click="resetHours" class="fas fa-times"> </i>
                </div>
                <span class="hours-label">
                  {{ hour - 1 }}{{ checkIsHour(hour) ? ":00" : "" }}
                </span>
                <p class="hours-counter">
                  {{ fitStatsToHour(hour - 1, "fit") }}
                </p>
                <p
                    class="hours-counter total-number"
                    v-show="fitStatsToHour(hour - 1, 'total')"
                >
                  {{
                    fitStatsToHour(hour - 1, "total")
                        ? fitStatsToHour(hour - 1, "total")
                        : ""
                  }}
                </p>
              </li>

              <!--              <div-->
              <!--                @click="hoursPaginate === 0 ? (hoursPaginate = 1) : ''"-->
              <!--                class="right"-->
              <!--                :class="{ disabled: hoursPaginate === 1 }"-->
              <!--              >-->
              <!--                <i class="fas fa-angle-right"></i>-->
              <!--              </div>-->
            </ul>
          </div>
        </div>

        <!--filters tabs-->
        <ul
            class="ul-filters style2"
            :v-if="CheckUserPermission([1, 2, 3, 4, 5, 6, 8, 12])"
        >
          <li
              v-for="tab in filterPresets"
              :key="tab.id"
              :class="{
              active: checkSelectedFilter(tab.alias)
            }"
              @click="setMainFilterTab(tab.alias)"
          >
            <span class="filters-label">{{ tab.name }}</span>
            <p
                class="filters-number"
                v-show="
                selectedTopFilter === tab.alias && selectedTopFilter !== 'ALL'
              "
            >
              {{ totalCount !== 0 ? totalCount : "" }}
            </p>
            <p
                class="filters-number"
                v-show="
                totalCalVal !== 0 &&
                  selectedTopFilter === tab.alias &&
                  selectedTopFilter !== 'ALL'
              "
            >
              {{ totalCalVal !== 0 ? totalCalVal : "" }}
            </p>

            <!--            REG AND DUP STATS-->
            <p class="filters-number" v-show="selectedTopFilter === 'ALL'">
              {{ tab.alias === "REG" ? regDupStatsReg : "" }}
              {{ tab.alias === "DUP" ? regDupStatsDup : "" }}
            </p>
            <p class="filters-number" v-show="selectedTopFilter === 'ALL'">
              {{ tab.alias === "REG" ? regDupStatsReg_total : "" }}
              {{ tab.alias === "DUP" ? regDupStatsDup_total : "" }}
            </p>
          </li>
        </ul>

        <!--months tabs-->
        <div class="months-text-new">
          <div class="cal-select">
            <ul class="ul-months style2">
              <div
                  @click="startActiveYear--, activeYearStart--"
                  :class="{
                  active_arrow: checkBoundaries('<', 'Y')
                }"
                  class="left"
              >
                <i class="fas fa-angle-left"></i>
              </div>

              <li
                  v-for="tab in availableMonthsNum"
                  :key="tab"
                  :class="{
                  monthBetween:
                    selectionBetweenRange(tab) && activeMonthStart !== tab - 1,
                  active: activeMonthStart === tab - 1
                }"
                  @click="clickOnMonthRange(tab - 1, reg)"
              >
                <div class="month-wrapper">
                  <p
                      v-if="isDateLastRangeMonth(tab)"
                      title="Reset date range"
                      class="edit-text-cancel-btn-cal-month"
                      href="javascript:void(0)"
                      @click.stop="resetOneCalendar(reg)"
                  >
                    <span class="fas fa-times"></span>
                  </p>

                  <div
                      class="months-ranges"
                      :class="{
                      'date-number-inline': returnRangeOfMonth('start', tab)
                    }"
                  >
                    {{ returnRangeOfMonth("start", tab) }}
                  </div>
                  {{ availableMonthsShort[tab - 1]
                  }}{{ `${activeYearStart}`.substring(2, 4) }}
                  <div
                      class="months-ranges"
                      :class="{
                      'date-number-inline': returnRangeOfMonth('end', tab)
                    }"
                  >
                    {{ returnRangeOfMonth("end", tab) }}
                  </div>
                </div>
                <p class="filters-number animate">
                  {{ fitStatsToMonthRange(tab) }}
                </p>
                <p
                    class="filters-number total-number animate"
                    v-if="
                    fitStatsToMonthRangeTotal(tab) !== '' &&
                      fitStatsToMonthRangeTotal(tab) !== undefined
                  "
                >
                  {{ fitStatsToMonthRangeTotal(tab) }}
                </p>
              </li>

              <div
                  @click="startActiveYear++, activeYearStart++"
                  :class="{
                  active_arrow: checkBoundaries('>', 'Y')
                }"
                  class="right"
              >
                <i class="fas fa-angle-right"></i>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!--    approval calls modal-->

    <div
        :key="modalKey"
        class="modal fade"
        id="approveCallsModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="approveCallsModalTitle"
        aria-hidden="true"
        data-keyboard="false"
        data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-stats">
            <scheduled-calls-stats-pop-up :today="true" :tomorrow="approvedCalls.length > 0"/>
          </div>
          <div class="modal-header">
            <h5 class="modal-title" id="approveCallsModalTitle">
              Please approve you calls for
              {{ approvedCalls.length == 0 ? "today " + formatDate('today') : "tomorrow " + formatDate('tomorrow')}}

            </h5>
            <!--            <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
            <!--              <span aria-hidden="true">&times;</span>-->
            <!--            </button>-->
          </div>
          <div class="modal-body">
            <div v-if="showApprModal && approvedCalls.length == 0">
              <scheduled-calls-pop-up
                  @filterSCByToday="filterSCByToday"
                  @fetchScStats="fetchScStatsEmit"
                  @setIfOpenViewMode="setIfOpenViewMode"
                  :mode="'approve_modal'"
                  :ifOpenViewMode="ifOpenViewMode"
                  :approvedCalls="{
                  approvedCalls: approvedCalls,
                  day: 'today'
                }"
                  :date-from-calendar="getCurrentDate(0)"
              ></scheduled-calls-pop-up>
            </div>
            <div v-if="showApprModal && approvedCalls.length > 0">
              <scheduled-calls-pop-up
                  @filterSCByToday="filterSCByToday"
                  @fetchScStats="fetchScStatsEmit"
                  @setIfOpenViewMode="setIfOpenViewMode"
                  :mode="'approve_modal'"
                  :ifOpenViewMode="ifOpenViewMode"
                  :approvedCalls="{
                  approvedCalls: approvedCalls,
                  day: 'tomorrow'
                }"
                  :date-from-calendar="getCurrentDate(1)"
              ></scheduled-calls-pop-up>
            </div>
          </div>
          <div class="modal-footer">
            <!--            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>-->
            <button type="button" class="btn btn-primary" @click="approveCalls">
              Approve calls
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fecha from "fecha";
import {mapGetters, mapState} from "vuex";
import moment from "moment";
import vClickOutside from "v-click-outside";
import apiClientCreator from "../../../../../../helpers/api/request";
import axios from "axios";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import ScheduledCallsPopUp from "../ScheduledCallsPopUp/ScheduledCallsPopUp.component";
import ScheduledCallsStatsPopUp from "../ScheduledCallsPopUp/ScheduledCallsStatsPopUp.component";
import CalendarSubMenuClientsTable from "../menu/CalendarSubMenuClientsTable.component";
import calendarCheck from "../../../../../../mixins/tags/calendarCheck";
import TotalModeCheck from "../../../../../../mixins/tags/TotalModeCheck";
import reduceWithFor from "@/mixins/util/reduceWithFor";
import CalendarDashboardUtils from "./calendarDashboardUtils";
import DepositsPopup
  from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/DepositsPopup/DepositsPopup.component";
import DepositsReports
  from "../../../../../statistics.feature/live_stats.sub_feature/components/DepositsReports.component";
import DepositsReportsPopup from "../DepositsPopup/DepositsReportsPopup.component";
import { Globals } from "@/global_constants/constants";
import SocketEndpoints from "@/mixins/system/SocketEndpoints";
// import TasksShortTable from "../../../../../tasks.feature/components/TasksShortTable.component";

const defaultConfig = {};
const defaultI18n = "EN";
const availableMonths = {
  EN: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};

const availableShortDays = {
  EN: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
};

const presetRangeLabel = {
  today: "TODAY",
  yesterday: "YESTERDAY",
  thisMonth: "THIS MONTH",
  lastMonth: "LAST MONTH",
  lastSevenDays: "LAST 7 DAYS",
  lastThirtyDays: "LAST 30 DAYS",
  last90Days: "LAST 90 DAYS",
  last180Days: "LAST 180 DAYS"
};

const defaultCaptions = {
  title: "Choose Dates",
  ok_button: "Apply"
};

const defaultStyle = {
  daysWeeks: "calendars_weeks",
  days: "calendars_days",
  daysSelected: "calendars_days_selected",
  daysSelectedInCompare: "calendars_days_selected_in_compare",
  daysInRange: "calendars_days_in-range",
  daysInRangeCompare: "calendars_days_in-range_compare",
  daysIsToday: "calendars_days_in-today",
  daysIsTodayUsers: "calendars_days_in-today-users",
  firstDate: "calendars_month_left",
  secondDate: "calendars_month_right",
  presetRanges: "calendars_preset-ranges",
  dateDisabled: "calendars_days_disabled",
  dateShown: "day_is_shown",
  userModeAndDateIsWeekend: "user_mode_date_is_weekend",
  dateAfterToday: "day_is_future",
  dateIsWeekend: "day_is_weekend",
  dateIsWeekendTop: "day_is_weekend_top",
  haveBirthDay: "today_have_birthday",
  aboveTheAvg: "above_the_avg",
  belowTheAvg: "below_the_avg",
  sameAsAvg: "same_as_avg",
  dateFromTag: "tag_from_tag",
  shiftNotSelected: "shift_not_selected",
  paintUserShiftChoice: "paint_user_shift_choice",
  paintUserShiftChoiceApproved: "paint_user_shift_choice_approved",
  paintPrevWeekGrey: "paint_current_week_grey"
};

const setGroupColor = function() {
  return this.innerBrColor;
};

// import Regular from "./registration/RangedatePicker";

export default {
  name: "CalendarsDashboard",
  mixins: [
    UsersPermissionCheck,
    calendarCheck,
    TotalModeCheck,
    reduceWithFor,
    CalendarDashboardUtils,
    SocketEndpoints
  ],
  components: {
    ScheduledCallsStatsPopUp,
    // TasksShortTable,
    DepositsReportsPopup,
    // DepositsReports,
    // DepositsPopup,
    ScheduledCallsPopUp,
    CalendarSubMenuClientsTable
    // Regular,
  },
  props: {
    selectedMainTab: {
      type: String
    },
    bnCalendarTrigger: {
      type: Number,
      default: 0
    },
    selectedTab: {
      type: String
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    showCalendar: {
      type: Boolean,
      required: true
    },

    configs: {
      type: Object,
      default: () => defaultConfig
    },
    i18n: {
      type: String,
      default: defaultI18n
    },
    months: {
      type: Array,
      default: () => null
    },
    shortDays: {
      type: Array,
      default: () => null
    },
    // options for captions are: title, ok_button
    captions: {
      type: Object,
      default: () => defaultCaptions
    },
    format: {
      type: String,
      default: "DD MMM YYYY"
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    initRange: {
      type: Object,
      default: () => null
    },
    startActiveMonth: {
      type: Number,
      default: new Date().getMonth()
    },
    startActiveYear: {
      type: Number,
      default: new Date().getFullYear()
    },
    presetRanges: {
      type: Object,
      default: () => null
    },
    compact: {
      type: String,
      default: "false"
    },
    righttoleft: {
      type: String,
      default: "false"
    },
    // statsReg: {
    //   type: Object
    // },
    statsRegPreset: {
      type: Object
    },
    // statsRegDays: {
    //   type: Object
    // },
    clickToActiveDelay: {
      type: Boolean
    },
    statsNi: {
      type: Object
    },
    statsBn: {
      type: Object
    },
    statsT4: {
      type: Object
    },
    statsCa: {
      type: Object
    },
    statsDup: {
      type: Object
    },
    statsNa: {
      type: Object
    },
    statLastModPersonal: {
      type: Object
    },

    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: () => false
    },
    queryObject: {
      type: Object,
      required: true
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      shiftsSelectionDate: null,
      timeout: {},
      showPopUp: false,
      shiftPriority: {
        choice: {
          id: null,
          name: null
        },
        r: null,
        i: null,
        reason: null
      },
      mouseOverDayTitle: false,
      showApprModal: false,
      approvedCalls: [],
      modalKey: 0,
      costumeShift: {
        start: null,
        end: null,
        reason: null
      },
      openCostumeShiftWindow: false,
      userFilledAllShifts: false,
      ifShowAdd: false,
      callTabPaginationIndex: 0,
      regDupStatsReg: null,
      shiftsStats: null,
      regDupStatsReg_total: null,
      regDupStatsDup: null,
      regDupStatsDup_total: null,
      availableMonthsShort: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      allUsersShifts: [
        {
          day: 2,
          shifts: []
        },
        {
          day: 3,
          shifts: []
        },
        {
          day: 4,
          shifts: []
        },
        {
          day: 5,
          shifts: []
        },
        {
          day: 6,
          shifts: []
        }
      ],
      newAllUsersShifts: [],
      filledLastWeek: false,
      submitedMondayShift: false,
      clickedShiftDay: { i: null, r: null },
      nextShiftDay: { i: null, r: null },
      hoverUsersShift: { r: null, i: null },
      hoverUserCA: { r: null, i: null },
      hoverUserDP: { r: null, i: null },
      userSelectShiftPopup: false,
      shiftOverviewWeek: null,
      copyLastWeekShifts: false,
      overviewShifts: [],
      userHoverShiftPopup: false,
      showEcEVTTable: false,
      startNextCount: 1,
      endLastCount: 0,
      showBDTable: false,
      birthDaysStats: [],
      economicEventsStats: [],
      displayedCal: "USERS",
      selectedCal: "USERS",
      allTags: "ALL",
      active: false,
      ifOpenViewMode: true,
      openDepositsPopup: false,
      numOfDays: 7,
      isFirstChoice: true,
      isFirstChoiceOfSecondDate: true,
      presetActive: "",
      showMonth: true,
      activeMonthStart: this.startActiveMonth,
      activeYearStart: this.startActiveYear,
      activeYearEnd: this.startActiveYear,
      isDupExcluded: false,
      isAgent: false,
      changeToRegChart: true,
      ctv: 0,
      dateRange: {
        REG: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        LAST_MOD: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        LAST_MOD_TAG: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        GR_ASGN: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        CA_F: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        CA_P: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        ASSIGN: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        TRA: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        DEP: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        REF: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        SUP: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        LEAD_TAG: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        NA_TAG: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        BN_TAG: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        LIVE: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        SHIFTS: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        tag: "",
        date: "",
        secondDate: ""
      },
      show: false,

      cancelAllTimeLastMod: false,

      requestLastModCalBusy: false,
      requestRegCalBusy: false,
      requestRegCalDaysBusy: false,
      requestCaCalBusy: false,
      requestCaCalDaysBusy: false,
      requestRefCalDaysBusy: false,
      requestDepCalDaysBusy: false,
      requestCallCalBusy: false,
      requestDupCalBusy: false,
      requestT4CalBusy: false,
      requestNaCalBusy: false,
      requestNiCalBusy: false,
      requestBnCalBusy: false,
      requestAssignCalBusy: false,
      requestTransCalBusy: false,
      requestTransCalDaysBusy: false,
      requestDepCalBusy: false,
      requestRefCalBusy: false,
      requestSupportCalBusy: false,
      requestSupportCalDaysBusy: false,
      requestLastModCalDaysBusy: false,
      requestRegCalPresetsBusy: false,

      regCalStats: {},

      regCalStatsTodays: {
        REG: {},
        LAST_MOD: {},
        LAST_MOD_TAG: {},
        CA: {},
        ASSIGN: {},
        TRA: {},
        DEP: {},
        REF: {},
        SUP: {},
        NA_TAG: {},
        BN_TAG: {},
        LEAD_TAG: {},
        GR_ASGN: {},
        SHIFTS: {}
      },
      availableMonthsNum: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      availableHoursNum: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24
      ],

      regDateRange: {},
      shiftsDateRange: {},
      modDateRange: {},
      modTagDateRange: {},
      caDateRange: {},
      caPastDateRange: {},
      assignDateRange: {},
      tranDateRange: {},
      refDateRange: {},
      depDateRange: {},
      supDateRange: {},
      naTagDateRange: {},
      leadTagDateRange: {},
      groupTagDateRange: {},

      groupColor: "",
      rstRegTable: false,
      rstRegCal: false,
      rstCaCal: false,
      rstDepCal: false,
      rstTransCal: false,
      rstModCal: false,
      rstModTagCal: false,
      rstSupportCal: false,
      rstAssignCal: false,
      rstRefCal: false,
      selectedMainGroup: "clients",

      countTheWeekends: true,
      daysInterval: null,

      selectedCalTab: "REG",
      selectedRegPreset: null,

      shiftChoices: [
        {
          id: 1,
          name: "MORNING: 09:00 - 17:00"
        },
        {
          id: 2,
          name: "NOON: 12:00 - 20:00"
        },
        {
          id: 3,
          name: "EVENING: 15:00 - 23:00"
        },
        {
          id: 4,
          name: "Any"
        },
        // {
        //   id: 5,
        //   name: "DO NOT CARE"
        // },
        {
          id: 6,
          name: "VACATION"
        },
        {
          id: 7,
          name: "CUSTOM"
        },
        {
          id: 8,
          name: "ILLNESS"
        }
      ],
      fridayChoices: [
        {
          id: 1,
          name: "MORNING: 09:00 - 16:00"
        },
        {
          id: 2,
          name: "NOON: 11:00 - 18:00"
        },
        {
          id: 3,
          name: "EVENING: 14:00 - 21:00"
        },
        {
          id: 4,
          name: "Any"
        },
        // {
        //   id: 5,
        //   name: "DO NOT CARE"
        // },
        {
          id: 6,
          name: "VACATION"
        },
        {
          id: 7,
          name: "CUSTOM"
        },
        {
          id: 8,
          name: "ILLNESS"
        }
      ],
      calTabs: [
        {
          id: 0,
          name: "USER",
          alias: "REG",
          short: "USER",
          color: "#1bc51b"
        },
        {
          id: 14,
          name: "SHIFTS",
          alias: "SHIFTS",
          short: "SHIFTS",
          color: "#cf1134"
        },
        {
          id: 3,
          name: "SCHEDULED CALLS",
          // alias: "CA_F",
          alias: "CA_F",
          short: "SC-F",
          color: "#fa8100"
        },
        {
          id: 1,
          name: "LAST MODIFIED",
          alias: "LAST_MOD",
          short: "L. MOD",
          color: "#8a8c5b"
        },
        {
          id: 3,
          name: "SCHEDULED CALLS-P",
          // alias: "CA_P",
          alias: "CA_P",
          short: "SC-P",
          color: "#fa8100"
        },
        {
          id: 5,
          name: "TRANSFERS",
          alias: "TRA",
          short: "TR",
          color: "#ab9b0c"
        },
        {
          id: 6,
          name: "REFERRALS",
          alias: "REF",
          short: "RF",
          color: "#d32f2f"
        },
        {
          id: 10,
          name: "LEAD TAG",
          alias: "LEAD_TAG",
          short: "LD",
          color: "#4275ec"
        },
        {
          id: 7,
          name: "DEPOSITS",
          alias: "DEP",
          short: "DP",
          color: "#ae3ede"
        },
        {
          id: 4,
          name: "ASSIGNMENTS",
          alias: "ASSIGN",
          short: "AS",
          color: "rgb(171, 206, 64)"
        },
        {
          id: 11,
          name: "NA TAG",
          alias: "NA_TAG",
          short: "NA",
          color: "#f4511e"
        },
        {
          id: 15,
          name: "BN TAG",
          alias: "BN_TAG",
          short: "BN",
          color: "#b71c1c"
        },
        {
          id: 8,
          name: "SUPPORT",
          alias: "SUP",
          short: "SUP",
          color: "#0092bc"
        },
        {
          id: 2,
          name: "LAST MOD TAG",
          alias: "LAST_MOD_TAG",
          short: "L. M. TAG",
          color: "#0092bc"
        },
        {
          id: 12,
          name: "GR ASNG",
          alias: "GR_ASGN",
          short: "GR ASNG",
          color: ""
        },
        {
          id: 9,
          name: "LIVE",
          alias: "LIVE",
          short: "LV",
          color: "#0092bc"
        }
      ],
      spcTabs: [
        {
          id: 0,
          name: "LIVE",
          alias: "LIVE",
          short: "LIVE",
          color: "#e6ff00"
        }
      ],
      reg: "REG",
      dontShowLeftTable: false,
      showResetBtn: false,
      showCalTabMenu: false,
      calTabMenuPos: { top: 0, left: 0 },
      selectedTopFilter: "ALL",
      totalCount: 0,
      firstLoad: false,
      fetchAll: false,
      presets: [
        //   {
        //     id:1,
        //     name:'T',
        //     alias:'TODAY'
        //   },
        //   {
        //     id:2,
        //     name:'Y',
        //     alias:'YESTERDAY'
        //   },
        {
          id: 3,
          name: "W",
          alias: "WEEK"
        },
        {
          id: 4,
          name: "M",
          alias: "MONTH"
        },
        {
          id: 5,
          name: "L-M",
          alias: "LAST_MONTH"
        },
        {
          id: 6,
          name: "Q",
          alias: "QUARTER"
        },
        {
          id: 6,
          name: "H",
          alias: "HALF_YEAR"
        }
      ],
      daysLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      filterPresets: [
        {
          id: 1,
          name: "REG",
          alias: "REG"
        },
        // {
        //   id: 3,
        //   name: "REG & DUP",
        //   alias: "ALL"
        // },
        {
          id: 2,
          name: "DUP",
          alias: "DUP"
        }
      ],
      lastWeek: 0,

      dateRangesStats: {
        REG: [],
        LAST_MOD: [],
        LAST_MOD_TAG: [],
        CA_F: [],
        CA_P: [],
        ASSIGN: [],
        TRA: [],
        DEP: [],
        REF: [],
        SUP: [],
        LIVE: [],
        NA_TAG: [],
        BN_TAG: [],
        LEAD_TAG: [],
        GR_ASGN: [],
        SHIFTS: []
      },
      dateRangesStatsCompare: {
        REG: [],
        LAST_MOD: [],
        LAST_MOD_TAG: [],
        CA_F: [],
        CA_P: [],
        ASSIGN: [],
        TRA: [],
        DEP: [],
        REF: [],
        SUP: [],
        LIVE: [],
        NA_TAG: [],
        BN_TAG: [],
        LEAD_TAG: [],
        GR_ASGN: [],
        SHIFTS: []
      },

      hoursRangesStats: {
        REG: [],
        LAST_MOD: [],
        LAST_MOD_TAG: [],
        CA_F: [],
        CA_P: [],
        ASSIGN: [],
        TRA: [],
        DEP: [],
        REF: [],
        SUP: [],
        LIVE: [],
        NA_TAG: [],
        BN_TAG: [],
        LEAD_TAG: [],
        GR_ASGN: [],
        SHIFTS: []
      },
      yearsList: [],
      liveMode: false,
      selectedLiveUser: "ALL",
      usersList: null,
      spcListArr: ["LIVE"],
      hoursList: [
        {
          id: 1,
          values: "01:00",
          name: "01"
        },
        {
          id: 2,
          values: "02:00",
          name: "02"
        },
        {
          id: 3,
          values: "03:00",
          name: "03"
        },
        {
          id: 4,
          values: "04:00",
          name: "04"
        },
        {
          id: 5,
          values: "05:00",
          name: "05"
        },
        {
          id: 1,
          values: "06:00",
          name: "06"
        },
        {
          id: 1,
          values: "07:00",
          name: "07"
        },
        {
          id: 1,
          values: "08:00",
          name: "08"
        }
      ],
      selectedHours: {
        REG: {
          from: null,
          to: null
        },
        LAST_MOD: {
          from: null,
          to: null
        },
        LAST_MOD_TAG: {
          from: null,
          to: null
        },
        CA_F: {
          from: null,
          to: null
        },
        CA_P: {
          from: null,
          to: null
        },
        ASSIGN: {
          from: null,
          to: null
        },
        TRA: {
          from: null,
          to: null
        },
        DEP: {
          from: null,
          to: null
        },
        REF: {
          from: null,
          to: null
        },
        SUP: {
          from: null,
          to: null
        },
        LIVE: {
          from: null,
          to: null
        },
        NA_TAG: {
          from: null,
          to: null
        },
        BN_TAG: {
          from: null,
          to: null
        },
        LEAD_TAG: {
          from: null,
          to: null
        },
        GR_ASGN: {
          from: null,
          to: null
        },
        SHIFTS: {
          from: null,
          to: null
        }
      },

      yearsPaginate: 0,
      monthPaginate: 0,
      hoursPaginate: 0,
      checkRangeHour: false,
      weekHover: null,

      innerBrColor: "#1bc51b",
      wrapperBrColor: "#1bc51b",

      totalCalVal: 0,
      styleTabsObject: {},
      caDate: null,
      calHashes: {},
      congratedUserIds: []
    };
  },
  watch: {

    ifOpenViewMode: function() {
    },
    resetCalendar: function() {
      if (this.resetCalendar) {
        this.resetOneCalendar(this.resetCalendar);
        this.$store.commit("clients/setResetOneCalendar", null);
      }
    },
    calendarDates: function() {
      let calObj = Object.assign({}, this.calendarDates);
      this.selectedCalTab = calObj.calendar;
      if (
          !this.dateRange[calObj.calendar].date.start &&
          !this.dateRange[calObj.calendar].date.end
      ) {
        if (calObj.dates) {
          this.dateRange[calObj.calendar].date.start = moment(
              calObj.dates.start
          ).toDate();
          this.dateRange[calObj.calendar].date.end = moment(
              calObj.dates.end
          ).toDate();
        } else {
          let keys = Object.keys(this.dateRange);
          let first = false;
          keys.map(key => {
            switch (key) {
              case "tag":
                return;
              case "secondDate":
                return;
              case "date":
                return;
            }
            if (
                this.dateRange[key].date.start &&
                this.dateRange[key].date.end &&
                !first
            ) {
              first = true;
              this.dateRange[calObj.calendar].date.start = this.dateRange[
                  key
                  ].date.start;
              this.dateRange[calObj.calendar].date.end = this.dateRange[
                  key
                  ].date.end;
            }
          });
        }
      }

      this.setDateValue(calObj.calendar);
    },
    requestForDate: function() {
      if (
          this.requestForDate.direction === "FROM_TAG" &&
          this.requestForDate.calendar
      ) {
        this.selectedCalTab = this.requestForDate.calendar;
      }
    },
    selectedCalendarType: function() {
      if (this.selectedCalendarType.alias) {
        let preset = this.selectedCalendarType.preset;
        this.selectedCalTab = this.selectedCalendarType.alias;
        if (
            // !this.dateRange[this.reg].date.start &&
            // !this.dateRange[this.reg].date.start &&
            preset
        ) {
          this.reg = this.selectedCalTab;
          this.updatePreset(
              this.selectedCalendarType.alias,
              this.finalPresetRanges[preset],
              preset
          );
        }
      } else {
        this.resetOneCalendar(this.reg);
        //this.selectedCalTab = "REG";
      }
    },
    openCaComponent: {
      handler() {
        this.handleCaChoose();
      },
      deep: true
    },
    dateRangesStats: {
      handler() {
        this.bounceEffect();
      },
      deep: true
    },
    liveDataFilter: function() {
      if (this.reg === "LIVE") {
        this.setMainFilterTab(this.liveDataFilter);
      }
    },

    mainCalendarDates: function() {
      let preset = false;
      let datesObj = this.mainCalendarDates.dates;
      let calendar = this.mainCalendarDates.calendar;
      if (
          moment(datesObj.start).format("YYYY-MM-DD") ===
          moment().format("YYYY-MM-DD") &&
          moment(datesObj.end).format("YYYY-MM-DD") ===
          moment().format("YYYY-MM-DD")
      ) {
        preset = "TODAY";
      }
      if (
          moment(datesObj.start).format("YYYY-MM-DD") ===
          moment()
              .subtract(1, "days")
              .format("YYYY-MM-DD") &&
          moment(datesObj.end).format("YYYY-MM-DD") ===
          moment()
              .subtract(1, "days")
              .format("YYYY-MM-DD")
      ) {
        preset = "YESTERDAY";
      }
      this.resetAllCalendars();

      if (calendar === "DEP") {
        this.selectedCalTab = "DEP";
        this.reg = "DEP";
        this.selectedCal = "DEP";
        this.displayedCal = "DEPOSITS";
        this.setMainFilterTab("ALL");
        //this.fetchDepositsStats(this.reg);
      }

      if (preset) {
        this.updatePreset("REG", this.finalPresetRanges[preset], preset);
      } else {
        this.dateRange[this.reg].date = {
          start: datesObj.start,
          end: datesObj.end
        };

        this.activeMonthStart = this.dateRange[this.reg].date.start.getMonth();
        this.activeYearStart = this.dateRange[
            this.reg
            ].date.start.getFullYear();
        this.activeYearEnd = this.dateRange[this.reg].date.end.getFullYear();
        this.setDateValue("REG");
      }
    },
    liveChartDataToCalendar: function() {
      if (this.liveChartDataToCalendar) {
        this.selectedCalTab = "LIVE";
        this.selectedCal = "LIVE";
        this.displayedCal = "LIVE";
        this.$store.commit("clients/setLiveChartDataToCalendar", false);
      }
    },
    generalChartFilter: function() {
      if (this.generalChartFilter) {
        let filter = this.generalChartFilter.filter.toLowerCase();
        if (
            filter !== "cost" &&
            filter !== "c2c" &&
            filter !== "sms" &&
            filter !== "bn" &&
            filter !== "ni" &&
            filter !== "nr" &&
            this.generalChartFilter.preset
        ) {
          // this.filterFromGeneralChart(this.generalChartFilter);
          if (filter === "reg" || filter === "nu" || filter === "new") {
            this.selectedCalTab = "REG";
            this.reg = "REG";
            this.selectedCal = "REG";
            this.displayedCal = "REGISTRATION";
            this.updatePreset(
                "REG",
                this.finalPresetRanges[this.generalChartFilter.preset],
                this.generalChartFilter.preset
            );
          }

          if (filter === "tr-lv" || filter === "tr-on") {
            this.selectedCalTab = "TRA";
            this.reg = "TRA";
            this.selectedCal = "TRA";
            this.displayedCal = "TRANSFERS";
            this.updatePreset(
                "REG",
                this.finalPresetRanges[this.generalChartFilter.preset],
                this.generalChartFilter.preset
            );
          }

          if (filter === "dp") {
            this.selectedCalTab = "DEP";
            this.reg = "DEP";
            this.selectedCal = "DEP";
            (this.displayedCal = "DEPOSITS"), this.setMainFilterTab("ALL");
            this.updatePreset(
                "REG",
                this.finalPresetRanges[this.generalChartFilter.preset],
                this.generalChartFilter.preset
            );
          }

          if (filter === "rf") {
            this.selectedCalTab = "REF";
            this.reg = "REF";
            this.selectedCal = "REF";
            this.displayedCal = "REFERRALS";
            this.updatePreset(
                "REG",
                this.finalPresetRanges[this.generalChartFilter.preset],
                this.generalChartFilter.preset
            );
          }

          if (filter === "end" || filter === "na") {
            this.selectedCalTab = "LAST_MOD_TAG";
            this.reg = "LAST_MOD_TAG";
            this.selectedCal = "MODT";
            this.displayedCal = "LAST MODIFIED TAG";
            this.updatePreset(
                "REG",
                this.finalPresetRanges[this.generalChartFilter.preset],
                this.generalChartFilter.preset
            );
          }

          if (filter == "ca") {
            this.selectedCalTab = "LAST_MOD_TAG";
            this.reg = "LAST_MOD_TAG";
            this.selectedCal = "MODT";
            this.displayedCal = "LAST MODIFIED TAG";
            this.updatePreset(
                "REG",
                this.finalPresetRanges[this.generalChartFilter.preset],
                this.generalChartFilter.preset
            );
          }

          if (filter == "assm") {
            this.selectedCalTab = "ASSIGN";
            this.reg = "ASSIGN";
            this.selectedCal = "ASSIGN";
            this.displayedCal = "ASSIGNMENTS";
            this.updatePreset(
                "REG",
                this.finalPresetRanges[this.generalChartFilter.preset],
                this.generalChartFilter.preset
            );
          }

          this.$store.commit("clients/setGeneralChartFilter", null);
        }
        if (filter === "reg" || filter === "dup") {
          this.setMainFilterTab(filter.toUpperCase(), true);
        }

        if (
            filter !== "cost" &&
            (filter === "reg" || filter === "dup" || filter === "on")
        ) {
          if (this.reg !== "CA_F" || this.reg !== "CA_P") {
            if (this.CheckUserPermission([1, 2, 3, 4, 5, 12])) {
              this.$store.commit(
                  "clients/setClientsTableSelectedMainTab",
                  "total"
              );
            }
          }
        }
      }
    },
    // clientsTableTab: function() {
    //   if (this.clientsTableTab) {
    //     if (
    //       !this.dateRange[this.reg].date.start &&
    //       !this.dateRange[this.reg].date.end
    //     ) {
    //       if (this.clientsTableTab !== "clients") {
    //         this.selectedCalTab = "GR_ASGN";
    //       }
    //       if (this.clientsTableTab === "clients") {
    //         this.selectedCalTab = "REG";
    //       }
    //     }
    //     this.$store.commit("clients/setClientsTableTab", null);
    //   }
    // },
    clientsTableTab: function(newVal) {
      if (newVal === "bn") {
        this.selectedCalTab = "BN_TAG";
      }
    },
    bnCalendarTrigger: function(newVal) {
      console.log("[BN_CAL] bnCalendarTrigger fired:", newVal);
      if (newVal > 0) {
        this.selectedCalTab = "BN_TAG";
      }
    },
    selectedMainTab() {
      if (this.selectedMainTab !== "users") {
        this.userSelectShiftPopup = false;
      }
    },
    selectedTab() {
    },
    selectedCal() {
      this.$store.commit("clients/setSelectedCalendar", this.selectedCal);
    },
    startNextActiveMonth: function(value) {
      if (value === 0) this.activeYearEnd = this.activeYearStart + 1;
    },

    // resetCalendars: function() {
    //   if (!this.resetCalendars) {
    //     this.resetCalendar = false;
    //     this.rstRegTable = false;
    //     this.rstRegCal = false;
    //     this.rstCaCal = false;
    //     this.rstDepCal = false;
    //     this.rstTransCal = false;
    //     this.rstModCal = false;
    //     this.rstModTagCal = false;
    //     this.rstSupportCal = false;
    //     this.rstAssignCal = false;
    //     this.rstRefCal = false;
    //   }
    //   if (this.resetCalendars) {
    //     this.resetAllCalendars();
    //     this.resetCalendar = true;
    //     this.rstRegTable = true;
    //     this.rstRegCal = true;
    //     this.rstCaCal = true;
    //     this.rstDepCal = true;
    //     this.rstTransCal = true;
    //     this.rstModCal = true;
    //     this.rstModTagCal = true;
    //     this.rstSupportCal = true;
    //     this.rstAssignCal = true;
    //     this.rstRefCal = true;
    //     // this.dateRange[this.reg] = {
    //     //   date: {
    //     //     start: null,
    //     //     end: null
    //     //   }
    //     // };
    //   }
    //   this.selectedRegPreset = null;
    // },

    selectedMainCalendar: function(val) {
      const selectedCal = val;
      if (selectedCal.includes("DEP")) {
        this.selectedCalTab = "DEP";
        this.reg = "DEP";
        this.selectedCal = "DEP";
        this.displayedCal = "DEPOSITS";
        this.updatePreset(
            "DEP",
            this.finalPresetRanges["last180days"],
            "last180days"
        );
      }

      // if (selectedCal.includes("ASSIGN")) {
      //   this.selectedCalTab = "ASSIGN";
      //   this.reg = "ASSIGN";
      // }

      if (selectedCal.includes("REG")) {
        this.selectedCalTab = "REG";
        this.reg = "REG";
      }
    },

    selectedCalTab: function() {
      this.waveEffect();
      let tab = this.calTabs.filter(tab => tab.alias === this.selectedCalTab);
      if (tab.length > 0) {
        this.wrapperBrColor = tab[0].color;
        if (tab[0].alias === "GR_ASGN") {
          this.wrapperBrColor = this.innerBrColor;
        }
        this.selectedCal = tab[0].short;
        this.displayedCal = tab[0].name;
      }

      if (this.selectedCalTab === "DEP") {
        this.reg = "DEP";
        //this.setMainFilterTab('ALL');
        apiClientCreator.cancel();
        this.fetchDepositsStats(this.reg);
        //return this.fetchTableData();
      }
      if (this.selectedCalTab === "REF") {
        this.reg = "REF";
        apiClientCreator.cancel();
        this.fetchReferralStats(this.reg);
        //return this.fetchTableData();
      }

      if (this.selectedCalTab === "ASSIGN") {
        this.reg = "ASSIGN";
        apiClientCreator.cancel();
        this.fetchAssignStats(this.reg);
        // this.fetchCaStats();
        //return this.fetchTableData();
      }

      if (this.selectedCalTab === "TRA") {
        this.reg = "TRA";
        apiClientCreator.cancel();
        this.fetchTransfersStats(this.reg);
        //return this.fetchTableData();
      }

      if (this.selectedCalTab === "CA_F") {
        this.reg = "CA_F";
        if (!this.openCaComponent.fromTable) {
          let tempObject = this.openCaComponent;
          tempObject.fromTable = false;
          tempObject.ifOpen = true;
          this.$store.commit("clients/setOpenCaComponent", tempObject);
        }
        apiClientCreator.cancel();
        this.fetchCaStats(this.reg);
      }
      if (this.selectedCalTab === "CA_P") {
        this.reg = "CA_P";
        apiClientCreator.cancel();
        this.fetchCaPastStats(this.reg);
      }
      if (this.selectedCalTab === "LAST_MOD") {
        this.reg = "LAST_MOD";
        apiClientCreator.cancel();
        this.fetchLastModStats(this.reg);
        //return this.fetchTableData("LAST_MOD");
      }

      if (this.selectedCalTab === "REG") {
        this.reg = "REG";
        this.fetchRegCalendar(this.reg);
        //return this.fetchTableData();
      }
      if (this.selectedCalTab === "SUP") {
        this.reg = "SUP";
        apiClientCreator.cancel();
        this.fetchSupportStats(this.reg);
      }
      if (this.selectedCalTab === "LEAD_TAG") {
        this.reg = "LEAD_TAG";
        this.fetchLeadTagStats(this.reg);
      }
      if (this.selectedCalTab === "GR_ASGN") {
        this.reg = "GR_ASGN";
        this.fetchGroupTagStats(this.reg);
      }
      if (this.selectedCalTab === "NA_TAG") {
        this.reg = "NA_TAG";
        this.fetchNaTagStats(this.reg);
      }
      if (this.selectedCalTab === "BN_TAG") {
        this.reg = "BN_TAG";
        if (!this.dateRange.BN_TAG.date.start) {
          this.updatePreset("BN_TAG", this.finalPresetRanges["MONTH"], "MONTH");
        }
        this.fetchBnTagStats("BN_TAG");
      }
      if (this.selectedCalTab === "LAST_MOD_TAG") {
        this.reg = "LAST_MOD_TAG";
        apiClientCreator.cancel();
        //this.fetchLastModStats();
      }

      if (this.selectedCalTab === "LIVE") {
        this.setMainFilterTab(this.liveDataFilter);
        this.reg = "LIVE";
        apiClientCreator.cancel();
      }
      if (this.selectedCalTab === "SHIFTS") {
        //this.setMainFilterTab(this.liveDataFilter);
        this.reg = "SHIFTS";
        apiClientCreator.cancel();
      }

      if (
          this.dateRange[this.reg].date.start &&
          this.dateRange[this.reg].date.end
      ) {
        if (this.reg === "CA_F" || this.reg === "CA_P") {
          this.$store.commit(
              "clients/setClientsTableSelectedMainTab",
              "clients"
          );
        }
        this.activeMonthStart = this.dateRange[this.reg].date.start.getMonth();
        this.activeYearStart = this.dateRange[
            this.reg
            ].date.start.getFullYear();
        this.activeYearEnd = this.dateRange[this.reg].date.end.getFullYear();
      }
    },

    queryObject: function() {
      //this.queryObject.fetchAll = this.fetchAll;
      // TODO: was queryObject
      if (this.selectedCalTab === "DEP") {
        this.reg = "DEP";
        apiClientCreator.cancel();
        return this.fetchDepositsStats(this.reg);
      }
      if (this.selectedCalTab === "REF") {
        this.reg = "REF";
        apiClientCreator.cancel();
        return this.fetchReferralStats(this.reg);
      }
      if (this.selectedCalTab === "ASSIGN") {
        this.reg = "ASSIGN";
        apiClientCreator.cancel();
        return this.fetchAssignStats(this.reg);
      }
      if (this.selectedCalTab === "TRA") {
        this.reg = "TRA";
        apiClientCreator.cancel();
        return this.fetchTransfersStats(this.reg);
      }
      if (this.selectedCalTab === "CA_F") {
        this.reg = "CA_F";
        apiClientCreator.cancel();
        return this.fetchCaStats(this.reg);
      }
      if (this.selectedCalTab === "CA_P") {
        this.reg = "CA_P";
        apiClientCreator.cancel();
        return this.fetchCaPastStats(this.reg);
      }
      if (this.selectedCalTab === "LAST_MOD") {
        this.reg = "LAST_MOD";
        return this.fetchLastModStats(this.reg);
      }
      if (this.selectedCalTab === "REG") {
        this.reg = "REG";
        this.fetchRegCalendar(this.reg);
      }
      if (this.selectedCalTab === "SUP") {
        this.reg = "SUP";
        return this.fetchSupportStats(this.reg);
      }
      if (this.selectedCalTab === "LAST_MOD_TAG") {
        this.reg = "LAST_MOD_TAG";
        //this.fetchLastModStats(this.reg);
      }
      if (this.selectedCalTab === "LEAD_TAG") {
        this.reg = "LEAD_TAG";
        this.fetchLeadTagStats(this.reg);
      }
      if (this.selectedCalTab === "GR_ASGN") {
        this.reg = "GR_ASGN";
        this.fetchGroupTagStats(this.reg);
      }
      if (this.selectedCalTab === "NA_TAG") {
        this.reg = "NA_TAG";
        this.fetchNaTagStats(this.reg);
      }
      if (this.selectedCalTab === "BN_TAG") {
        this.reg = "BN_TAG";
        if (!this.dateRange.BN_TAG.date.start) {
          this.updatePreset("BN_TAG", this.finalPresetRanges["MONTH"], "MONTH");
        }
        this.fetchBnTagStats("BN_TAG");
      }
      // if (this.selectedCalTab === "SHIFTS") {
      //   this.reg = "SHIFTS";
      //   this.fetchShiftsStats(this.reg);
      // }
      if (
          this.selectedRegPreset === null ||
          this.selectedRegPreset === undefined
      ) {
        //this.fetchTableData();
      }
    },

    loading: function() {
      if (!this.loading) {
        if (
            this.requestRegCalDaysBusy ||
            this.requestSupportCalDaysBusy ||
            this.requestDepCalDaysBusy ||
            this.requestRefCalDaysBusy ||
            this.requestAssignCalBusy ||
            this.requestTransCalDaysBusy ||
            this.requestCaCalDaysBusy ||
            this.requestLastModCalDaysBusy
        ) {
          this.$store.commit("clients/setLoading", true);
        } else {
          this.$store.commit("clients/setLoading", false);
        }
      }
    },

    clientsTableSelectedMainTab: function() {
      switch (this.clientsTableSelectedMainTab) {
        case "clients":
          this.innerBrColor = "#1bc51b";
          this.wrapperBrColor = this.innerBrColor;
          break;
        case "na":
          // this.innerBrColor = '#F4511E';
          this.innerBrColor = "#c9302c";
          this.wrapperBrColor = this.innerBrColor;
          break;
        case "ni":
          // this.innerBrColor = '#000000';
          this.innerBrColor = "#c1bdbd";
          this.wrapperBrColor = this.innerBrColor;
          break;
        case "bn":
          this.innerBrColor = "#000000";
          this.wrapperBrColor = this.innerBrColor;
          break;
        case "t4":
          this.innerBrColor = "#003b60";
          this.wrapperBrColor = this.innerBrColor;
          break;
        case "ended":
          // this.innerBrColor = '#390072';
          this.innerBrColor = "#008b00";
          this.wrapperBrColor = this.innerBrColor;
          break;
        case "merged":
          this.innerBrColor = "#777";
          this.wrapperBrColor = this.innerBrColor;
          break;
        case "newLd":
          this.innerBrColor = "#2ba3cf";
          break;
        case "total":
          this.innerBrColor = "#f1f1f1";
          // this.wrapperBrColor = this.innerBrColor;

          break;
      }
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [
      "filterDepTimeFrame",
      "selectedMainCalendar",
      "clientsTableTab",
      "generalChartFilter",
      "liveChartDataToCalendar",
      "mainCalendarDates",
      "loading",
      "liveDataFilter",
      "mainTabsList",
      "clientsTableSelectedMainTab",
      "openCaComponent",
      "selectedCalendarType",
      "requestForDate",
      "calendarDates",
      "resetCalendar",
      "showReset",
      "calNameForCountries",
      "clientsTableSelectedMainTab"
    ]),
    ...mapState("main", ["showVikiMsg"]),
    monthsLocale: function() {
      return this.months || availableMonths[this.i18n];
    },
    shortDaysLocale: function() {
      return this.shortDays || availableShortDays[this.i18n];
    },
    s: function() {
      return Object.assign({}, defaultStyle, this.style);
    },
    startMonthDay: function() {
      return new Date(
          Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
      ).getDay();
    },
    startNextMonthDay: function() {
      return new Date(
          Date.UTC(this.activeYearStart, this.startNextActiveMonth, 1)
      ).getDay();
    },
    endMonthDate: function() {
      return new Date(
          Date.UTC(this.activeYearEnd, this.startNextActiveMonth, 0)
      ).getDate();
    },

    futureMonthDate: function() {
      return new Date(
          Date.UTC(this.activeYearEnd, this.startNextActiveMonth, 0)
      ).getDate();
    },
    endNextMonthDate: function() {
      return new Date(
          Date.UTC(this.activeYearEnd, this.activeMonthStart + 2, 0)
      ).getDate();
    },
    startNextActiveMonth: function() {
      return this.activeMonthStart >= 11 ? 0 : this.activeMonthStart + 1;
    },
    finalPresetRanges: function() {
      const tmp = {};
      const presets = this.presetRanges || this.defaultPresets(this.i18n);
      for (const i in presets) {
        const item = presets[i];
        let plainItem = item;
        if (typeof item === "function") {
          plainItem = item();
        }
        tmp[i] = plainItem;
      }
      return tmp;
    },
    isRighttoLeft: function() {
      return this.righttoleft === "true";
    },
    isCompact: function() {
      return this.compact === "true";
    },
    innerCssVars() {
      // if (!this.checkIfCalendarSelected() && this.checkIfTotalMode()) {
      //   return { "--br-color": "grey" };
      // } else if (
      //   this.displayedCal === "DEPOSITS" ||
      //   this.displayedCal === "LEAD TAG"
      // ) {
      //   return { "--br-color": "grey" };
      // }

      // else if(this.selectedMainTab === 'total'){
      //   return { "--br-color": "#efefef" };
      // }
      // else {
      return {
        "--br-color": this.innerBrColor
      };
      // }
    },
    wrapperCssVars() {
      return {
        "--br-color":
            this.selectedTab === "GR_ASGN"
                ? this.innerBrColor
                : this.wrapperBrColor
      };
    }

  },
  created() {
    this.returnYearsList();
    if (this.activeMonthStart < 6) {
      this.monthPaginate = 0;
    } else {
      this.monthPaginate = 1;
    }

    this.msgSocket.on("receiveAllNotifics", notifics => {
      this.congratedUserIds = notifics.map(notify => {
        if (notify.type === "RECEIVE_CONGRATS_BDAY") return notify.to_user_id;
      });
    });

  },

  mounted() {
    //this.checkIfNeedToApproveCalls();
    // $('#approveCallsModal').modal('show')
    //this.blinkCaDays(15,15)
    $(".dropdown-menu.ul-hours").click(e => {
      if (this.selectedHours[this.reg].to === null) {
        e.stopPropagation();
      }
    });
    // $(".dropdown").on("show.bs.dropdown", event => {
    //   this.ifShowAdd = true;
    // });
    // $(".dropdown").on("hide.bs.dropdown", event => {
    //   this.ifShowAdd = false;
    // });
    $(".calendars-dropdown").on("show.bs.dropdown", event => {
      this.ifShowAdd = true;
    });
    $(".calendars-dropdown").on("hide.bs.dropdown", event => {
      this.ifShowAdd = false;
    });
    apiClientCreator(`client/stats/calendar/birth_days`)
        .get("", {})
        .then(res => {
          this.birthDaysStats = res.data;
        })
        .catch(err => {
        });
    apiClientCreator(`client/stats/calendar/economic_events`)
        .get("", {})
        .then(res => {
          this.economicEventsStats = res.data.reverse();
        })
        .catch(err => {
        });
    if (!this.checkPermissions(this.auth, [1, 2, 3, 4, 5, 6, 8, 12])) {
      this.selectedTopFilter = "ALL";
      this.filterPresets = this.filterPresets.filter(item => item.id === 3);
    }
    this.yearsList = this.getYearsList();

    if (moment().format("H") > 11) {
      this.hoursPaginate = 1;
    }

    this.shiftsSelectionDate = moment().add(1, 'week').startOf('isoWeek').format('YYYY-MM-DD')
    this.checkIfUserShifts();
    this.checkIfNeedToFillShifts();
    this.fetchUsersShifts();
    this.getShiftsToCalendar();
    this.getAllNotifics();
    if (this.$route.name === "Users") {
      this.reg = "SHIFTS";
      this.selectedCalTab = "SHIFTS";
      this.selectedCal = "SHIFTS";
      this.displayedCal = "SHIFTS";
    }
  },

  methods: {
    checkIfAllMyShiftsApproved(){
      if(this.dateRangesStats['SHIFTS'].length > 0){
        return this.dateRangesStats['SHIFTS'].every(item => item.approved === 1)
      }else{
        return false;
      }
    },
    checkIfCongrated(userId) {
      if (this.congratedUserIds.find(id => id === userId)) return false;
      // if(this.auth.user.id===userId) return false // Current user can't congrate himself -> Ask roman
      return true;
    },
    onSayCongrats(toUser) {
      const fromUser = this.auth.user;
      const message = `Congratulations \n ${toUser.first_name} from ${fromUser.first_name}`;
      this.msgSocket.emit("bday_congrats", {
        fromUser,
        toUser,
        message,
        approved: "APPROVED",
        type: "RECEIVE_CONGRATS_BDAY",
        tag: "none"
      });
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: `You Sent Congratulations \n to ${toUser.first_name}`,
        type: "SENT_CONGRATE_BDAY",
      });
      this.msgSocket.emit("get_all_notifics", fromUser.id);

    },
    getAllNotifics() {
      const { id } = this.auth.user;
      this.msgSocket.emit("get_all_notifics", id);
    },
    sendCallsApproving(day) {
      apiClientCreator(`users/scheduled_calls/approve_sc`)
          .post("", { day: day })
          .then(res => {
          });
    },
    async approveCalls() {
      if (
          this.approvedCalls.includes("today") &&
          !this.approvedCalls.includes("tomorrow")
      ) {
        await this.sendCallsApproving(2);
        this.approvedCalls.push("tomorrow");

        $("#approveCallsModal").modal("hide");
        // this.checkIfNeedToApproveTasks();
        this.showApprModal = false;
      } else if (!this.approvedCalls.includes("today")) {
        await this.sendCallsApproving(1);
        this.approvedCalls.push("today");
        // this.modalKey +=1
        // $('#approveCallsModal').modal('hide')
        // $('#approveCallsModal').modal('show')
      }
    },
    async approveTasks() {
      apiClientCreator(`tasks/users/approve_tasks`)
          .post("")
          .then(res => {
            $("#approveTasksModal").modal("hide");
          });
    },
    getCurrentDate(days) {
      return moment()
          .add(days, "days")
          .format("YYYY-MM-DD");
    },
    saveCostumeShiftChoice(r, i) {
      this.shiftOverviewWeek = r;
      const result = this.getDayIndexInMonth(r, i, this.startMonthDay);
      const resultDate = new Date(
          Date.UTC(this.activeYearStart, this.activeMonthStart, result)
      );

      let getShiftList = apiClientCreator(`shifts/save_user_choice/7`);
      getShiftList
          .post("", {
            choice_date: resultDate,
            week: r,
            custom: this.costumeShift
          })
          .then(res => {
            this.checkUserShifts();
            this.fetchUsersShifts();
            this.getShiftsToCalendar();
            this.userSelectShiftPopup = false;
            this.openCostumeShiftWindow = false;
          });
    },
    cancelAndReChoose() {
      this.shiftOverviewWeek = null;
    },
    confirmMyShifts() {
      this.shiftOverviewWeek = null;
      this.userFilledAllShifts = true;
      //this.$router.push({ name: "Main" });
      //this.$emit("change_selected_main_tab", "clients");
    },
    // Function checks if user approved today and tomorrow calls
    checkIfNeedToApproveCalls() {
      apiClientCreator(`users/scheduled_calls/check_sc_approve`)
          .get("")
          .then(res => {
            if (res.data === "NOT_APPROVED") {
              this.showApprModal = true;
              $("#approveCallsModal").modal("show");

              // need to trigger modal
            } else if (res.data === "APPROVED") {
              // continue
              // this.checkIfNeedToApproveTasks();
            }
          });
    },
    checkIfNeedToApproveTasks() {
      apiClientCreator(`tasks/users/check_tasks_approve`)
          .get("")
          .then(res => {
            if (res.data === "NOT_APPROVED") {
              // this.showApprModal = true;
              $("#approveTasksModal").modal("show");

              // need to trigger modal
            } else if (res.data === "APPROVED") {
              // continue
              // $("#approveTasksModal").modal("show");
            }
          });
    },

    // Function checks if user has selected his shifts for a week
    checkIfUserShifts() {
      if (this.CheckUserPermission([2, 4, 6, 7])) {
        apiClientCreator(`shifts/get_current_week_shifts_by_user`)
          .get("")
          .then(res => {
            if (res.data.length > 1) {
            // if (res.data.length === 0) {
              this.checkIfNeedToApproveCalls();
            } else {
              // here need to trigger Gabi`s function to set user shifts
            }
          });
      } else {
        if (this.CheckUserPermission([1, 2, 3, 4, 6])) {
          //TODO: LEV: NEED TO ADD LOGIC THAT WILL CHECK IF LOGGED-IN USER HAS TASKS TO POPUP THE APPROVAL WINDOW - TO ALL ROLES NO MATTER WHAT ROLE AND REMOVE THIS TEMP PERMISSION LOGC
          // this.checkIfNeedToApproveTasks();
        }
      }
    },
    checkIfNeedToFillShifts() {
      this.checkUserShifts();
      let roles = [4, 5, 6, 7, 8, 12];
      if (roles.includes(this.auth.user.role)) {
        let wednesday = moment().isoWeekday() === 3;
        let thursday = moment().isoWeekday() === 4;
        let sunday = moment().isoWeekday() === 7;
        if (wednesday && this.auth.user.seniority > 1) {
          apiClientCreator(
              `client/stats/multiselect/deposits/users/?deposit_at_from=${moment()
                  .subtract(30, "days")
                  .format("YYYY-MM-DD")}&deposit_at_to=${moment().format(
                  "YYYY-MM-DD"
              )}&deposit_clients=1&hash=${Math.floor(Math.random() * 10000) + 1}`
          )
              .get("")
              .then(res => {
                let usersArray = [];
                let topThree = [];
                res.data.forEach(user => {
                  let u = {
                    id: user.id,
                    count: user.count[0]
                  };
                  usersArray.push(u);
                });

                let a = usersArray.sort((a, b) => (a.count < b.count ? 1 : -1));
                if (a.length > 3) {
                  let three = a.slice(0, 3);
                  topThree = three.map(i => i.id);
                }
                let roles = [4, 5, 6, 7, 8, 12];
                if (
                    roles.includes(this.auth.user.role) &&
                    topThree.includes(this.auth.user.id)
                ) {
                  this.checkUserShifts();
                }
              });
        }

        if (thursday) {
          apiClientCreator(
              `client/stats/multiselect/deposits/users/?deposit_at_from=${moment()
                  .subtract(30, "days")
                  .format("YYYY-MM-DD")}&deposit_at_to=${moment()
                  .subtract("2", "days")
                  .format("YYYY-MM-DD")}&deposit_clients=1&hash=${Math.floor(
                  Math.random() * 10000
              ) + 1}`
          )
              .get("")
              .then(res => {
                let usersArray = [];
                let topThree = [];
                res.data.forEach(user => {
                  let u = {
                    id: user.id,
                    count: user.count[0]
                  };
                  usersArray.push(u);
                });

                let a = usersArray.sort((a, b) => (a.count < b.count ? 1 : -1));
                if (a.length > 3) {
                  let three = a.slice(0, 3);
                  topThree = three.map(i => i.id);
                }
                let roles = [4, 5, 6, 7, 8, 12];
                if (
                    roles.includes(this.auth.user.role) &&
                    !topThree.includes(this.auth.user.id)
                ) {
                  this.checkUserShifts();
                  this.checkIfFilledPrevWeek();
                }
              });
        }
      }
    },

    checkIfShiftApproved(r, i) {
      const result = this.getDayIndexInMonth(r, i, this.startMonthDay);
      const resultDate = new Date(Date.UTC(this.activeYearStart, this.activeMonthStart, result));
      let y = false;
      if (this.dateRangesStats["SHIFTS"].length > 0) {
        this.dateRangesStats["SHIFTS"].forEach(s => {
          if (s.approved === 1 && moment(s.date).format('YYYY-MM-DD') === moment(resultDate).format('YYYY-MM-DD')) {
            y = true;
          }
        });
      }
      return y;
    },

    checkUserShifts() {

      apiClientCreator(`shifts/user_shifts/${this.auth.user.id}`)
          .get("")
          .then(res => {
            let days = [
              { id: 2, name: "Monday" },
              { id: 3, name: "Tuesday" },
              { id: 4, name: "Wednesday" },
              { id: 5, name: "Thursday" },
              { id: 6, name: "Friday" }
            ];
            let userChoicesDays = [
              ...new Set(res.data.map(c => c.choice_day_number))
            ];

            days.forEach((n, i) => {
              let yon = userChoicesDays.includes(n.id);
              if (yon === false) {
                this.$store.commit("clients/setLoading", true);
                this.$store.commit("main/setShowVikiMsg", {
                  show: true,
                  msg: `Select shift for next ${n.name}`,
                  type: "ERROR",
                  op: { type: "SYSTEM" }
                });
                this.$store.commit("clients/setLoading", false);
                if (this.selectedMainTab !== "users") {
                  this.$router.push({ name: "Users" });
                }
                //this.$emit("change_selected_main_tab", "users");
              }
              if (
                  yon === true &&
                  userChoicesDays.length === days.length &&
                  i === 4
              ) {
                this.userHoverShiftPopup = false;

                let a = [];

                res.data.forEach(c => {
                  let day;
                  switch (c.choice_day_number) {
                    case 2:
                      day = "Monday";
                      break;
                    case 3:
                      day = "Tuesday";
                      break;
                    case 4:
                      day = "Wednesday";
                      break;
                    case 5:
                      day = "Thursday";
                      break;
                    case 6:
                      day = "Friday";
                      break;
                  }
                  let o = {
                    day_name: day,
                    shift_name: c.choice_name
                  };
                  a.push(o);
                });
                this.overviewShifts = a;
                this.userFilledAllShifts = true;
              }
            });
          });
    },
    checkForRequestDate(type) {
      return (
          (type === "hour" &&
              this.requestForDate.calendar === this.reg &&
              !this.requestForDate.time) ||
          (type === "date" &&
              this.requestForDate.calendar === this.reg &&
              !this.requestForDate.date)
      );
    },
    checkForActiveWeek(week) {
      if (
          !this.dateRange[this.reg].date.start ||
          !this.dateRange[this.reg].date.end
      ) {
        return false;
      }
      let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
      let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
      if (week_start < 1) {
        week_start = 1;
      }

      let dateStart = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
      );
      let dateEnd = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
      );

      let monthObj = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
      );

      if (dateEnd.isAfter(monthObj.endOf("month"))) {
        dateEnd = monthObj.endOf("month");
      }
      return (
          dateStart.format("YYYY-MM-DD") ===
          moment(this.dateRange[this.reg].date.start).format("YYYY-MM-DD") &&
          dateEnd.format("YYYY-MM-DD") ===
          moment(this.dateRange[this.reg].date.end).format("YYYY-MM-DD")
      );
    },
    checkForActiveWeekCompare(week) {
      if (
          !this.dateRange[this.reg].secondDate.start ||
          !this.dateRange[this.reg].secondDate.end
      ) {
        return false;
      }
      let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
      let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
      if (week_start < 1) {
        week_start = 1;
      }

      let dateStart = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
      );
      let dateEnd = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
      );

      let monthObj = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
      );

      if (dateEnd.isAfter(monthObj.endOf("month"))) {
        dateEnd = monthObj.endOf("month");
      }

      return (
          dateStart.format("YYYY-MM-DD") ===
          moment(this.dateRange[this.reg].secondDate.start).format(
              "YYYY-MM-DD"
          ) &&
          dateEnd.format("YYYY-MM-DD") ===
          moment(this.dateRange[this.reg].secondDate.end).format("YYYY-MM-DD")
      );
    },
    checkForSelectingWeek(week) {
      let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
      let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
      if (week_start < 1) {
        week_start = 1;
      }

      let dateStart = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
      );
      let dateEnd = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
      );
      let monthObj = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
      );

      // if (dateEnd.isAfter(monthObj.endOf("month"))) {
      //   dateEnd = monthObj.endOf("month");
      // }

      return (
          this.dateRange[this.reg].date.start &&
          this.dateRange[this.reg].date.end &&
          moment(moment(this.dateRange[this.reg].date.end)).diff(
              moment(this.dateRange[this.reg].date.start),
              "days"
          ) === moment(dateEnd).diff(dateStart, "days")
      );
    },

    checkBoundaries(cond, type) {
      if (
          this.dateRange[this.reg].date.start &&
          this.dateRange[this.reg].date.end
      ) {
        let date = moment(
            `${this.activeYearStart}.${this.activeMonthStart + 1}`
        );
        //let timeType = type === 'Y' ? this.activeYearStart :this.activeMonthStart+1

        let formattedDate = date.format("Y-M");
        if (type === "Y") {
          if (
              moment(this.dateRange[this.reg].date.end).format(type) ==
              this.activeYearStart
          ) {
            return false;
          }
        }
        if (
            moment(this.dateRange[this.reg].date.end).format("Y-M") ==
            formattedDate
        ) {
          return false;
        }

        if (cond === ">") {
          return (
              moment(this.dateRange[this.reg].date.start).isAfter(date) ||
              moment(this.dateRange[this.reg].date.end).isAfter(date)
          );
        }
        if (cond === "<") {
          return (
              moment(date).isAfter(this.dateRange[this.reg].date.end) ||
              moment(date).isAfter(this.dateRange[this.reg].date.start)
          );
        }
      }

      return false;
    },
    selectWeek(week) {
      this.resetOneCalendar(this.reg);
      let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
      let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
      if (week_start < 1) {
        week_start = 1;
      }

      let dateStart = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
      );
      let dateEnd = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
      );

      let monthObj = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
      );

      // if (dateEnd.isAfter(monthObj.endOf("month"))) {
      //   dateEnd = monthObj.endOf("month");
      // }
      this.dateRange[this.reg].date.start = dateStart.toDate();
      this.dateRange[this.reg].date.end = dateEnd.toDate();
      this.setDateValue();
    },
    selectWeekForCompare(week) {
      this.resetSecondDate(this.reg);
      let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
      let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
      if (week_start < 1) {
        week_start = 1;
      }

      let dateStart = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
      );
      let dateEnd = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
      );

      let monthObj = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
      );
      //
      // if (dateEnd.isAfter(monthObj.endOf("month"))) {
      //   dateEnd = monthObj.endOf("month");
      // }

      this.dateRange[this.reg].secondDate.start = dateStart.toDate();
      this.dateRange[this.reg].secondDate.end = dateEnd.toDate();
      this.setDateValue();
    },
    checkForFutureWeek(week) {
      let month = this.activeMonthStart + 1;
      let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);

      let dateOfWeek = new Date(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
      );

      return moment(
          moment(this.activeYearStart + "-" + month)
              .endOf("month")
              .toDate()
      ).isAfter(moment(dateOfWeek).subtract(1,'days')) &&
          week_start != 32
    },
    getDatesForWeek(week) {
      let week_start = this.getDayIndexInMonth(week, 1, this.startMonthDay);
      let week_end = this.getDayIndexInMonth(week, 7, this.startMonthDay);
      if (week_start < 1) {
        week_start = 1;
      }

      let dateStart = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_start)
      );
      let dateEnd = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, week_end)
      );

      let monthObj = moment(
          Date.UTC(this.activeYearStart, this.activeMonthStart, 1)
      );

      // if (dateEnd.isAfter(monthObj.endOf("month"))) {
      //   dateEnd = monthObj.endOf("month");
      // }

      return {
        start: dateStart.format("DD/MM"),
        end: dateEnd.format("DD/MM")
      };
    },
    checkDateFromTag(date) {
      return (
          (this.requestForDate.date === date ||
              this.requestForDate.time === date) &&
          this.requestForDate.calendar === this.reg
      );
    },
    checkForDatePickForTag() {
      let mainObj = Object.assign({}, this.requestForDate);
      if (mainObj.direction === "FROM_TAG" && mainObj.calendar === this.reg) {
        return true;
      }
      return false;
    },
    sendDateToTag(date, time) {
      let mainObj = Object.assign({}, this.requestForDate);
      if (date) {
        mainObj.date = date;
      }
      if (time) {
        moment(time.toString(), "LTS").format("HH:mm:ss");
        mainObj.time = time;
      }
      if (mainObj.time && mainObj.date) {
        mainObj.direction = "FROM_CAL";
      }
      this.$store.commit("clients/setRequestForDate", mainObj);
    },
    truncateScoped(input) {
      if (input.length > 5) {
        return input.substring(0, 5);
      }
      return input;
    },
    getGroupColor(style) {
      this.groupColor = style.class;
      this.selectedMainGroup = style.tabName;
      this.wrapperBrColor = this.innerBrColor;
    },
    openCAPopup(date) {
      this.$store.commit("clients/setOpenCaComponentOtherDay", {
        // date: moment().format("YYYY-MM-DD"),
        date: date
      });
    },
    daysBgMethod(stat, stat_total) {
      if (stat === "" || stat === undefined || stat === 0) {
        return;
      }

      let below = "rgba(253,29,29,1)";
      let above = "rgba(0,195,43,1)";

      let color_top = "#fff";
      let color_bottom = "#fff";

      let perc_bottom = "30%";
      let perc_top = "40%";

      if (
          this.dateRangesStats.hasOwnProperty(this.reg) &&
          this.dateRangesStats[this.reg].hasOwnProperty("initial_dates")
      ) {
        perc_bottom = "40%";
        perc_top = "53%";
      }

      if (stat > this.countSumAvgReg().avg) {
        color_top = above;
      }
      if (stat < this.countSumAvgReg().avg) {
        color_top = below;
      }
      if (stat === this.countSumAvgReg().avg) {
        color_top = "#c2d6ff";
      }
      if (stat === 0) {
        color_top = "";
      }

      if (stat_total > this.countSumAvgReg().avg_total) {
        color_bottom = above;
      }
      if (stat_total < this.countSumAvgReg().avg_total) {
        color_bottom = below;
      }
      if (stat_total === this.countSumAvgReg().avg_total) {
        color_bottom = "#c2d6ff";
      }
      if (stat_total === 0) {
        color_bottom = "";
      }
      return `linear-gradient(0deg, ${color_bottom} ${perc_bottom}, ${color_top} ${perc_top})`;
    },
    tabPagination(e, direction, selectedCal, tabList) {
      e.stopPropagation();
      let index = tabList.findIndex(item => item.short === selectedCal);
      if (direction === "left") {
        index -= 1;
      }
      if (direction === "right") {
        index += 1;
      }
      this.callTabPaginationIndex = index;
      this.selectedCalTab = tabList[index].alias;
      this.selectedCal = tabList[index].short;
      this.displayedCal = tabList[index].name;
    },
    checkAvgStat(stat, option) {
      if (stat === 0 || stat === "") {
        return false;
      }
      if (stat > this.countSumAvgReg().avg && option === "above") {
        return true;
      }
      if (stat < this.countSumAvgReg().avg && option === "below") {
        return true;
      }
      if (stat === this.countSumAvgReg().avg && option === "same") {
        return true;
      }
    },

    shouldPresentPopUp(day, week) {
      let days = (week - 1) * 7 + day;
      let month = this.activeMonthStart + 1;
      let date = moment(this.activeYearStart + "-" + month + "-" + days).format(
          "YYYY-MM-DD"
      );
      let currentDate = moment().format("YYYY-MM-DD");
      return date >= currentDate;
    },
    checkPopUpDate(day, week) {
      let checkedDate = this.formatCADate(
          this.getDayCell(week, day, this.startMonthDay, this.endMonthDate),
          this.monthsLocale[this.activeMonthStart]
      );
      let badDate1 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month");
      let badDate2 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(1, "days");
      let badDate3 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(2, "days");
      let badDate4 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(3, "days");
      let badDate5 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(4, "days");
      let badDate6 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(5, "days");
      let badDate7 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(6, "days");
      let badDate8 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(7, "days");
      let badDate9 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(8, "days");
      let badDate10 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(9, "days");
      let badDate11 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(10, "days");
      let badDate12 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(11, "days");
      let badDate13 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(12, "days");
      let badDate14 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(13, "days");
      let badDate15 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(14, "days");
      let badDate16 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .endOf("month")
          .subtract(15, "days");

      return (
          checkedDate === badDate1.format("YYYY-MM-DD") ||
          checkedDate === badDate2.format("YYYY-MM-DD") ||
          checkedDate === badDate3.format("YYYY-MM-DD") ||
          checkedDate === badDate4.format("YYYY-MM-DD") ||
          checkedDate === badDate5.format("YYYY-MM-DD") ||
          checkedDate === badDate6.format("YYYY-MM-DD") ||
          checkedDate === badDate7.format("YYYY-MM-DD") ||
          checkedDate === badDate8.format("YYYY-MM-DD") ||
          checkedDate === badDate9.format("YYYY-MM-DD") ||
          checkedDate === badDate10.format("YYYY-MM-DD") ||
          checkedDate === badDate11.format("YYYY-MM-DD") ||
          checkedDate === badDate12.format("YYYY-MM-DD") ||
          checkedDate === badDate13.format("YYYY-MM-DD") ||
          checkedDate === badDate14.format("YYYY-MM-DD") ||
          checkedDate === badDate15.format("YYYY-MM-DD") ||
          checkedDate === badDate16.format("YYYY-MM-DD")
      );
    },
    checkPopUpDateLeft(day, week) {
      let checkedDate = this.formatCADate(
          this.getDayCell(week, day, this.startMonthDay, this.endMonthDate),
          this.monthsLocale[this.activeMonthStart]
      );
      let badDate1 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .startOf("month");
      let badDate2 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .startOf("month")
          .add(1, "days");
      let badDate3 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .startOf("month")
          .add(2, "days");
      let badDate4 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .startOf("month")
          .add(3, "days");
      let badDate5 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .startOf("month")
          .add(4, "days");
      let badDate6 = moment()
          .set({ year: this.activeYearStart, month: this.activeMonthStart })
          .startOf("month")
          .add(5, "days");

      return (
          checkedDate === badDate1.format("YYYY-MM-DD") ||
          checkedDate === badDate2.format("YYYY-MM-DD") ||
          checkedDate === badDate3.format("YYYY-MM-DD") ||
          checkedDate === badDate4.format("YYYY-MM-DD") ||
          checkedDate === badDate5.format("YYYY-MM-DD") ||
          checkedDate === badDate6.format("YYYY-MM-DD")
      );
    },
    getValueForMoveDepositPopup(day, week) {
      let checkedDate = this.formatCADate(
          this.getDayCell(week, day, this.startMonthDay, this.endMonthDate),
          this.monthsLocale[this.activeMonthStart]
      );
      let dayForCheck = parseInt(moment(checkedDate).format("DD"));
      let pxValue = 0;

      if (dayForCheck < 9) {
        pxValue = -141;
      } else if (dayForCheck < 16) {
        pxValue = -200;
      } else if (dayForCheck < 22) {
        pxValue = -450;
      } else {
        pxValue = -1000;
      }

      return {
        // left: `${pxValue}px` || TODO temporary disabled for css changes 04/02/21
      };
      // return true
      // let badDate1 = moment()
      //   .set({ year: this.activeYearStart, month: this.activeMonthStart })
      //   .startOf("month");
      // let badDate2 = moment()
      //   .set({ year: this.activeYearStart, month: this.activeMonthStart })
      //   .startOf("month")
      //   .add(1, "days");
      // let badDate3 = moment()
      //   .set({ year: this.activeYearStart, month: this.activeMonthStart })
      //   .startOf("month")
      //   .add(2, "days");
      // let badDate4 = moment()
      //   .set({ year: this.activeYearStart, month: this.activeMonthStart })
      //   .startOf("month")
      //   .add(3, "days");
      // let badDate5 = moment()
      //   .set({ year: this.activeYearStart, month: this.activeMonthStart })
      //   .startOf("month")
      //   .add(4, "days");
      // let badDate6 = moment()
      //   .set({ year: this.activeYearStart, month: this.activeMonthStart })
      //   .startOf("month")
      //   .add(5, "days");
      //
      // return (
      //   checkedDate === badDate1.format("YYYY-MM-DD") ||
      //   checkedDate === badDate2.format("YYYY-MM-DD") ||
      //   checkedDate === badDate3.format("YYYY-MM-DD") ||
      //   checkedDate === badDate4.format("YYYY-MM-DD") ||
      //   checkedDate === badDate5.format("YYYY-MM-DD") ||
      //   checkedDate === badDate6.format("YYYY-MM-DD")
      // );
    },
    formatCADate(day, week) {
      let month = this.activeMonthStart + 1;

      return moment(this.activeYearStart + "-" + month + "-" + day).format(
          "YYYY-MM-DD"
      );
    },
    setIfOpenViewMode(flag) {
      this.ifOpenViewMode = flag;
    },
    getBtnClass(tabName) {
      switch (tabName) {
        case "LEADS":
          return "btn-success-header";
        case "LAST MODIFIED":
          return "btn-last-mod";
        case "LAST MOD TAG":
          return "btn-last-mod-tag";
        case "SCHEDULED CALLS":
          return "btn-sc";
        case "SCHEDULED CALLS-P":
          return "btn-warning-header";
        case "ASSIGNMENTS":
          return "btn-ass";
        case "TRANSFERS":
          return "btn-transfer";
        case "REFERRALS":
          return "btn btn-danger-header";
        case "DEPOSITS":
          return "btn btn-deposit";
        case "SUPPORT":
          return "btn btn-primary-header";
        case "LIVE":
          return "btn btn-info-header";
        case "NA TAG":
          return "btn btn-na";
        case "LEAD TAG":
          return "btn btn-lead";
        case "GR ASNG":
          return this.groupColor;
        default:
          return "btn-success-header";
      }
    },
    checkSelectedFilter(tab) {
      return this.selectedTopFilter === tab || this.selectedTopFilter === "ALL";
    },
    showCaPopUp(r, i) {

        this.hoverUserCA.r = r;
        this.hoverUserCA.i = i;
        this.ifOpenViewMode = true;

    },
    showDpPopUp(r, i) {
      // this.mouseOverDayTitle = true
      //if(this.timeout){
      Object.keys(this.timeout).map(key=>{
        clearTimeout(this.timeout[key])
      })

        this.timeout[`r${r}i${i}`] = setTimeout(() => {
          //   if (this.mouseOverDayTitle) {
          this.showPopUp=true;
          this.hoverUserDP.r = r;
          this.hoverUserDP.i = i;
          this.ifOpenViewMode = false;
          //   }

        }, 500);
      //}

      // }, Globals.ux.section.top_tag_menu.cal_presets_speed);

      // this.openDepositsPopup = true;
    },
    clearTimeoutPopUp(t){
      this.showPopUp = false;
      Object.keys(this.timeout).map(key=>{
        clearTimeout(this.timeout[key])
      })

    },
    clickOnMonthRange(tab, cal) {
      // if (
      //   this.dateRange[this.reg].date.start &&
      //   !this.dateRange[this.reg].date.end
      // ) {
      //   this.dateRange[this.reg].date.end = moment(
      //     this.activeYearStart + "/" + (tab + 1)
      //   )
      //     .endOf("month")
      //     .toDate();
      // }
      if (tab === this.activeMonthStart) {
        this.updatePreset(cal, this.finalPresetRanges["MONTH"], "MONTH");
      }
      this.activeMonthStart = tab;
      // this.setDateValue();
    },
    checkIsHour(hour) {
      return moment().format("H") == hour - 1;
    },
    holdDayClick(r, i) {
      this.daysInterval = setTimeout(() => {
        this.selectFirstItem(r, i);
      }, 1000);
    },
    clearHoldDay() {
      clearTimeout(this.daysInterval);
    },
    calHasRange(tab) {
      let cal = tab.alias;
      if (this.dateRange[cal].date.start || this.dateRange[cal].date.end) {
        return true;
      }
      return false;
    },
    selectionBetweenRange(month) {
      let startDate = this.dateRange[this.reg].date.start;
      let endDate = this.dateRange[this.reg].date.end;

      let tabDate = moment(this.activeYearStart + "/" + month).format(
          "YYYY-MM"
      );

      if (startDate || endDate) {
        if (
            moment(startDate)
                .format("YYYY-MM")
                .toString() === tabDate ||
            moment(endDate)
                .format("YYYY-MM")
                .toString() === tabDate
        ) {
          return true;
        }
        return moment(tabDate).isBetween(startDate, endDate);
      }
      return false;
    },
    returnRangeOfMonth(opt, month) {
      let date;
      let dateToShow = null;
      let tabDate = moment(this.activeYearStart + "/" + month).format(
          "YYYY-MM"
      );
      if (opt === "start") {
        date = this.dateRange[this.reg].date.start;
        if (date) {
          if (
              moment(date)
                  .format("YYYY-MM")
                  .toString() === tabDate
          ) {
            dateToShow = moment(date).format("DD");
          }
        }
      }
      if (opt === "end") {
        date = this.dateRange[this.reg].date.end;
        if (date) {
          if (
              moment(date)
                  .format("YYYY-MM")
                  .toString() === tabDate
          ) {
            dateToShow = moment(date).format("DD");
          }
        }
      }
      return dateToShow;
    },
    returnYearsList() {
      let thisYear = this.startActiveYear;
      let list = [];
      let runArr = [];
      if (this.yearsPaginate === 0) {
        runArr = [
          this.yearsPaginate - 1,
          this.yearsPaginate,
          this.yearsPaginate + 1
        ];
      } else if (this.yearsPaginate > 0) {
        runArr = [
          this.yearsPaginate + this.yearsPaginate,
          this.yearsPaginate + (this.yearsPaginate + 1),
          this.yearsPaginate + (this.yearsPaginate + 2)
        ];
      } else if (this.yearsPaginate < 0) {
        runArr = [
          this.yearsPaginate + this.yearsPaginate,
          this.yearsPaginate + (this.yearsPaginate - 1),
          this.yearsPaginate + (this.yearsPaginate - 2)
        ];
      }
      runArr.forEach(i => {
        if (this.yearsPaginate > 1) {
          list.push(thisYear + (i + 1));
        } else if (this.yearsPaginate < -1) {
          list.push(thisYear + (i - 1));
        } else {
          list.push(thisYear + i);
        }
      });
      return list.sort((a, b) => {
        return a - b;
      });
    },

    getDayLabel(r, i) {
      const result = this.getDayIndexInMonth(r, i, this.startMonthDay);
      const resultDate = new Date(
          Date.UTC(this.activeYearStart, this.activeMonthStart, result)
      );
      let label = moment(resultDate).format("ddd");
      return label;
    },
    resetHours() {
      this.selectedHours[this.reg].to = null;
      this.selectedHours[this.reg].from = null;
      this.$emit("resetHoursFilter", this.reg);
    },
    clickHourTime(hour) {
      if (this.selectedHours[this.reg].from === null && hour === 24) {
        return;
      }
      let option = "from";
      if (
          this.selectedHours[this.reg].from ||
          this.selectedHours[this.reg].from === 0
      ) {
        option = "to";
      }
      if (
          (this.selectedHours[this.reg].from ||
              this.selectedHours[this.reg].from === 0) &&
          this.selectedHours[this.reg].to
      ) {
        option = "from";
        if (hour > this.selectedHours[this.reg].from) {
          option = "to";
        }
      }
      if (
          this.selectedHours[this.reg].from === null &&
          this.selectedHours[this.reg].to === null
      ) {
        option = "from";
      }

      if (
          (this.selectedHours[this.reg].from ||
              this.selectedHours[this.reg].from === 0) &&
          this.selectedHours[this.reg].to === null &&
          this.selectedHours[this.reg].from > hour
      ) {
        return;
      }
      if (option === "from") {
        this.selectedHours[this.reg].from = hour;
      }
      if (option === "to" && this.selectedHours[this.reg].from !== null) {
        this.selectedHours[this.reg].to = hour;
      }

      if (
          this.selectedHours[this.reg].from !== null &&
          this.selectedHours[this.reg].to !== null
      ) {
        this.setHourFilter({
          from: moment(
              this.selectedHours[this.reg].from.toString(),
              "LTS"
          ).format("HH:mm:ss"),
          to: moment(this.selectedHours[this.reg].to.toString(), "LTS")
              .add(1, "hour")
              .subtract(1, "second")
              .format("HH:mm:ss"),
          calendar: this.reg
        });
      }
    },
    hoverTheHour(hour) {
      return (
          this.checkRangeHour &&
          (this.selectedHours[this.reg].from ||
              this.selectedHours[this.reg].from === 0) &&
          this.selectedHours[this.reg].from < hour &&
          this.checkRangeHour >= hour
      );
    },
    moveDate(action) {
      if (action === "back") {
        if (this.activeMonthStart === 0) {
          this.activeMonthStart = 11;
          this.activeYearStart -= 1;
        } else {
          this.activeMonthStart -= 1;
        }
      }
      if (action === "forward") {
        if (this.activeMonthStart === 11) {
          this.activeMonthStart = 0;
          this.activeYearStart += 1;
        } else {
          this.activeMonthStart += 1;
        }
      }
      if (this.activeMonthStart < 6) {
        this.monthPaginate = 0;
      } else {
        this.monthPaginate = 1;
      }
    },
    setDynamicChartView() {
      this.$store.commit("clients/setChartsMainView", "DYNAMIC");
    },
    defaultPresets(i18n = defaultI18n) {
      return {
        TODAY: function() {
          const n = new Date();
          const today = new Date(
              Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
          );
          return {
            label: presetRangeLabel.today,
            active: false,
            dateRange: {
              start: today,
              end: today
            }
          };
        },
        YESTERDAY: function() {
          const n = new Date();
          const start = new Date(
              Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 1)
          );
          // const end = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()))
          return {
            label: presetRangeLabel.yesterday,
            active: false,
            dateRange: {
              start: start,
              end: start
            }
          };
        },
        WEEK: function() {
          const start = moment()
              .subtract(1, "week")
              .toDate();
          const end = moment().toDate();
          return {
            label: "WEEK",
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        },
        T_WEEK: function() {
          const start = moment()
              .startOf("isoWeek")
              .toDate();
          const end = moment().toDate();
          return {
            label: "WEEK",
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        },
        L_WEEK: function() {
          const start = moment()
              .subtract(1, "week")
              .startOf("isoWeek")
              .toDate();
          const end = moment()
              .subtract(1, "week")
              .endOf("isoWeek")
              .toDate();
          return {
            label: "WEEK",
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        },
        MONTH: () => {
          const n = new Date();
          let month = this.activeMonthStart + 1;
          let startMonth = moment()
              .startOf("month")
              .toDate();
          let endMonth;
          if (
              moment().format("YYYY-MM") ===
              moment().format("YYYY-MM")
          ) {
            endMonth = moment().toDate();
          } else {
            endMonth = moment()
                .endOf("month")
                .toDate();
          }

          if (this.reg === "CA_F") {
            startMonth = moment().toDate();
            endMonth = moment()
                .endOf("month")
                .toDate();
          }

          return {
            label: presetRangeLabel.thisMonth,
            active: false,
            dateRange: {
              start: startMonth,
              end: endMonth
            }
          };
        },
        MONTH_F: () => {
          const n = new Date();
          let month = this.activeMonthStart + 1;

          let startMonth = moment().toDate();
          let endMonth = moment()
              .endOf("month")
              .toDate();
          return {
            label: presetRangeLabel.thisMonth,
            active: false,
            dateRange: {
              start: startMonth,
              end: endMonth
            }
          };
        },
        LAST_MONTH: function() {
          const n = new Date();
          const startMonth = new Date(
              Date.UTC(n.getFullYear(), n.getMonth() - 1, 1)
          );
          const endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 0));
          return {
            label: presetRangeLabel.lastMonth,
            active: false,
            dateRange: {
              start: startMonth,
              end: endMonth
            }
          };
        },
        QUARTER: function() {
          const start = moment()
              .subtract(1, "quarter")
              .toDate();
          const end = moment().toDate();
          return {
            label: "QUARTER",
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        },
        HALF_YEAR: function() {
          const start = moment()
              .subtract(6, "months")
              .toDate();
          const end = moment().toDate();
          return {
            label: "HALF_YEAR",
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        },
        last7days: function() {
          const n = new Date();
          const start = new Date(
              Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 6)
          );
          const end = new Date(
              Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
          );
          return {
            label: presetRangeLabel.lastSevenDays,
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        },
        last30days: function() {
          const n = new Date();
          const start = new Date(
              Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 30)
          );
          const end = new Date(
              Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
          );
          return {
            label: presetRangeLabel.lastThirtyDays,
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        },
        last90days: function() {
          const n = new Date();
          const start = new Date(
              Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 90)
          );
          const end = new Date(
              Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
          );
          return {
            label: presetRangeLabel.last90Days,
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        },
        last180days: function() {
          const n = new Date();
          const start = new Date(
              Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 180)
          );
          const end = new Date(
              Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
          );
          return {
            label: presetRangeLabel.last180Days,
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        },

        //future presets
        TOMORROW: function() {
          const n = new Date();
          const start = new Date(
              Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() + 1)
          );
          return {
            label: "TOMORROW",
            active: false,
            dateRange: {
              start: start,
              end: start
            }
          };
        },
        N_WEEK: function() {
          const start = moment()
              .add(1, "weeks")
              .startOf("isoWeek")
              .toDate();
          const end = moment()
              .add(1, "weeks")
              .endOf("isoWeek")
              .toDate();
          return {
            label: "N_WEEK",
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        },
        N_MONTH: function() {
          const n = new Date();
          const startMonth = new Date(
              Date.UTC(n.getFullYear(), n.getMonth() + 1, 1)
          );
          const endMonth = new Date(
              Date.UTC(n.getFullYear(), n.getMonth() + 2, 0)
          );
          return {
            label: "NEXT_MONTH",
            active: false,
            dateRange: {
              start: startMonth,
              end: endMonth
            }
          };
        },
        N_Q: function() {
          const start = moment().toDate();
          const end = moment()
              .add(3, "months")
              .toDate();
          return {
            label: "NEXT_Q",
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        },
        N_Y: function() {
          const start = moment().toDate();
          const end = moment()
              .add(1, "year")
              .toDate();
          return {
            label: "NEXT_Y",
            active: false,
            dateRange: {
              start: start,
              end: end
            }
          };
        }
      };
    },
    handleCaChoose() {
      this.selectedCal = "SC-F";
      this.selectedCalTab = "CA_F";
      this.displayedCal = "SC-F";
      if (!this.caDate) {
        let date = new Date();
        this.activeMonthStart = date.getMonth();
        this.activeYearStart = date.getFullYear();
      }
      this.caDate = this.openCaComponent.date;

      this.$store.commit("clients/setLoading", true);
      if (this.openCaComponent.fromTable) {
        apiClientCreator(`client/stats/calendar/get_dates_for_tag/CA`)
            .get("", {})
            .then(res => {
              if (res.data.dates[0]) {
                let tempQuery = {
                  scheduled_call_to_from: res.data.dates[0],
                  scheduled_call_to_to: res.data.dates[1],
                  active: 1
                };

                apiClientCreator(`client/stats/calendar/sc/days`)
                    .get("", {
                      params: tempQuery
                    })
                    .then(res => {
                      this.dateRangesStats["CA_F"] = res.data;
                      this.requestCaCalDaysBusy = false;
                      this.$store.commit("clients/setLoading", false);
                    })
                    .catch(err => {
                      this.requestCaCalDaysBusy = false;
                      this.$store.commit("clients/setLoading", false);
                    });
              }

              this.requestCaCalDaysBusy = false;
              this.$store.commit("clients/setLoading", false);
            })
            .catch(err => {
              this.requestCaCalDaysBusy = false;
              this.$store.commit("clients/setLoading", false);
            });
      }
    },
    async fetchUsersShifts() {
      let allShifts = apiClientCreator(`shifts/all_users_shifts`);
      let result = await allShifts.get("");
      let shifts = [];
      result.data.forEach(s => {
        shifts.push(s);
      });
      this.newAllUsersShifts = shifts;
    },
    checkIfFilledPrevWeek() {
      apiClientCreator(`shifts/check_if_filled_last_week`)
          .get("")
          .then(res => {
            if (res.data === "yes") {
              this.filledLastWeek = true;
            }
          });
    },

    setShiftPriority(shift, r, i) {
      this.shiftPriority.choice.id = shift.id;
      this.shiftPriority.r = r;
      this.shiftPriority.i = i;
    },

    submitShift(date, shift,r) {
      this.shiftsSelectionDate = moment(date).add(1,'day').format(
          "YYYY-MM-DD"
      )
      if(this.userFilledAllShifts){
        this.shiftsSelectionDate =   null
      }
      if (moment(date).isoWeekday() === 6 || moment(date).isoWeekday() === 7) {

        this.shiftsSelectionDate =   null

      }

      if(moment(date).endOf('month').format(
          "YYYY-MM-DD"
      ) === date){

        r = 1;
        this.shiftOverviewWeek = r;
        this.moveDate('forward')
      }

      if (shift.id === 7) {
        this.openCostumeShiftWindow = true;
        this.submitedMondayShift = true;
      }
      if (shift.id !== 7) {

        this.submitedMondayShift = true;
        this.shiftOverviewWeek = r;
        let getShiftList = apiClientCreator(
            `shifts/save_user_choice/${shift.id}`
        );
        getShiftList
            .post("", {
              choice_date: date,
              week: r,
              priority: this.shiftPriority.i !== null ? this.shiftPriority : null
            })
            .then(res => {
              this.shiftPriority = {
                choice: {
                  id: null,
                  name: null
                },
                r: null,
                i: null,
                reason: null
              },
              this.checkUserShifts();
              this.fetchUsersShifts();
              this.getShiftsToCalendar();
              this.userSelectShiftPopup = false;
            });
      }
    },
    getShiftsToCalendar() {
      apiClientCreator(`shifts/get_choices_to_calendar`)
          .get("", {})
          .then(res => {
            if (res.data.length > 0) {
              this.dateRangesStats["SHIFTS"] = res.data;
              // this.shiftOverviewWeek = res.data[0].week;
              this.checkUserShifts();
            } else {
              this.copyLastWeekShifts = true;
            }
          });
    },
    copyShiftsFromLastWeek(r) {
      apiClientCreator(`shifts/copy_last_week_shifts`)
          .get("", {})
          .then(res => {
            if (res.data.length > 0) {
              this.getShiftsToCalendar();
              // this.dateRangesStats['SHIFTS'] = res.data;
              this.copyLastWeekShifts = false;
              this.userFilledAllShifts = true;
            } else {
            }
          });
    },
    showUserSelectShiftPopup(r, i) {
      this.userHoverShiftPopup = false;
      this.clickedShiftDay = { i: i, r: r };
      this.userSelectShiftPopup = true;
    },
    showUsersShiftsForToday(r, i) {
      const result = this.getDayIndexInMonth(r, i, this.startMonthDay);
      const resultDate = new Date(
          Date.UTC(this.activeYearStart, this.activeMonthStart, result)
      );
      let formattedDate = moment(resultDate).format("YYYY-MM-DD");

      return this.newAllUsersShifts.filter(
          s => moment(s.choice_date).format("YYYY-MM-DD") === formattedDate
      );
    },
    showHoverShiftsPopup(r, i) {
      this.hoverUsersShift = { r: r, i: i };
      this.userHoverShiftPopup = true;
    },
    checkPastAllEventsDate() {
      let check = true;
      this.economicEventsStats.forEach(e => {
        if (moment(e.date).isAfter(moment().toDate())) {
          check = false;
        }
      });
      return check;
    },
    checkPastEventDate(date) {
      return moment(moment().toDate()).isAfter(date);
    },
    momentFormmater(date) {
      return moment(date).format("DD/MM/YY HH:mm");
    },
    startDayZero(i, startMonthDay) {
      if (startMonthDay > 0) {
        return false;
      } else {
        if (i > 37) {
          return true;
        } else {
          return false;
        }
      }
    },
    closeBDTable() {
      this.userSelectShiftPopup = false;
      this.showBDTable = false;
      this.showEcEVTTable = false;
    },
    openCalTabMenu(event) {
      const rect = event.currentTarget.getBoundingClientRect();
      const menuHeight = 420;
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      let top;
      if (spaceBelow >= menuHeight || spaceBelow >= spaceAbove) {
        top = Math.min(rect.bottom, window.innerHeight - menuHeight);
      } else {
        top = Math.max(0, rect.top - menuHeight);
      }
      this.calTabMenuPos = { top, left: rect.left };
      this.showCalTabMenu = !this.showCalTabMenu;
      if (this.showCalTabMenu) {
        setTimeout(() => {
          const close = () => { this.showCalTabMenu = false; document.removeEventListener('click', close); };
          document.addEventListener('click', close);
        }, 0);
      }
    },
    closeShiftSelection() {
      this.userSelectShiftPopup = false;
    },
    userAge(user) {
      return moment(moment().format("YYYY/MM/DD")).diff(
          moment(user.birth_date).format("YYYY/MM/DD"),
          "years"
      );
    },
    checkForCalCompareStats() {
      if (this.dateRangesStats[this.reg].hasOwnProperty("secondary_dates")) {
        return true;
      } else {
        return false;
      }
    },

    getYearsList() {
      let tempArr = [];
      let counter = 10;
      this.availableMonthsNum.map(item => {
        if (counter > -1) {
          tempArr.push(this.startActiveYear - counter--);
        }
        if (counter === -1) {
          tempArr.push(this.startActiveYear + 1);
          counter--;
        }
      });
      return tempArr;
    },
    setWeekPreset(r, i) {
      const result = this.getDayIndexInMonth(r, 6, this.startNextMonthDay);
    },
    checkLastWeek(r, i, startMonthDay, endMonthDate) {
      // const result = this.getDayIndexInMonth(r, i, startMonthDay);
      // // bound by > 0 and < last day of month
      // result > 0 && result <= endMonthDate?this.lastWeek++:'';
    },
    resetAllCalendars() {
      this.dateRange = {
        REG: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        LAST_MOD: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        LAST_MOD_TAG: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        CA_F: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        CA_P: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        ASSIGN: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        TRA: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        DEP: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        REF: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        SUP: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        LIVE: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        LEAD_TAG: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        NA_TAG: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        BN_TAG: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        GR_ASGN: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        SHIFTS: {
          date: {
            start: null,
            end: null
          },
          secondDate: {
            start: null,
            end: null
          },
          preset: null
        },
        tag: "",
        date: "",
        secondDate: ""
      };
      //this.fetchTableData();
      this.selectedCalTab = "REG";
      this.reg = "REG";
      this.selectedCal = "USERS";
      this.displayedCal = "REGISTRATION";
      this.$emit("resetAllCalendars");
      this.isFirstChoice = true;
      this.isFirstChoiceOfSecondDate = true;
      this.selectedHours = {
        REG: {
          from: null,
          to: null
        },
        LAST_MOD: {
          from: null,
          to: null
        },
        LAST_MOD_TAG: {
          from: null,
          to: null
        },
        CA_F: {
          from: null,
          to: null
        },
        CA_P: {
          from: null,
          to: null
        },
        ASSIGN: {
          from: null,
          to: null
        },
        TRA: {
          from: null,
          to: null
        },
        DEP: {
          from: null,
          to: null
        },
        REF: {
          from: null,
          to: null
        },
        SUP: {
          from: null,
          to: null
        },
        LIVE: {
          from: null,
          to: null
        },
        LEAD_TAG: {
          from: null,
          to: null
        },
        NA_TAG: {
          from: null,
          to: null
        },
        BN_TAG: {
          from: null,
          to: null
        },
        GR_ASGN: {
          from: null,
          to: null
        },
        SHIFTS: {
          from: null,
          to: null
        }
      };
    },
    resetBtn() {
      let showRstBtn = false;
      this.calTabs.map(item => {
        if (
            this.dateRange[item.alias].date.start &&
            this.dateRange[item.alias].date.end
        ) {
          showRstBtn = true;
        }
      });
      return showRstBtn;
    },
    weekCount(year, month_number) {
      let firstOfMonth = new Date(year, month_number - 1, 1);
      let day = firstOfMonth.getDay() || 6;
      day = day === 1 ? 0 : day;
      if (day) {
        day--;
      }
      let diff = 7 - day;
      let lastOfMonth = new Date(year, month_number, 0);
      let lastDate = lastOfMonth.getDate();
      if (lastOfMonth.getDay() === 1) {
        diff--;
      }
      let result = Math.ceil((lastDate - diff) / 7);
      return result + 1;
    },
    getCalTabList(tabList) {
      let allTabs = tabList;
      if (
          this.clientsTableSelectedMainTab === "clients" ||
          this.clientsTableSelectedMainTab === "newLd"
      ) {
        allTabs = allTabs.filter(tab => tab.alias !== "GR_ASGN");
      }
      if (
          this.clientsTableSelectedMainTab === "bn" ||
          this.clientsTableSelectedMainTab === "ni" ||
          this.clientsTableSelectedMainTab === "na"
      ) {
        allTabs = allTabs.filter(
            tab =>
                tab.alias !== "CA_F" && tab.alias !== "SUP" && tab.alias !== "DEP"
        );
      }
      if (!this.CheckUserPermission([1, 2, 3, 4, 5, 12])) {
        allTabs = allTabs.filter(
            tab =>
                tab.alias !== "SUP" &&
                // tab.alias !== "ASSIGN" &&
                tab.alias !== "LIVE" &&
                tab.alias !== "GR_ASGN"
        );
      }

      return allTabs.filter(tab => {
        return (
            tab.alias !== this.selectedCalTab && tab.alias !== "LAST_MOD_TAG"
        );
      });
    },
    resetOneCalendar(calendar, resetChoice = true) {
      let tag = null;
      switch (calendar) {
        case "REG":
          tag = "all";
          break;
        case "DEP":
          tag = "dp";
          break;
        case "CA_F":
          tag = "sc";
          break;
        case "CA_P":
          tag = "mc";
          break;
        case "TRA":
          tag = "tr";
          break;
        case "REF":
          tag = "rf";
          break;
        case "LEAD_TAG":
          tag = "ld";
          break;
        case "NA_TAG":
          tag = "na";
          break;
        case "BN_TAG":
          tag = "bn";
          break;
      }
      this.$emit("resetOneCalendar", { calendar: calendar, tag: tag });
      this.dateRange[calendar] = {
        date: {
          start: null,
          end: null
        },
        secondDate: {
          start: null,
          end: null
        },
        preset: null
      };
      this.selectedHours[calendar] = {
        from: null,
        to: null
      };
      this.isFirstChoice = resetChoice;
      this.isFirstChoiceOfSecondDate = true;
      this.hoursRangesStats[calendar] = [];
      this.dateRangesStats[calendar] = [];
      if (calendar === "LIVE") {
        this.$store.commit("clients/setUpdateLiveChart", {
          dates: null,
          lead_filter: this.selectedTopFilter
        });
      }
    },
    resetSecondDate(calendar) {
      this.dateRange[calendar].secondDate = {
        start: null,
        end: null
      };
      this.dateRangesStats[calendar] = [];
      this.setDateValue();
      this.isFirstChoiceOfSecondDate = true;
    },
    countTheViews() {
      let count = this.regCalStatsTodays[this.allTags].calendar_today_total;
      let tempTime = moment().format("YYY-MM-DD");
      let tempTimeArr = [];
      tempTimeArr.push([tempTime, count]);
      if (localStorage.getItem("tTime") === undefined) {
        localStorage.setItem("tTime", JSON.stringify(tempTimeArr));
      } else {
        let beforeSending = JSON.parse(localStorage.getItem("tTime"));
        if (beforeSending.length > 0) {
          if (beforeSending[0][0] === tempTime) {
            if (count > beforeSending[0][1]) {
              this.ctv = count - beforeSending[0][1];
            }
          } else {
            localStorage.setItem("tTime", JSON.stringify(tempTimeArr));
          }
        }
        // let x=JSON.parse(localStorage.getItem("tTime"));
        // x.push(tempTime);
        // localStorage.setItem("tTime",JSON.stringify(x));
      }
    },

    getDateString: function(date, format = this.format) {
      if (!date) {
        return null;
      }
      const dateparse = new Date(Date.parse(date));
      return fecha.format(
          new Date(
              Date.UTC(
                  dateparse.getFullYear(),
                  dateparse.getMonth(),
                  dateparse.getDate()
              )
          ),
          format
      );
    },

    getDayIndexInMonth: function(r, i, startMonthDay) {
      if (startMonthDay === 0) {
        const date = this.numOfDays * (r - 1) + i;

        return date - startMonthDay;
      }
      const date = this.numOfDays * (r - 1) + (i + 1);

      return date - startMonthDay;
    },

    getDayCell(r, i, startMonthDay, endMonthDate) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      // bound by > 0 and < last day of month
      return result > 0 && result <= endMonthDate ? result : result; //'&nbsp;')
    },
    getDayCellShow(r, i, startMonthDay, endMonthDate) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      // bound by > 0 and < last day of month

      return result > 0 && result <= endMonthDate
          ? result
          : result > this.endMonthDate
              ? result - this.endMonthDate
              : 0; //'&nbsp;')
    },
    getDayCellDis(r, i, startMonthDay, endMonthDate) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      // bound by > 0 and < last day of month
      return result; //'&nbsp;')
    },

    getNewDateRange(result, activeMonth, activeYear) {
      const newData = {};
      let key = "start";
      if (!this.isFirstChoice) {
        key = "end";
      } else {
        newData["end"] = null;
      }
      const resultDate = new Date(Date.UTC(activeYear, activeMonth, result));
      if (
          !this.isFirstChoice &&
          resultDate < this.dateRange[this.reg].date.start
      ) {
        this.isFirstChoice = false;
        return { start: resultDate };
      }

      // toggle first choice
      this.isFirstChoice = !this.isFirstChoice;
      newData[key] = resultDate;
      return newData;
    },
    getNewSecondDateRange(result, activeMonth, activeYear) {
      const newData = {};
      let key = "start";
      if (!this.isFirstChoiceOfSecondDate) {
        key = "end";
      } else {
        newData["end"] = null;
      }
      const resultDate = new Date(Date.UTC(activeYear, activeMonth, result));
      if (
          !this.isFirstChoiceOfSecondDate &&
          resultDate < this.dateRange[this.reg].secondDate.start
      ) {
        this.isFirstChoiceOfSecondDate = false;
        // this.isFirstChoiceOfSecondDate = true;

        return { start: resultDate };
      }

      // toggle first choice

      this.isFirstChoiceOfSecondDate = false;
      newData[key] = resultDate;
      if (key === "end") {
        if (
            moment(resultDate).diff(
                this.dateRange[this.reg].secondDate.start,
                "days"
            ) !==
            moment(this.dateRange[this.reg].date.end).diff(
                this.dateRange[this.reg].date.start,
                "days"
            )
        ) {
          let tempDate = this.dateRange[this.reg].secondDate.start;
          this.resetOneCalendar(this.reg);
          this.dateRange[this.reg].date.start = tempDate;
          this.dateRange[this.reg].date.end = resultDate;
          // this.setDateValue();
          return;
        }
      }
      return newData;
    },

    selectFirstItem(r, i) {
      const result = this.getDayIndexInMonth(r, i, this.startMonthDay);

      const resultDate = new Date(
          Date.UTC(this.activeYearStart, this.activeMonthStart, result)
      );

      if (
          (!moment(resultDate).isAfter(moment().toDate(), "day") ||
              this.reg === "CA_F") &&
          (!moment(moment().toDate()).isAfter(resultDate, "day") ||
              this.reg !== "CA_F")
      ) {
        if (
            this.dateRange[this.reg].date.start &&
            this.dateRange[this.reg].date.end &&
            this.dateRange[this.reg].secondDate.start &&
            this.dateRange[this.reg].secondDate.end
        ) {
          this.resetOneCalendar(this.reg);
        } else {
          if (
              this.dateRange[this.reg].date.start &&
              this.dateRange[this.reg].date.end &&
              !this.spcListArr.includes(this.reg)
          ) {
            this.dateRange[this.reg].secondDate = Object.assign(
                {},
                this.dateRange[this.reg].secondDate,
                this.getNewSecondDateRange(
                    result,
                    this.activeMonthStart,
                    this.activeYearStart
                )
            );
          } else {
            this.dateRange[this.reg].date = Object.assign(
                {},
                this.dateRange[this.reg].date,
                this.getNewDateRange(
                    result,
                    this.activeMonthStart,
                    this.activeYearStart
                )
            );
          }

          if (
              (this.dateRange[this.reg].date.start &&
                  this.dateRange[this.reg].date.end &&
                  (!this.dateRange[this.reg].secondDate.start &&
                      !this.dateRange[this.reg].secondDate.end)) ||
              (this.dateRange[this.reg].secondDate.start &&
                  this.dateRange[this.reg].secondDate.end)
          ) {
            this.dateRange[this.reg].preset = null;
            if (this.isCompact) {
              this.showMonth = false;
            }
            // this.$store.commit("clients/setSelectedCalendarType", {
            //   alias: this.reg,
            //   preset: null
            // });
            this.setDateValue();
          }

          if (
            this.dateRange[this.reg].date.start ||
            this.dateRange[this.reg].date.end
          ) {
            this.showResetBtn = true;
          }
        }
      }
    },

    markBirthDay(day, month) {
      return (
        moment().date() === parseInt(day) &&
        moment().format("MMMM") === month &&
        this.birthDaysStats.count > 0
      );
    },

    markEconomicEvents(day, month) {
      return (
        moment().date() === parseInt(day) &&
        moment().format("MMMM") === month &&
        moment().format("YYYY") == this.activeYearStart &&
        this.economicEventsStats.length > 0
      );
    },

    isDateSelected(r, i, key, startMonthDay, endMonthDate, selectedCal) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      // if (result < 0 || result > endMonthDate) return false;
      let currDate = null;
      if (key === "first") {
      } else {
        currDate = new Date(
          Date.UTC(this.activeYearEnd, this.startNextActiveMonth, result)
        );
      }
      currDate = new Date(
        Date.UTC(this.activeYearStart, this.activeMonthStart, result)
      );
      if (!this.dateRange.hasOwnProperty(this.reg)) {
        return false;
      }
      if (this.dateRange[this.reg]["secondDate"].start === null) {
        return (
          (this.dateRange[this.reg].date.start &&
            moment(this.dateRange[this.reg].date.start).format("YYYY-MM-DD") ===
              moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, result)
              ).format("YYYY-MM-DD")) ||
          (this.dateRange[this.reg].date.end &&
            moment(this.dateRange[this.reg].date.end).format("YYYY-MM-DD") ===
              moment(
                Date.UTC(this.activeYearStart, this.activeMonthStart, result)
              ).format("YYYY-MM-DD"))
        );
      } else {
        return (
          (this.dateRange[this.reg].date.start &&
            this.dateRange[this.reg].date.start.getTime() ===
              currDate.getTime()) ||
          (this.dateRange[this.reg].date.end &&
            this.dateRange[this.reg].date.end.getTime() === currDate.getTime())
        );
      }
    },

    isDateInCompareSelected(
      r,
      i,
      key,
      startMonthDay,
      endMonthDate,
      selectedCal
    ) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      if (result < 1 || result > endMonthDate) return false;
      let currDate = null;
      if (key === "first") {
        currDate = new Date(
          Date.UTC(this.activeYearStart, this.activeMonthStart, result)
        );
      } else {
        currDate = new Date(
          Date.UTC(this.activeYearEnd, this.startNextActiveMonth, result)
        );
      }
      if (!this.dateRange.hasOwnProperty(this.reg)) {
        return false;
      }
      if (this.dateRange[this.reg]["secondDate"].start === null) {
        return false;
      } else {
        return (
          (this.dateRange[this.reg].secondDate.start &&
            this.dateRange[this.reg].secondDate.start.getTime() ===
              currDate.getTime()) ||
          (this.dateRange[this.reg].secondDate.end &&
            this.dateRange[this.reg].secondDate.end.getTime() ===
              currDate.getTime())
        );
      }
    },
    isDateInRange(r, i, key, startMonthDay, endMonthDate) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      //if (result < 2 || result > endMonthDate) return false;

      let currDate = null;
      if (key === "first") {
        currDate = new Date(
          Date.UTC(this.activeYearStart, this.activeMonthStart, result)
        );
      } else {
        currDate = new Date(
          Date.UTC(this.activeYearEnd, this.startNextActiveMonth, result)
        );
      }
      if (!this.dateRange.hasOwnProperty(this.reg)) {
        return false;
      }
      return (
        this.dateRange[this.reg].date.start &&
        this.dateRange[this.reg].date.start.getTime() < currDate.getTime() &&
        (this.dateRange[this.reg].date.end &&
          this.dateRange[this.reg].date.end.getTime() > currDate.getTime())
      );
    },
    isDateInRangeCompare(r, i, key, startMonthDay, endMonthDate) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      if (result < 2 || result > endMonthDate) return false;

      let currDate = null;
      if (key === "first") {
        currDate = new Date(
            Date.UTC(this.activeYearStart, this.activeMonthStart, result)
        );
      } else {
        currDate = new Date(
            Date.UTC(this.activeYearEnd, this.startNextActiveMonth, result)
        );
      }
      if (!this.dateRange.hasOwnProperty(this.reg)) {
        return false;
      }

      return (
          this.dateRange[this.reg].secondDate.start &&
          this.dateRange[this.reg].secondDate.start.getTime() <
          currDate.getTime() &&
          (this.dateRange[this.reg].secondDate.end &&
              this.dateRange[this.reg].secondDate.end.getTime() >
              currDate.getTime())
      );
    },

    isDateDisabled(r, i, startMonthDay, endMonthDate) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      // bound by > 0 and < last day of month
      return !(result > 0 && result <= endMonthDate);
    },

    isDateIsFuture(day, month) {
      const date =
          (moment(
              `${this.activeYearStart}.${this.activeMonthStart + 1}.${day}`
              ).isAfter(moment().toDate()) &&
              (this.reg !== "CA_F" && this.selectedMainTab !== "users")) ||
          (this.reg === "CA_F" &&
              moment(moment().toDate()).isAfter(
                  `${this.activeYearStart}.${this.activeMonthStart + 1}.${day}`
              ) &&
              moment(moment().toDate()).format("YYYY-MM-DD") !==
              moment(
                  `${this.activeYearStart}.${this.activeMonthStart + 1}.${day}`
              ).format("YYYY-MM-DD"));

      return date;
    },

    dateAfterMonth(r, i) {
      const result = this.getDayIndexInMonth(r, i, this.startMonthDay);
      const resultDate = new Date(
          Date.UTC(this.activeYearStart, this.activeMonthStart, result)
      );
      const date = moment(resultDate).isAfter(
          moment(`${this.activeYearStart}.${this.activeMonthStart + 1}`)
              .endOf("month")
              .toDate()
      );
      return date;
    },

    isDateIsPast(day, month) {
      let date =
          moment(moment().toDate()).isAfter(
              `${this.activeYearStart}.${this.activeMonthStart + 1}.${day}`
          ) &&
          (this.selectedMainTab === "users" ||
              (this.reg === "CA_F" ||
                  moment(moment().toDate()).isSame(
                      `${this.activeYearStart}.${this.activeMonthStart + 1}.${day - 1}`
                  )));

      return date;
    },

    isDateLastCompare(day, month) {
      let date1 = moment(
          `${this.activeYearStart}.${this.activeMonthStart + 1}.${day}`
      ).format("YYYY-MM-DD");
      let date2 = moment(this.dateRange[this.reg].secondDate.end).format(
          "YYYY-MM-DD"
      );
      const date = this.dateRange[this.reg].secondDate.end && date1 === date2;

      return date;
    },

    isDateLastRange(day, month) {
      let date1 = moment(
          `${this.activeYearStart}.${this.activeMonthStart + 1}.${day}`
      ).format("YYYY-MM-DD");
      let date2 = moment(this.dateRange[this.reg].date.end).format(
          "YYYY-MM-DD"
      );
      const date = this.dateRange[this.reg].date.end && date1 === date2;

      return date;
    },

    isDateLastRangeMonth(month) {
      if (!this.dateRange[this.reg].date.end) {
        return;
      }
      let date1 = moment(`${this.activeYearStart}.${month}`).format("YYYY-MM");

      let date2 = moment(this.dateRange[this.reg].date.end).format("YYYY-MM");

      const date = this.dateRange[this.reg].date.end && date1 === date2;

      return date;
    },

    isDateIsWeekend(r, i) {
      const result = this.getDayIndexInMonth(r, i, this.startMonthDay);
      const resultDate = new Date(
          Date.UTC(this.activeYearStart, this.activeMonthStart, result)
      );
      let label =
          moment(resultDate).isoWeekday() === 6 ||
          moment(resultDate).isoWeekday() === 7;
      return label;
    },
    goPrevMonthes() {
      this.lastWeek = 0;
      // const prevMonth = new Date(
      //   Date.UTC(this.activeYearStart, this.activeMonthStart, 0)
      // );
      const prevMonth = moment(
          `${this.activeYearStart}.${this.activeMonthStart}`,
          "YYYY-M"
      ).subtract(1, "months");
      this.activeMonthStart = prevMonth.format("M");
      this.activeYearStart = prevMonth.format("YYYY");
      this.activeYearEnd = prevMonth.format("YYYY");
    },

    goNextMonthes() {
      this.lastWeek = 0;
      const nextMonth = new Date(
          Date.UTC(this.activeYearEnd, this.startNextActiveMonth, 1)
      );
      this.activeMonthStart = nextMonth.getMonth();
      this.activeYearStart = nextMonth.getFullYear();
    },

    fitStatsToRange(num, month) {
      let count;
      if (
          this.dateRangesStats.hasOwnProperty(this.reg) &&
          this.dateRangesStats[this.reg].hasOwnProperty("initial_dates") &&
          this.dateRange[this.reg].secondDate.start &&
          this.dateRange[this.reg].secondDate.end
      ) {
        // let startDate = moment(this.dateRange[this.reg].date.start).subtract(1,"day")
        // let endDate = moment(this.dateRange[this.reg].date.end).add(1,"day")
        count = this.dateRangesStats[this.reg].initial_dates.find(itm => {
          const monthName =
              itm.hasOwnProperty("date") &&
              moment(itm.date).format("MMMM") === month &&
              moment(itm.date).format("YYYY") == this.activeYearStart;
          //     && moment(itm.date).isBetween(startDate, endDate);
          if (monthName) {
            return moment(itm.date).date() === parseInt(num);
          }
        });
        if (count === undefined) {
          count = this.dateRangesStats[this.reg].secondary_dates.find(itm => {
            const monthName =
                itm.hasOwnProperty("date") &&
                moment(itm.date).format("MMMM") === month &&
                moment(itm.date).format("YYYY") == this.activeYearStart;
            if (monthName) {
              return moment(itm.date).date() === parseInt(num);
            }
          });
        }
      } else if (
          this.dateRangesStats.hasOwnProperty(this.reg) &&
          !this.dateRangesStats[this.reg].hasOwnProperty("initial_dates")
      ) {
        count = this.dateRangesStats.hasOwnProperty(this.reg)
            ? this.dateRangesStats[this.reg].find(itm => {
              const monthName =
                  itm.hasOwnProperty("date") &&
                  moment(itm.date).format("MMMM") === month &&
                  moment(itm.date).format("YYYY") == this.activeYearStart;
              if (monthName) {
                return moment(itm.date).date() === parseInt(num);
              }
            })
            : undefined;
      }

      if (count === undefined) {
        return "";
      } else {
        return count.count;
      }
    },

    fitStatsToRangeTotal(num, month) {
      let count;
      if (
          this.dateRangesStats.hasOwnProperty(this.reg) &&
          this.dateRangesStats[this.reg].hasOwnProperty("initial_dates")
      ) {
        count = this.dateRangesStats[this.reg].initial_dates.find(itm => {
          const monthName =
              itm.hasOwnProperty("date") &&
              moment(itm.date).format("MMMM") === month &&
              moment(itm.date).format("YYYY") == this.activeYearStart;

          if (monthName) {
            return moment(itm.date).date() === parseInt(num);
          }
        });
        if (count === undefined) {
          count = this.dateRangesStats[this.reg].secondary_dates.find(itm => {
            const monthName =
                itm.hasOwnProperty("date") &&
                moment(itm.date).format("MMMM") === month &&
                moment(itm.date).format("YYYY") == this.activeYearStart;
            if (monthName) {
              return moment(itm.date).date() === parseInt(num);
            }
          });
        }
      } else if (
          this.dateRangesStats.hasOwnProperty(this.reg) &&
          !this.dateRangesStats[this.reg].hasOwnProperty("initial_dates")
      ) {
        count = this.dateRangesStats.hasOwnProperty(this.reg)
            ? this.dateRangesStats[this.reg].find(itm => {
              const monthName =
                  itm.hasOwnProperty("date") &&
                  moment(itm.date).format("MMMM") === month &&
                  moment(itm.date).format("YYYY") == this.activeYearStart;
              if (monthName) {
                return moment(itm.date).date() === parseInt(num);
              }
            })
            : undefined;
      }

      if (count === undefined) {
        return "";
      } else {
        return count.total_count || count.total_count === 0
            ? count.total_count
            : "";
      }
    },

    fitStatsToMonthRange(month) {
      if (
          !this.dateRange[this.reg].date.start &&
          !this.dateRange[this.reg].date.end &&
          !this.dateRange[this.reg].secondDate.start &&
          !this.dateRange[this.reg].secondDate.end
      ) {
        return undefined;
      }
      let count;
      let monthFormat = moment(`${this.activeYearStart}.${month}`).format(
          "YYYY-MM"
      );

      if (
          this.dateRangesStats.hasOwnProperty(this.reg) &&
          this.dateRangesStats[this.reg].hasOwnProperty("initial_dates")
      ) {
        count = this.dateRangesStats[this.reg].initial_dates.filter(itm => {
          const monthName =
              itm.hasOwnProperty("date") &&
              moment(itm.date).format("YYYY-MM") === monthFormat;
          if (monthName) {
            return moment(itm.date).format("YYYY-MM") === monthFormat;
          }
        });
        if (count.length === 0) {
          count = this.dateRangesStats[this.reg].secondary_dates.filter(itm => {
            const monthName =
                itm.hasOwnProperty("date") &&
                moment(itm.date).format("YYYY-MM") === monthFormat;
            if (monthName) {
              return moment(itm.date).format("YYYY-MM") === monthFormat;
            }
          });
        }
      } else if (
          this.dateRangesStats.hasOwnProperty(this.reg) &&
          !this.dateRangesStats[this.reg].hasOwnProperty("initial_dates")
      ) {
        count = this.dateRangesStats.hasOwnProperty(this.reg)
            ? this.dateRangesStats[this.reg].filter(itm => {
              const monthName =
                  moment(itm.date).format("YYYY-MM") === monthFormat &&
                  itm.hasOwnProperty("date");
              if (monthName) {
                return moment(itm.date).format("YYYY-MM") === monthFormat;
              }
            })
            : undefined;
      }
      if (count.length === 0) {
        return "";
      } else {
        let singleVal = 0;
        for (let i = 0; i < count.length; i++) {
          singleVal = singleVal += count[i].count;
        }
        return singleVal;
      }
    },

    fitStatsToMonthRangeTotal(month) {
      if (
          !this.dateRange[this.reg].date.start &&
          !this.dateRange[this.reg].date.end &&
          !this.dateRange[this.reg].secondDate.start &&
          !this.dateRange[this.reg].secondDate.end
      ) {
        return undefined;
      }
      let count;
      let monthFormat = moment(`${this.activeYearStart}.${month}`).format(
          "YYYY-MM"
      );

      if (
          this.dateRangesStats.hasOwnProperty(this.reg) &&
          this.dateRangesStats[this.reg].hasOwnProperty("initial_dates")
      ) {
        count = this.dateRangesStats[this.reg].initial_dates.filter(itm => {
          const monthName =
              itm.hasOwnProperty("date") &&
              moment(itm.date).format("YYYY-MM") === monthFormat &&
              itm.hasOwnProperty("total_count");
          if (monthName) {
            return moment(itm.date).format("YYYY-MM") === monthFormat;
          }
        });

        if (count.length === 0) {
          count = this.dateRangesStats[this.reg].secondary_dates.filter(itm => {
            const monthName =
                itm.hasOwnProperty("date") &&
                moment(itm.date).format("YYYY-MM") === monthFormat &&
                itm.hasOwnProperty("total_count");
            if (monthName) {
              return moment(itm.date).format("YYYY-MM") === monthFormat;
            }
          });
        }
      } else if (
          this.dateRangesStats.hasOwnProperty(this.reg) &&
          !this.dateRangesStats[this.reg].hasOwnProperty("initial_dates")
      ) {
        count = this.dateRangesStats.hasOwnProperty(this.reg)
            ? this.dateRangesStats[this.reg].filter(itm => {
              const monthName =
                  itm.hasOwnProperty("date") &&
                  moment(itm.date).format("YYYY-MM") === monthFormat &&
                  itm.hasOwnProperty("total_count");
              if (monthName) {
                return moment(itm.date).format("YYYY-MM") === monthFormat;
              }
            })
            : undefined;
      }
      if (count.length === 0) {
        return "";
      } else {
        return this.newReduce(count, "total_count", "count");
      }
    },

    fitStatsToHour(hour, preset) {
      let count;

      if (this.hoursRangesStats.hasOwnProperty(this.reg)) {
        count = this.hoursRangesStats.hasOwnProperty(this.reg)
            ? this.hoursRangesStats[this.reg].find(itm => {
              const HourName = itm.date == hour;
              if (HourName) {
                return itm.date == hour;
              }
            })
            : undefined;
      }

      if (count === undefined) {
        return "";
      } else {
        return preset === "total" ? count.total_count : count.count;
      }
    },

    fitStatsToCompare(num, month) {
      let count;
      if (
          this.dateRangesStats.hasOwnProperty(this.reg) &&
          this.dateRangesStats[this.reg].hasOwnProperty("initial_dates") &&
          this.dateRange[this.reg].secondDate.start &&
          this.dateRange[this.reg].secondDate.end
      ) {
        count = this.dateRangesStats[this.reg].initial_dates.find(itm => {
          const monthName =
              itm.hasOwnProperty("date") &&
              moment(itm.date).format("MMMM") === month;
          if (monthName) {
            return moment(itm.date).date() === parseInt(num);
          }
        });
        if (count === undefined) {
          count = this.dateRangesStats[this.reg].secondary_dates.find(itm => {
            const monthName =
                itm.hasOwnProperty("date") &&
                moment(itm.date).format("MMMM") === month;
            if (monthName) {
              return moment(itm.date).date() === parseInt(num);
            }
          });
        }
      } else {
        return "";
      }

      if (count === undefined) {
        return "";
      } else {
        return count.difference ? parseInt(count.difference) : count.count;
      }
    },
    fitStatsToCompareTotal(num, month) {
      let count;
      if (
          this.dateRangesStats.hasOwnProperty(this.reg) &&
          this.dateRangesStats[this.reg].hasOwnProperty("initial_dates") &
          this.dateRange[this.reg].secondDate.start &&
          this.dateRange[this.reg].secondDate.end
      ) {
        count = this.dateRangesStats[this.reg].initial_dates.find(itm => {
          const monthName =
              itm.hasOwnProperty("date") &&
              moment(itm.date).format("MMMM") === month;
          if (monthName) {
            return moment(itm.date).date() === parseInt(num);
          }
        });
        if (count === undefined) {
          count = this.dateRangesStats[this.reg].secondary_dates.find(itm => {
            const monthName =
                itm.hasOwnProperty("date") &&
                moment(itm.date).format("MMMM") === month;
            if (monthName) {
              return moment(itm.date).date() === parseInt(num);
            }
          });
        }
      }

      if (count === undefined) {
        return "";
      } else {
        return count.difference_total ? parseInt(count.difference_total) : "";
      }
    },

    markTodayDay(day, month) {
      return (
          moment().date() === parseInt(day) && moment().format("MMMM") === month
      );
    },

    countSumAvgReg() {
      let sum;
      let sum_total;
      let mainObj = this.dateRangesStats[this.reg];

      if (mainObj.hasOwnProperty("initial_dates")) {
        let raw_data = this.dateRangesStats[this.reg].initial_dates.filter(
            day => {
              if (!this.countTheWeekends) {
                return (
                    day.hasOwnProperty("date") &&
                    moment(day.date).day() !== 0 &&
                    moment(day.date).day() !== 6
                );
              }
              return day.hasOwnProperty("date");
            }
        );
        if (mainObj.initial_dates.length > 0) {
          sum = this.newReduce(raw_data, "count");

          if (raw_data.some(key => key.count_total === undefined)) {
            sum_total = this.newReduce(raw_data, "total_count");
          }
        } else {
          sum = 0;
          sum_total = 0;
        }
        const count = raw_data;

        // filter counts zero
        //     .filter(
        //   day => day.count !== 0
        // );
        const count_total = raw_data;

        //     .filter(
        //   day => day.total_count !== 0
        // );

        const avg = sum / count.length;
        const avg_total = sum_total / count_total.length;
        return {
          sum: sum,
          sum_total: sum_total,
          count: count.length,
          count_total: count_total.length,
          avg: avg ? avg : 0,
          avg_total: avg_total ? avg_total : 0
        };
      } else {
        let raw_data = mainObj.filter(obj => {
          if (!this.countTheWeekends) {
            return (
                obj.hasOwnProperty("date") &&
                moment(obj.date).day() !== 0 &&
                moment(obj.date).day() !== 6
            );
          }
          return obj.hasOwnProperty("date");
        });
        if (mainObj.length > 0) {
          sum = this.newReduce(raw_data, "count");
          sum_total = sum;
          if (raw_data.some(key => key.count_total === undefined)) {
            sum_total = this.newReduce(raw_data, "total_count");
          }
          sum_total = sum_total ? sum_total : 0;
        } else {
          sum = 0;
          sum_total = 0;
        }
        const count = raw_data;

        //     .filter(
        //   day => day.count !== 0
        // );
        const count_total = raw_data;

        //     .filter(
        //   day => day.total_count !== 0
        // );
        const avg = sum / count.length;
        const avg_total = sum_total / count_total.length;

        let regDupStats = this.dateRangesStats[this.reg].filter(obj => {
          return obj.hasOwnProperty("dup_count");
        });
        if (regDupStats.length > 0) {
          regDupStats = regDupStats[0];
          this.regDupStatsReg = regDupStats.reg_count;
          // this.regDupStatsReg_total = regDupStats.reg_count_total;
          this.regDupStatsDup = regDupStats.dup_count;
          // this.regDupStatsDup_total = regDupStats.dup_count_total;
        } else {
          this.regDupStatsReg = null;
          this.regDupStatsReg_total = null;
          this.regDupStatsDup = null;
          this.regDupStatsDup_total = null;

          this.allTotalCount(sum, sum_total);
        }

        this.$store.commit("clients/setTotalSumForCrumbBtn", sum_total);
        return {
          sum: sum,
          sum_total: sum_total,
          count: count.length,
          count_total: count_total.length,
          avg: avg ? avg : 0,
          avg_total: avg_total ? avg_total : 0
        };
      }
    },

    countSumAvgRegCompare() {
      let sum;
      let sum_total;
      if (this.dateRangesStats[this.reg].hasOwnProperty("secondary_dates")) {
        let raw_data = this.dateRangesStats[this.reg].secondary_dates.filter(
            day => {
              if (!this.countTheWeekends) {
                return (
                    day.hasOwnProperty("date") &&
                    moment(day.date).day() !== 0 &&
                    moment(day.date).day() !== 6
                );
              }
              return day.hasOwnProperty("date");
            }
        );
        if (this.dateRangesStats[this.reg].secondary_dates.length > 0) {
          sum = this.newReduce(raw_data, "count");
          sum_total = sum;
          if (raw_data.some(key => key.count_total === undefined)) {
            let singleVal = 0;
            for (let i = 0; i < raw_data.length; i++) {
              singleVal = singleVal += raw_data[i].total_count;
            }
            sum_total = singleVal;
          }
        } else {
          sum = 0;
          sum_total = 0;
        }
        const count = raw_data.length;
        const count_total = this.dateRangesStats[
            this.reg
            ].secondary_dates.filter(day => day.total_count !== 0);
        const avg = sum / count;
        const avg_total = sum_total / count_total.length;

        return {
          sum: sum,
          sum_total: sum_total,
          count: count.length,
          count_total: count_total.length,
          avg: avg ? avg : 0,
          avg_total: avg_total ? avg_total : 0
        };
      }
    },

    updatePreset(tag, item, preset) {
      this.$emit("choosedTopTag");
      this.fetchAll = true;
      this.presetActive = [tag, item.label, this.reg];
      this.dateRange[this.reg] = {
        tag: tag,
        date: item.dateRange,
        secondDate: {
          start: null,
          end: null
        },
        preset: preset || null
      };
      this.showResetBtn = true;
      // update start active month

      this.setDateValue(tag);
    },

    updateSelected(tag, preset) {
      this.presetActive = [tag, preset, this.reg];
      this.setDateValue(tag);
    },
    setDateValue: async function(tag = this.reg) {
      this.dateRange.tag = tag;
      switch (tag) {
        case "REG":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            let tempObj = Object.assign({}, this.multiSelectChartData);
            tempObj.selectedSector = "register";
            this.$store.commit("clients/setMultiSelectChartData", [
              tempObj,
              "register"
            ]);
            this.selectedReg(this.dateRange[tag]);
          }
          break;
        case "LAST_MOD":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterLastMod(this.dateRange[tag]);
          }
          break;
        case "CA_F":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterScheduledCalls(this.dateRange[tag]);
          }
          break;
        case "CA_P":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterScheduledCallsPast(this.dateRange[tag]);
          }
          break;
        case "ASSIGN":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterAssign(this.dateRange[tag]);
          }
          break;
        case "TRA":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterTransfers(this.dateRange[tag]);
          }
          break;
        case "REF":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterReferrals(this.dateRange[tag]);
          }
          break;
        case "DEP":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterDeposits(this.dateRange[tag]);
          }
          break;
        case "LAST_MOD_TAG":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterLastModTag(this.dateRange[tag]);
          }
          break;
        case "SUP":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterSupport(this.dateRange[tag]);
          }
          break;
        case "LIVE":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.setLiveStats(this.dateRange[tag]);
          }
          break;
        case "NA_TAG":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterNaTag(this.dateRange[tag]);
          }
          break;
        case "BN_TAG":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterBnTag(this.dateRange[tag]);
          }
          break;
        case "LEAD_TAG":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterLeadTag(this.dateRange[tag]);
          }
          break;
        case "GR_ASGN":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterGroupTag(this.dateRange[tag]);
          }
          break;
        case "SHIFTS":
          if (this.dateRange[tag].date.start && this.dateRange[tag].date.end) {
            this.filterGroupTag(this.dateRange[tag]);
          }
          break;
        default:
          this.selectedReg(this.dateRange);
      }

      this.activeMonthStart = this.dateRange[tag].date.start.getMonth();
      this.activeYearStart = this.dateRange[tag].date.start.getFullYear();
      this.activeYearEnd = this.dateRange[tag].date.end.getFullYear();
      // this.$emit("selected", this.dateRange);
    },
    fetchScStatsEmit() {
      this.$emit("fetchScStats");
    },
    filterSCByToday(date) {
      // let tempObj = {
      //   date: {
      //    end: date,
      //    start: date,
      //   },
      //   preset: null,
      //   secondDate:{
      //    end: null,
      //    start: null
      //   },
      //
      // }
      // this.filterScheduledCalls(tempObj);
      this.$store.commit("clients/setCalendarDates", {
        calendar: "CA_F",
        dates: {
          start: date,
          end: date
        }
      });

      // this.$store.commit("clients/setSelectedCalendarType", {
      //   alias: "CA_F",
      //   preset: "TODAY"
      // });
      this.$emit("pushTCTag");
    },
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
            ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
            : Math.sign(num) * Math.abs(num);
      }
    },
    allTotalCount(val, total_val) {
      this.totalCount = val;
      this.totalCalVal = total_val;
    },
    fetchTableData(exclude = null) {
      // this.fetchRegTodayTableStats();
      // this.fetchRegYesterdayTableStats();
      // this.fetchRegLast7TableStats();
      // this.fetchRegLast30TableStats();
      // !exclude && this.fetchRegLast90TableStats();
      // !exclude && this.fetchRegLast180TableStats();
      // this.fetchRegMonthTableStats();
      // this.fetchRegLastMonthTableStats();
    },
    excludeDup() {
      if (!this.isDupExcluded) {
        this.isDupExcluded = true;
        this.selectedTopFilter = "REG";
        return this.$emit("filterexdup", true);
      }
      if (this.isDupExcluded) {
        this.isDupExcluded = false;
        return this.$emit("filterexdup", false);
      }
    },
    setMainFilterTab: function(tag, cond = 0) {
      if (
          this.selectedTopFilter !== "ALL" &&
          this.selectedTopFilter === tag &&
          !cond
      ) {
        return;
      }
      if (this.selectedTopFilter === "ALL") {
        tag === "REG"
            ? (this.selectedTopFilter = "DUP")
            : (this.selectedTopFilter = "REG");
      } else {
        tag !== this.selectedTopFilter ? (this.selectedTopFilter = "ALL") : "";
      }

      if (cond) {
        this.selectedTopFilter = tag;
      }
      this.$store.commit(
          "clients/setRegCalFilterNoDate",
          this.selectedTopFilter
      );

      if (this.reg === "LIVE") {
        this.$store.commit("clients/setUpdateLiveChart", {
          dates: this.dateRange[this.reg].date,
          lead_filter: this.selectedTopFilter
        });
      }
      // this.$emit("selected", this.dateRange);
      // this.selectedReg(tag);
    },

    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },

    filterExDup(val) {
      this.$emit("filterexdup", val);
      setTimeout(() => {
        this.fetchRegCalendar();
      }, 2000);
    },
    setLiveStats(val) {
      this.$store.commit("clients/setUpdateLiveChart", {
        dates: val.date,
        lead_filter: this.selectedTopFilter
      });
    },

    selectedReg(val) {
      let date = val.date;
      this.selectedRegPreset = val.preset;
      if (date.end === null) {
        date.end = date.start;
        this.regDateRange = date;
        return this.$emit("regDate", val);
      }
      this.regDateRange = date;
      if (!this.showReset && this.clientsTableSelectedMainTab === "clients") {
        this.$store.commit("clients/setClientsTableSelectedMainTab", "total");
        this.$store.commit("clients/setClientsTableTab", "total");
      }
      this.$emit("regDate", val);
    },
    selectedShifts(val) {
      let date = val.date;
      this.selectedRegPreset = val.preset;
      if (date.end === null) {
        date.end = date.start;
        this.shiftsDateRange = date;
        return this.$emit("shifts_date", val);
      }
      this.shiftsDateRange = date;
      this.$emit("shifts_date", val);
    },

    filterSupport(val) {
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        this.supDateRange = date;
        return this.$emit("filter_support", val);
      }
      this.supDateRange = date;
      this.$emit("filter_support", val);
    },

    filterNaTag(val) {
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        this.naTagDateRange = date;
        return this.$emit("filter_na_tag", val);
      }
      this.naTagDateRange = date;
      this.$emit("filter_na_tag", val);
      this.$emit("selectTag", "na");
    },
    filterBnTag(val) {
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        return this.$emit("filter_bn_tag", val);
      }
      this.$emit("filter_bn_tag", val);
      this.$emit("selectTag", "bn");
    },
    filterLeadTag(val) {
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        this.leadTagDateRange = date;
        return this.$emit("filter_lead_tag", val);
      }
      this.leadTagDateRange = date;
      this.$emit("filter_lead_tag", val);
      this.$emit("selectTag", "ld");
    },
    filterGroupTag(val) {
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        this.groupTagDateRange = date;
        return this.$emit("filter_group_tag", val);
      }
      this.groupTagDateRange = date;
      this.$emit("filter_group_tag", val);
    },

    filterReferrals(val) {
      this.selectedRegPreset = val.preset;
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        this.refDateRange = date;
        return this.$emit("filter_referrals", val);
      }
      this.refDateRange = date;
      this.$emit("filter_referrals", val);
      this.$emit("selectTag", "rf");
    },

    filterDeposits(val) {
      this.selectedRegPreset = val.preset;
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        this.depDateRange = date;
        return this.$emit("filter_deposits", val);
      }
      this.depDateRange = date;
      this.$emit("filter_deposits", val);
      this.$emit("selectTag", "dp");
    },

    filterTransfers(val) {
      this.selectedRegPreset = val.preset;
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        this.tranDateRange = date;
        return this.$emit("filter_transfers", val);
      }
      this.tranDateRange = date;
      this.$emit("filter_transfers", val);
      this.$emit("selectTag", "tr");
    },

    filterAssign(val) {
      this.selectedCalTab = "ASSIGN";
      this.selectedRegPreset = val.preset;
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        this.assignDateRange = date;
        return this.$emit("filter_assign", val);
      }
      this.assignDateRange = date;
      this.$emit("filter_assign", val);
    },

    filterScheduledCalls(val) {
      val.tag = "sc";
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        this.caDateRange = date;
        return this.$emit("filter_ca", val);
      }
      this.caDateRange = date;
      this.$emit("filter_ca", val);
      this.$emit("selectTag", val.tag);
    },

    filterScheduledCallsPast(val) {
      const date = val.date;
      val.tag = "sc-p";
      // val.tag = "sc";
      if (date.end === null) {
        date.end = date.start;
        this.caPastDateRange = date;
        return this.$emit("filter_ca_past", val);
      }
      this.caDateRange = date;
      this.$emit("filter_ca_past", val);
      this.$emit("selectTag", val.tag);
    },

    filterLastMod(val) {
      this.selectedRegPreset = val.preset;
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        this.modDateRange = date;
        return this.$emit("filter_lm", val);
      }
      this.modDateRange = date;
      this.$emit("filter_lm", val);
    },

    filterLastModTag(val) {
      this.selectedCalTab = "LAST_MOD_TAG";
      const date = val.date;
      if (date.end === null) {
        date.end = date.start;
        this.modTagDateRange = date;
        return this.$emit("filter_lm_tag", val);
      }
      this.modTagDateRange = date;
      this.$emit("filter_lm_tag", val);
    },

    formatDateTable(date) {
      if (date === null || date === undefined) {
        return "none";
      }
      return moment(String(date)).format("DD/MM/YY");
    },

    fetchRegCalendar(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        let query = Object.assign({}, this.queryObject);
        if (!query.dup_exclude && this.selectedTopFilter === "REG") {
          query.dup_exclude = true;
        }
        this.requestRegCalDaysBusy = true;
        if (
            this.dateRange[cal].secondDate.start &&
            this.dateRange[cal].secondDate.end
        ) {
          this.$store.commit("clients/setLoading", true);
          //compare two dates
          let tag = "registration";
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];
          delete query.registered_on_from;
          delete query.registered_on_to;
          this.calHashes[cal] = this.getHash();
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: { ...query, hash: this.calHashes[cal] }
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                if (
                    this.dateRange[cal].secondDate.start &&
                    this.dateRange[cal].secondDate.end &&
                    this.calHashes[cal] === res.config.params.hash
                ) {
                  this.dateRangesStats[cal] = res.data;
                }
                this.requestRegCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestRegCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        } else {
          this.$store.commit("clients/setLoading", true);
          this.calHashes[cal] = this.getHash();
          apiClientCreator(`client/stats/calendar/reg/days`)
              .get("", {
                params: { ...query, hash: this.calHashes[cal] }
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                if (
                    this.dateRange[cal].date.start &&
                    this.dateRange[cal].date.end &&
                    this.calHashes[cal] === res.config.params.hash
                ) {
                  this.dateRangesStats[cal] = res.data;
                }
                this.requestRegCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestRegCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });

          apiClientCreator(`client/stats/calendar/hours_stats/reg`)
              .get("", {
                params: { ...query, hash: this.calHashes[cal] }
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                if (this.calHashes[cal] === res.config.params.hash) {
                  this.hoursRangesStats[cal] = res.data;
                  this.requestRegCalDaysBusy = false;
                  this.$store.commit("clients/setLoading", false);
                }
              })
              .catch(err => {
                this.requestRegCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        }
      }

      if (!this.selectedHours[cal].from && !this.selectedHours[cal].to) {
        this.hoursRangesStats[cal] = [];
      }

      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }
    },

    async fetchSupportStats(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        let query = Object.assign({}, this.queryObject);
        if (!query.dup_exclude && this.selectedTopFilter === "REG") {
          query.dup_exclude = true;
        }
        this.requestSupportCalDaysBusy = true;
        if (
            this.dateRange[cal].secondDate.start &&
            this.dateRange[cal].secondDate.end
        ) {
          this.$store.commit("clients/setLoading", true);
          //compare two dates
          let tag = "support";
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];
          delete query.support_at_from;
          delete query.support_at_to;
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: query,
                cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.dateRangesStats[cal] = res.data;
                this.requestSupportCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestSupportCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        } else {
          apiClientCreator(`client/stats/calendar/support/days`)
              .get("", {
                params: this.queryObject,
                cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.dateRangesStats[cal] = res.data;
                this.requestSupportCalDaysBusy = false;
              })
              .catch(err => {
                this.requestSupportCalDaysBusy = false;
              });
        }
      }

      if (!this.selectedHours[cal].from && !this.selectedHours[cal].to) {
        this.hoursRangesStats[cal] = [];
      }

      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }
    },

    fetchDepositsStats(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        this.requestDepCalDaysBusy = true;
        if (
            this.dateRange[cal].secondDate.start &&
            this.dateRange[cal].secondDate.end
        ) {
          this.$store.commit("clients/setLoading", true);
          //compare two dates
          let tag = "deposits";
          let query = Object.assign({}, this.queryObject);
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];
          delete query.deposit_at_from;
          delete query.deposit_at_to;
          this.calHashes[cal] = this.getHash();
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: { ...query, hash: this.calHashes[cal] }
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                if (
                    this.dateRange[cal].secondDate.start &&
                    this.dateRange[cal].secondDate.end &&
                    this.calHashes[cal] === res.config.params.hash
                ) {
                  this.dateRangesStats[cal] = res.data;
                  this.requestDepCalDaysBusy = false;
                  this.$store.commit("clients/setLoading", false);
                }
              })
              .catch(err => {
                this.requestDepCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);

              });
        } else {
          this.$store.commit("clients/setLoading", true);
          this.calHashes[cal] = this.getHash();

          apiClientCreator(`client/stats/calendar/dep/days`)
              .get("", {
                params: { ...this.queryObject, hash: this.calHashes[cal] }
              })
              .then(res => {
                if (
                    this.dateRange[cal].date.start &&
                    this.dateRange[cal].date.end &&
                    this.calHashes[cal] === res.config.params.hash
                ) {
                  this.dateRangesStats[cal] = res.data;
                  this.$store.commit("clients/setLoading", false);
                  this.requestDepCalDaysBusy = false;
                }
              })
              .catch(err => {
                this.$store.commit("clients/setLoading", false);
                this.requestDepCalDaysBusy = false;
              });

          apiClientCreator(`client/stats/calendar/hours_stats/${cal}`)
              .get("", {
                params: { ...this.queryObject, hash: this.calHashes[cal] }
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                if (this.calHashes[cal] === res.config.params.hash) {
                  this.hoursRangesStats[cal] = res.data;
                }
              })
              .catch(err => {
              });
        }
      }

      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }

      if (
          !this.selectedHours[this.reg].from &&
          !this.selectedHours[this.reg].to
      ) {
        this.hoursRangesStats[cal] = [];
      }
    },

    async fetchNaTagStats(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        this.requestDepCalDaysBusy = true;
        if (
            this.dateRange[cal].secondDate.start &&
            this.dateRange[cal].secondDate.end
        ) {
          this.$store.commit("clients/setLoading", true);
          //compare two dates
          let tag = "na_tag";
          let query = Object.assign({}, this.queryObject);
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];
          delete query.deposit_at_from;
          delete query.deposit_at_to;
          this.calHashes[cal] = this.getHash();
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: { ...query, hash: this.calHashes[cal] }
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                if (
                    this.dateRange[cal].secondDate.start &&
                    this.dateRange[cal].secondDate.end &&
                    this.calHashes[cal] === res.config.params.hash
                ) {
                  this.dateRangesStats[cal] = res.data;
                  this.requestDepCalDaysBusy = false;
                  this.$store.commit("clients/setLoading", false);
                }
              })
              .catch(err => {
                this.requestDepCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        } else {
          this.$store.commit("clients/setLoading", true);
          this.calHashes[cal] = this.getHash();
          if (this.dateRange[cal].date.start && this.dateRange[cal].date.end) {
            apiClientCreator(`client/stats/calendar/na_tag/days`)
                .get("", {
                  params: { ...this.queryObject, hash: this.calHashes[cal] }
                })
                .then(res => {
                  if (
                      this.dateRange[cal].date.start &&
                      this.dateRange[cal].date.end &&
                      this.calHashes[cal] === res.config.params.hash
                  ) {
                    this.dateRangesStats[cal] = res.data;
                    this.$store.commit("clients/setLoading", false);
                    this.requestDepCalDaysBusy = false;
                  }
                })
                .catch(err => {
                  this.$store.commit("clients/setLoading", false);
                  this.requestDepCalDaysBusy = false;
                });
          }
          apiClientCreator(`client/stats/calendar/hours_stats/${cal}`)
              .get("", {
                params: { ...this.queryObject, hash: this.calHashes[cal] }
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                if (this.calHashes[cal] === res.config.params.hash) {
                  this.hoursRangesStats[cal] = res.data;
                }
              })
              .catch(err => {
              });
        }
      }

      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }

      if (!this.selectedHours[cal].from && !this.selectedHours[cal].to) {
        this.hoursRangesStats[cal] = [];
      }
    },

    async fetchBnTagStats(cal) {
      if (!(this.dateRange[cal].date.start && this.dateRange[cal].date.end)) {
        return;
      }
      this.$store.commit("clients/setLoading", true);
      this.calHashes[cal] = this.getHash();
      const hash = this.calHashes[cal];
      const params = {
        ...this.queryObject,
        last_modified_bn_from: moment(this.dateRange[cal].date.start).format("YYYY-MM-DD"),
        last_modified_bn_to: moment(this.dateRange[cal].date.end).format("YYYY-MM-DD"),
        hash
      };
      const token = localStorage.getItem("user-token");
      const bnAxios = axios.create({
        baseURL: Globals.crm_api_server_endpoint + "client/stats/calendar/bn_tag/days",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token
        }
      });
      bnAxios.get("", { params })
        .then(res => {
          if (this.dateRange[cal].date.start && this.dateRange[cal].date.end && this.calHashes[cal] === res.config.params.hash) {
            this.dateRangesStats[cal] = res.data;
            this.$store.commit("clients/setLoading", false);
            this.requestBnCalBusy = false;
          }
        })
        .catch(() => {
          this.$store.commit("clients/setLoading", false);
          this.requestBnCalBusy = false;
        });
    },
    async fetchLeadTagStats(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        this.requestDepCalDaysBusy = true;
        if (
          this.dateRange[cal].secondDate.start &&
          this.dateRange[cal].secondDate.end
        ) {
          this.$store.commit("clients/setLoading", true);
          //compare two dates
          let tag = "lead_tag";
          let query = Object.assign({}, this.queryObject);
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];
          delete query.deposit_at_from;
          delete query.deposit_at_to;
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: query
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.dateRangesStats[cal] = res.data;
                this.requestDepCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestDepCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        } else {
          this.$store.commit("clients/setLoading", true);
          if (this.checkIfDateChecked(cal)) {
            apiClientCreator(`client/stats/calendar/lead_tag/days`)
                .get("", {
                  params: this.queryObject,
                  cancelToken: apiClientCreator.source.token
                })
                .then(res => {
                  this.dateRangesStats[cal] = res.data;
                  this.$store.commit("clients/setLoading", false);
                  this.requestDepCalDaysBusy = false;
                })
                .catch(err => {
                  this.$store.commit("clients/setLoading", false);
                  this.requestDepCalDaysBusy = false;
                });
          }
          apiClientCreator(`client/stats/calendar/hours_stats/${cal}`)
              .get("", {
                params: this.queryObject
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.hoursRangesStats[cal] = res.data;
              })
              .catch(err => {
              });
        }
      }

      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }

      if (!this.selectedHours[cal].from && !this.selectedHours[cal].to) {
        this.hoursRangesStats[cal] = [];
      }
    },

    async fetchGroupTagStats(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        this.requestDepCalDaysBusy = true;
        if (
            this.dateRange[cal].secondDate.start &&
            this.dateRange[cal].secondDate.end
        ) {
          this.$store.commit("clients/setLoading", true);
          //compare two dates
          let tag = "gr_asnmt";
          let query = Object.assign({}, this.queryObject);
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];
          delete query.deposit_at_from;
          delete query.deposit_at_to;
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: query
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.dateRangesStats[cal] = res.data;
                this.requestDepCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestDepCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        } else {
          this.$store.commit("clients/setLoading", true);
          if (this.checkIfDateChecked(cal)) {
            apiClientCreator(`client/stats/calendar/group_tag/days`)
                .get("", {
                  params: this.queryObject,
                  cancelToken: apiClientCreator.source.token
                })
                .then(res => {
                  this.dateRangesStats[cal] = res.data;
                  this.$store.commit("clients/setLoading", false);
                  this.requestDepCalDaysBusy = false;
                })
                .catch(err => {
                  this.$store.commit("clients/setLoading", false);
                  this.requestDepCalDaysBusy = false;
                });
          }
          apiClientCreator(`client/stats/calendar/hours_stats/${cal}`)
              .get("", {
                params: this.queryObject
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.hoursRangesStats[cal] = res.data;
              })
              .catch(err => {
              });
        }
      }

      if (!this.selectedHours[cal].from && !this.selectedHours[cal].to) {
        this.hoursRangesStats[cal] = [];
      }

      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }
    },

    async fetchReferralStats(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        this.$store.commit("clients/setLoading", true);
        this.requestRefCalDaysBusy = true;
        if (
            this.dateRange[cal].secondDate.start &&
            this.dateRange[cal].secondDate.end
        ) {
          //compare two dates
          let tag = "referrals";
          let query = Object.assign({}, this.queryObject);
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];
          delete query.last_referral_from;
          delete query.last_referral_to;
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: query
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.dateRangesStats[cal] = res.data;
                this.requestRefCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestRefCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        } else {
          if (this.checkIfDateChecked(cal)) {
            apiClientCreator(`client/stats/calendar/ref/days`)
                .get("", {
                  params: this.queryObject,
                  cancelToken: apiClientCreator.source.token
                })
                .then(res => {
                  this.dateRangesStats[cal] = res.data;
                  this.requestRefCalDaysBusy = false;
                  this.$store.commit("clients/setLoading", false);
                })
                .catch(err => {
                  this.$store.commit("clients/setLoading", false);
                  this.requestRefCalDaysBusy = false;
                });
          }
          apiClientCreator(`client/stats/calendar/hours_stats/${cal}`)
              .get("", {
                params: this.queryObject
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.hoursRangesStats[cal] = res.data;
              })
              .catch(err => {
              });
        }
      }

      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }

      if (!this.selectedHours[cal].from && !this.selectedHours[cal].to) {
        this.hoursRangesStats[cal] = [];
      }
    },

    async fetchAssignStats(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        this.requestAssignCalBusy = true;

        if (
            this.dateRange[cal].secondDate.start &&
            this.dateRange[cal].secondDate.end
        ) {
          this.$store.commit("clients/setLoading", true);
          //compare two dates
          let tag = "assignments";
          let query = Object.assign({}, this.queryObject);
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];
          delete query.assigned_at_from;
          delete query.assigned_at_to;
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: query
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.dateRangesStats[cal] = res.data;
                this.requestAssignCalBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestAssignCalBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        } else {
          this.$store.commit("clients/setLoading", true);
          if (this.checkIfDateChecked(cal)) {
            apiClientCreator(`client/stats/calendar/assign/days`)
                .get("", {
                  params: this.queryObject,
                  cancelToken: apiClientCreator.source.token
                })
                .then(res => {
                  this.dateRangesStats[cal] = res.data;
                  this.requestAssignCalBusy = false;
                  this.$store.commit("clients/setLoading", false);
                })
                .catch(err => {
                  this.requestAssignCalBusy = false;
                  this.$store.commit("clients/setLoading", false);
                });
          }
          apiClientCreator(`client/stats/calendar/hours_stats/${cal}`)
              .get("", {
                params: this.queryObject
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.hoursRangesStats[cal] = res.data;
              })
              .catch(err => {
              });
        }
      }
      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }

      if (!this.selectedHours[cal].from && !this.selectedHours[cal].to) {
        this.hoursRangesStats[cal] = [];
      }
    },

    async fetchTransfersStats(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        this.$store.commit("clients/setLoading", true);
        this.requestTransCalDaysBusy = true;
        if (
            this.dateRange[cal].secondDate.start &&
            this.dateRange[cal].secondDate.end
        ) {
          //compare two dates
          let tag = "transfers";
          let query = Object.assign({}, this.queryObject);
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];
          delete query.last_transfer_from;
          delete query.last_transfer_to;
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: query
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.dateRangesStats[cal] = res.data;
                this.requestTransCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestTransCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        } else {
          if (this.checkIfDateChecked(cal)) {
            apiClientCreator(`client/stats/calendar/trans/days`)
                .get("", {
                  params: this.queryObject,
                  cancelToken: apiClientCreator.source.token
                })
                .then(res => {
                  this.dateRangesStats[cal] = res.data;
                  this.requestTransCalDaysBusy = false;
                  this.$store.commit("clients/setLoading", false);
                })
                .catch(err => {
                  this.requestTransCalDaysBusy = false;
                  this.$store.commit("clients/setLoading", false);
                });
          }
          apiClientCreator(`client/stats/calendar/hours_stats/${cal}`)
              .get("", {
                params: this.queryObject
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.hoursRangesStats[cal] = res.data;
              })
              .catch(err => {
              });
        }
      }

      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }

      if (!this.selectedHours[cal].from && !this.selectedHours[cal].to) {
        this.hoursRangesStats[cal] = [];
      }
    },

    fetchCaStats(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        this.$store.commit("clients/setLoading", true);
        this.requestCagCalDaysBusy = true;
        if (
            this.dateRange[cal].secondDate.start &&
            this.dateRange[cal].secondDate.end
        ) {
          //compare two dates
          let tag = "scheduled_calls";
          let query = Object.assign({}, this.queryObject);
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];

          delete query.scheduled_call_to_from;
          delete query.scheduled_call_to_to;
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: query
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.dateRangesStats[cal] = res.data;
                this.requestCaCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestCaCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        } else {
          this.$store.commit("clients/setLoading", true);
          if (this.checkIfDateChecked(cal)) {
            this.calHashes[cal] = this.getHash();
            apiClientCreator(`client/stats/calendar/sc/days`)
                .get("", {
                  params: { ...this.queryObject, hash: this.calHashes[cal] },
                  cancelToken: apiClientCreator.source.token
                })
                .then(res => {
                  if (this.calHashes[cal] === res.config.params.hash) {
                    this.dateRangesStats[cal] = res.data;
                    this.requestCaCalDaysBusy = false;
                    this.$store.commit("clients/setLoading", false);
                  }
                })
                .catch(err => {
                  this.requestCaCalDaysBusy = false;
                  this.$store.commit("clients/setLoading", false);
                });
          }
          apiClientCreator(`client/stats/calendar/hours_stats/${cal}`)
              .get("", {
                params: this.queryObject
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.hoursRangesStats[cal] = res.data;
              })
              .catch(err => {
              });
        }
      }

      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }

      if (!this.selectedHours[cal].from && !this.selectedHours[cal].to) {
        this.hoursRangesStats[cal] = [];
      }
    },

    async fetchCaPastStats(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        this.$store.commit("clients/setLoading", true);
        this.requestCaPastCalDaysBusy = true;
        if (
            this.dateRange[cal].secondDate.start &&
            this.dateRange[cal].secondDate.end
        ) {
          //compare two dates
          let tag = "scheduled_calls_past";
          let query = Object.assign({}, this.queryObject);
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];

          delete query.last_modified_personal_from;
          delete query.last_modified_personal_to;
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: query
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.dateRangesStats[cal] = res.data;
                this.requestCaPastCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestCaPastCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        } else {
          this.$store.commit("clients/setLoading", true);
          if (this.checkIfDateChecked(cal)) {
            apiClientCreator(`client/stats/calendar/sc_past/days`)
                .get("", {
                  params: this.queryObject,
                  cancelToken: apiClientCreator.source.token
                })
                .then(res => {
                  this.dateRangesStats[cal] = res.data;
                  this.requestCaPastCalDaysBusy = false;
                  this.$store.commit("clients/setLoading", false);
                })
                .catch(err => {
                  this.requestCaPastCalDaysBusy = false;
                  this.$store.commit("clients/setLoading", false);
                });
          }
          apiClientCreator(`client/stats/calendar/hours_stats/${cal}`)
              .get("", {
                params: this.queryObject
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.hoursRangesStats[cal] = res.data;
              })
              .catch(err => {
              });
        }
      }

      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }

      if (!this.selectedHours[cal].from && !this.selectedHours[cal].to) {
        this.hoursRangesStats[cal] = [];
      }
    },

    async fetchLastModStats(cal) {
      if (
          (this.dateRange[cal].date.start && this.dateRange[cal].date.end) ||
          (this.selectedHours[cal].from && this.selectedHours[cal].to)
      ) {
        this.requestLastModCalDaysBusy = true;
        this.$store.commit("clients/setLoading", true);
        if (
            this.dateRange[cal].secondDate.start &&
            this.dateRange[cal].secondDate.end
        ) {
          //compare two dates
          let tag = "last_modified";
          let query = Object.assign({}, this.queryObject);
          query.initial_dates = [
            moment(this.dateRange[cal].date.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].date.end).format("DD-MM-YYYY")
          ];
          query.secondary_dates = [
            moment(this.dateRange[cal].secondDate.start).format("DD-MM-YYYY"),
            moment(this.dateRange[cal].secondDate.end).format("DD-MM-YYYY")
          ];
          apiClientCreator(`client/stats/calendar/diff/${tag}`)
              .get("", {
                params: query
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.dateRangesStats[cal] = res.data;
                this.requestLastModCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestLastModCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        } else {
          this.$store.commit("clients/setLoading", true);
          if (this.checkIfDateChecked(cal)) {
            apiClientCreator(`client/stats/calendar/mod/days`)
                .get("", {
                  params: this.queryObject,
                  cancelToken: apiClientCreator.source.token
                })
                .then(res => {
                  this.dateRangesStats[cal] = res.data;
                  this.requestLastModCalDaysBusy = false;
                  this.$store.commit("clients/setLoading", false);
                })
                .catch(err => {
                  this.requestLastModCalDaysBusy = false;
                  this.$store.commit("clients/setLoading", false);
                });
          }
          apiClientCreator(`client/stats/calendar/hours_stats/last_mod`)
              .get("", {
                params: this.queryObject
                //  cancelToken: apiClientCreator.source.token
              })
              .then(res => {
                this.hoursRangesStats[cal] = res.data;
                this.requestLastModCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              })
              .catch(err => {
                this.requestLastModCalDaysBusy = false;
                this.$store.commit("clients/setLoading", false);
              });
        }
      }

      if (!this.dateRange[cal].date.start && !this.dateRange[cal].date.end) {
        this.dateRangesStats[cal] = [];
      }

      if (!this.selectedHours[cal].from && !this.selectedHours[cal].to) {
        this.hoursRangesStats[cal] = [];
      }
    },

    setHourFilter(hours) {
      this.$emit("setHoursFilter", hours);
    },

    bounceEffect() {
      let element = document.getElementsByClassName("animate");
      $(element).addClass("date-number-anim");
      setTimeout(() => {
        $(element).removeClass("date-number-anim");
      }, 1000);
    },

    waveEffect() {
      let element = document.getElementsByClassName("wrapper-border");
      $(element).addClass("inner-layer-anim");
      setTimeout(() => {
        $(element).removeClass("inner-layer-anim");
      }, 1000);
    },

    checkIfDateChecked(cal) {
      return this.dateRange[cal].date.start && this.dateRange[cal].date.end;
    }
  }
};
</script>

<style lang="scss" scoped>
.paint_current_week_grey {
  background-color: #666565;
}

.paint_user_shift_choice {
  background-color: orange;
}

.paint_user_shift_choice_approved {
  background-color: green !important;
}

.shift-choice-overview {
  background-color: white;
  position: absolute;
  top: 240px;
  width: 355px;
  border-radius: 5px;
  height: 300px;
  color: black;
  border: 1px solid #b5b5b5;
  z-index: 1;
}

div {
  user-select: none;
}

.calendar-wrapper {
  /*display: inline-block;*/
  text-align: center;
  background-color: #fff;
  //padding-top: 12px;
  padding-right: 12px;
  padding-left: 12px;

  /*
          float: left;
        */
}

.edit-text-cancel-btn-cal {
  color: red !important;
}

.edit-text-cancel-btn-cal:hover {
  color: white !important;
}

.edit-text-cancel-btn {
  color: red !important;
  /*margin-left: 10px;*/
  /*transition: 0.2s;*/
}

.months-text-new {
  font-weight: bold;
  font-size: 11px;
  //  word-break: break-word;
  margin-left: 2px;
  display: flex;
  width: calc(45%);
  justify-content: center;
}

.calendar {
  font-size: 12px;
  margin-top: 5px;
}

.months-text-new .left {
  float: left;
  cursor: pointer;
  width: 16px;
  margin: 3px 5px 0px;
}

.months-text-new .left:hover {
  background-color: #ddf1d5;
}

.months-text-new .right {
  float: right;
  cursor: pointer;
  width: 16px;
  margin: 3px 5px 0px;
}

.months-text-new .right:hover {
  background-color: #ddf1d5;
}

.calendar ul {
  list-style-type: none;
}

.calendar-btn-reset {
  width: 42px;
  height: 22px;
  background: #c62828;
  color: #fff;
  border: none;
  padding: 5px;
  line-height: 2px;
  font-size: 8pt;
  border-radius: 3px;
}

.days-numbers {
  font-weight: bold;
  font-size: 9px;
  cursor: pointer;
  margin-bottom: 0px;
}

.choose-dates {
  /*border: 1px solid black;*/
  //width: 116px;
  height: 20px;
  float: right;
}

.main-row {
  display: flex;
  //border: 1px solid #ddd;
  min-height: 67px;
  //background-color: #fff;
  flex-direction: row;
}

.tabs-selector {
  display: flex;
  flex-direction: row;
  max-width: 100%;
  height: 39px;
}

.main-cal-div {
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  //border-top: 1px solid #b7b7b7;
  background-color: var(--br-color);
}

.main-cal-div:first-child {
  margin-bottom: 2px;
  border-radius: 0px 0px 7px 0px;
}

.main-cal-div:nth-child(2) {
  border-radius: 0px 7px 0px 0px;
}

.wrapper-border {
  border-bottom: 1px solid var(--br-color);
}

.bars-icon {
  color: cadetblue;
  height: 28px;
}

.selection-bar {
  background-color: #fff;
  min-width: 100%;
  height: 28px;
}

.dropdown-menu.bottom {
  top: unset !important;
  bottom: 100% !important;
}

.dropdown-menu.ul-cals {
  border-radius: 0px;
  top: 60% !important;
}

.ul-cals li {
  margin: 5px;
}

.ul-cals li i {
  margin-right: 20px;
  color: #96281b;
}

.ul-cals li:not(:last-child):after {
  //border-bottom: 1px solid rgba(116, 171, 203, 0.5);
  content: ""; /* This is necessary for the pseudo element to work. */
  display: block; /* This will put the pseudo element on its own line. */
  margin: 0 auto; /* This will center the border. */
  width: 70%; /* Change this to whatever width you want. */

  border-bottom: 1px solid rgba(222, 220, 220, 0.36); /* This creates the border. Replace black with whatever color you want. */
}

.ul-cals a {
  font-family: "Montserrat", Montserrat, serif;
  font-size: 12px;
  text-transform: uppercase;
  min-width: 90px;
  cursor: pointer;
}

.ul-filters li {
  margin: 5px;
}

.ul-filters li i {
  margin-right: 20px;
  color: #96281b;
}

//.ul-filters li:not(:last-child):after {
//  //border-bottom: 1px solid rgba(116, 171, 203, 0.5);
//  content: ""; /* This is necessary for the pseudo element to work. */
//  display: block; /* This will put the pseudo element on its own line. */
//  margin: 0 auto; /* This will center the border. */
//  width: 70%; /* Change this to whatever width you want. */
//
//  border-bottom: 1px solid rgba(222, 220, 220, 0.36);
//}
.ul-filters a {
  font-family: "Montserrat", Montserrat, serif;
  font-size: 12px;
  text-transform: uppercase;
  min-width: 50px;
  cursor: pointer;
}

.activedrop > a {
  background-color: #7eb5dd;
  color: #fff !important;
}

.activedrop > a:hover {
  background-color: #7eb5dd;
  color: #000 !important;
}

.ranges-section {
  display: flex;
  flex-direction: column;
  min-width: 220px;
}

.date-ranges-big {
  display: flex;
  justify-content: center;
  font-size: 11px;
  padding: 1px 1px 1px;
  width: 100%;
  height: 24px;
  border: none;
  outline: none;
  text-align: left;
  font-family: "Montserrat", Montserrat, serif;
  background: #ffffff;
  color: #1c1c1c;
}

.date-ranges-small {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  padding: 7px 4px 3px;
  width: 100%;
  height: 28px;
  border: none;
  outline: none;
  font-family: "Montserrat", Montserrat, serif;
}

.presets-nav {
  margin: 0.5px;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
  position: relative;
  background: white;
  float: right;
  text-transform: capitalize;
  width: 100%;
}

.presets-nav.style2 li {
  /*border-radius: 5px 5px 0px 0px;*/
  transition: transform 0.1s ease;
}

.presets-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.presets-nav li {
  max-width: 100%;
  min-width: 15px;
  height: 28px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 13px;
  text-align: center;
  vertical-align: middle;
  line-height: 20px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.presets-nav.style2 li:not(.empty):hover {
  transform: translateY(0px);
}

.presets-nav.style2 li.active {
  //border-bottom: 3px solid #d179ff !important;
  /*color: #44a2d2;*/
  /*
    border-bottom: none !important;
  */

  background-color: #efefef;
  font-weight: bold;
  color: #000;
}

.presets-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.calendars_weeks {
  margin: 2px;
  padding: 8px 0;
  width: auto;
  background-color: lightgray;
  height: 32px;
}

.calendars_weeks th {
  text-align: center;
}

.calendars_weeks li {
  display: inline-block;
  width: 13.6%;
  color: #999;
  text-align: center;
  font-family: "Montserrat";
  color: black;
  font-weight: bold;
}

.calendars_days {
  min-width: fit-content;
  //margin: auto;
  display: flex;
  //margin: 3px;
  margin-bottom: 0px;
  padding: 0px;
  flex-direction: column;
}

.calendars_days li {
  list-style: none;
  color: #333;
  text-align: center;
  cursor: pointer;
  width: 49px;
  font-size: 10px;
  position: relative;
  border-radius: 5px;
  margin: 1px;
  height: 64px;
}

.calendars_presets li {
  line-height: 2.5em;
  //width: auto;
  display: block;
  //padding-right: 3px;
}

.calendars_days li:hover {
  background: #eee;
  color: #000;
}

.calendars_days_disabled {
  pointer-events: none;
  display: none;
  min-width: fit-content;
}

.calendars_days_selected {
  background: #c1c1c1;
  color: #000 !important;
  border: #bbdefb 1px solid;
}

.calendars_days_selected_in_compare {
  background: #b6e3ff;
  color: #000 !important;
  border: #4d82cb 1px solid;
}

.calendars_days_in-range {
  border: 0.4px solid #bbdefb !important;
  background-color: #dadada;
}

.calendars_days_in-range_compare {
  border: 0.4px solid #bbdefb !important;
  background: #c1e8ff;
}

.calendars_days_in-today {
  border: 1px solid #9e9e9e;
}

.calendars_days_in-today-users {
  border: 1px solid #bf0303 !important;
  background-color: #000000 !important;
  color: white;
}

.days-months-container {
  display: flex;
}

.selected-cal {
  font-family: "Montserrat", Montserrat, serif;
  padding: 5px;
  background-color: #efefef;
  color: #44a2d2;
  //font-weight: bold;
  width: 90px;
  cursor: pointer;
  height: 28px;
  font-size: 11px;
}

.filters-container {
  //display: flex;
  flex-direction: row;
  flex: 2;
  min-height: 100%;
}

.filters-unit {
  //margin: auto;
  display: flex;
  //margin: 3px;
  margin-bottom: 0px;
  padding: 0px;
  float: right;
  min-height: 75%;
}

.filters-unit-bottom {
  //margin: auto;
  display: flex;
  //margin: 3px;
  margin-bottom: 0px;
  padding: 0px;
  float: right;
  min-height: 13%;
  background-color: #efefef;
}

.filters-container li {
  list-style: none;
  //padding: 3px;
  color: #333;
  text-align: center;
  cursor: pointer;
  //line-height: 2.4em;
  width: 58px;
  font-size: 10px;
  border-left: 1px solid #efefef;
  //border-right: 1px solid #efefef;
  border-radius: 2px;
}

.filters-unit-bottom li {
  border-left: unset;
}

.filters-label {
  max-height: 28%;
}

.filters-container li.count {
  max-width: 35px;
}

.filters-label-end {
  background-color: #d4d4d4;
  font-weight: bold;
}

.filters-label-end li.count {
  max-width: 35px;
}

.filters-number {
  font-weight: bold;
  margin: 0px 0px 0px 0px;
  font-size: 9px;
  max-height: 28%;
  display: block;
  line-height: normal;
}

.total-number {
  border-top: 1px solid #000;
}

.days-label {
  background-color: #efefef;
  font-weight: bold;
  border-radius: 5px 5px 0px 0px;
  padding-top: 3px;
  display: flex;
  justify-content: space-evenly;
}

.date-number {
  margin: 2px 0px 0px 0px;
  font-size: 11px;
  height: 65%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.total-week:hover {
  cursor: default;
}

.dropdown-menu.ul-filters {
  min-width: 90px;
  border-radius: 0px;
}

.selection-cal {
  float: left;
  font-size: 12px;
  color: #0a0a0a;
  border-radius: 0px;
  height: 30px;
  width: 100%;
  font-family: "Montserrat", Montserrat, serif;
}

.cal-date-drop {
  display: flex;
}

.cal-select {
  float: left;
  font-size: 11px;
  color: #0a0a0a;
  border-radius: 0px;
  height: 10px;
  background-color: #efefef;
}

.dropdown-menu.ul-dates {
  border-radius: 0px;
  max-width: 125px;
  min-width: 125px;
}

.ul-dates li {
  margin: 2px;
}

.ul-dates li i {
  margin-right: 10px;
  color: #96281b;
}

.ul-dates li a:not(:last-child):after {
  //border-bottom: 1px solid rgba(116, 171, 203, 0.5);
  content: ""; /* This is necessary for the pseudo element to work. */
  display: block; /* This will put the pseudo element on its own line. */
  margin: 0 auto; /* This will center the border. */
  width: 70%; /* Change this to whatever width you want. */
  border-bottom: 1px solid rgba(222, 220, 220, 0.36); /* This creates the border. Replace black with whatever color you want. */
}

.ul-dates a {
  font-family: "Montserrat", Montserrat, serif;
  font-size: 10px;
  text-transform: uppercase;
  min-width: 50px;
  cursor: pointer;
}

.activeDate {
  background-color: #7eb5dd;
  color: #fff !important;
}

.activeDate:hover {
  background-color: #7eb5dd;
  color: #000 !important;
}

.day_is_future {
  opacity: 0.4;
}

.day_is_future:hover {
  cursor: not-allowed;
}

.numbers-compare {
  font-weight: bold;
}

.negativeDiff {
  color: red;
}

.positiveDiff {
  color: #00c32b;
}

.sameDiff {
  color: #004b83;
}

.choose-dates-nav-side {
  font-size: 12px;
  display: flex;
}

.edit-text-cancel-btn-cal-nav {
  float: right;
  color: red !important;
}

.edit-text-cancel-btn-cal-nav:hover {
  color: black !important;
}

.edit-text-cancel-btn-cal-day {
  color: red !important;
  position: absolute;
  right: -4px;
  top: -7px;
  z-index: 2;
  transition: all 0.5s ease-in;
}

.edit-text-cancel-btn-cal-day:hover {
  transform: scale(1.3);
  color: black !important;
}

.edit-text-cancel-btn-cal-month {
  color: red !important;
  position: absolute;
  right: -7px;
  top: -7px;
  z-index: 2;
  transition: all 0.5s ease-in;
}

.edit-text-cancel-btn-cal-month:hover {
  transform: scale(1.3);
  color: black !important;
}

.user_mode_date_is_weekend {
  opacity: 0.3;
}

.user_mode_date_is_weekend:hover {
  cursor: not-allowed;
}

.day_is_weekend {
  background-color: #ffd95a;
}

.shift_not_selected {
  background-color: #7c28c6;
}

.day_is_weekend_top {
  background-color: #f9a825;
}

.today_have_birthday {
  border: 2px solid #76ff03;
}

.cake-img {
  color: #ec407a;
}

.events-img {
  color: #c30000;
  margin-left: 2px;
}

.bd-table {
  position: absolute;
  //bottom: 23px;
  right: -125%;
  bottom: 55px;
  z-index: 200;
  width: -moz-max-content;
  width: max-content;
  background-color: #efefef;
  /* border-radius: 5px; */
  border: solid 2px #ec407a;
  /*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  font-size: 13px;
}

.bd-text {
  font-size: 12px;
}

.evt-table {
  position: absolute;
  //bottom: 23px;
  left: -450%;
  bottom: 55px;
  z-index: 200;
  width: -moz-max-content;
  width: max-content;
  background-color: #ffffff;
  /* border-radius: 5px; */
  border: solid 1px #c30000;
  /*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  font-size: 12px;
  font-weight: normal;
}

.shift-selection {
  position: absolute;
  bottom: 57px;
  z-index: 200;
  width: -moz-max-content;
  width: max-content;
  background-color: #ffffff;
  border: solid 1px #c30000;
  font-size: 12px;
  font-weight: normal;
}

.hover-shift-selection {
  position: absolute;
  bottom: 61px;
  /*z-index: 190;*/
  z-index: 1000;
  width: -moz-max-content;
  width: max-content;
  background-color: #ffffff;
  /*border: solid 1px #c30000;*/
  font-size: 12px;
  font-weight: normal;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.hover-shift-selection-deposit {
  position: fixed;
  bottom: 33vh;
  left: 6.6vw;
  width: 86.8vw;
  //height: 70vh;
  z-index: 1000;
  background-color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.shift-name:hover {
  background-color: #79cfe5;
}

.evt-text {
  font-size: 12px;
}

.evt-header-text {
  font-weight: bolder;
  color: #4d0000;
}

.date-ranges-big .dropdown-toggle {
  cursor: pointer;
}

.table {
  margin-bottom: 0px;
}

.pastEvent {
  color: #3a5169;
  opacity: 0.7;
}

.dc-button {
  font-size: 10px;
  //margin-bottom: 3px;
  line-height: 2px;
}

.dropdown-menu.ul-hours {
  border-radius: 0px;
  max-width: 125px;
  min-width: 125px;
  max-height: 150px;
  overflow-y: scroll;
  top: unset !important;
  bottom: 100% !important;
}

.ul-hours li {
  margin: 2px;
}

.ul-hours li i {
  margin-right: 10px;
  color: #96281b;
}

.ul-hours li a:not(:last-child):after {
  //border-bottom: 1px solid rgba(116, 171, 203, 0.5);
  content: ""; /* This is necessary for the pseudo element to work. */
  display: block; /* This will put the pseudo element on its own line. */
  margin: 0 auto; /* This will center the border. */
  width: 70%; /* Change this to whatever width you want. */
  border-bottom: 1px solid rgba(222, 220, 220, 0.36); /* This creates the border. Replace black with whatever color you want. */
}

.ul-hours a {
  font-family: "Montserrat", Montserrat, serif;
  font-size: 10px;
  text-transform: uppercase;
  min-width: 50px;
  cursor: pointer;
}

.arrow-button {
  width: 20px;
  font-size: 20px;
  margin: 2px;
  display: flex;
  flex-direction: column;
  color: black;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
}

.arrow-button:hover {
  cursor: pointer;
}

.disabled {
  color: #efefef !important;
}

.disabled:hover {
  cursor: not-allowed;
}

.cancel-cal {
  position: absolute;
  left: 2px;
  margin-top: 4px;
  display: flex;
}

.cancel-cal-main {
  position: absolute;
  left: 120px;
  margin-top: 1px;
  display: flex;
}

.cancel-hour {
  position: absolute;
  right: -13px;
  margin-top: -3px;
  display: flex;
  z-index: 3;
}

.hours-icon {
  position: absolute;
  left: 0px;
  top: 10px;
}

.date-number-anim {
  color: #000000;
  opacity: 0;
  transform: translate(-150px, -50px) rotate(-180deg) scale(3);
  animation: revolveScale 0.4s forwards;
}

@keyframes revolveScale {
  60% {
    transform: translate(0px, 0px) rotate(30deg) scale(0.3);
  }

  100% {
    transform: translate(0) rotate(0) scale(1);
    opacity: 1;
  }
}

.main-calendars {
  display: flex;
  //border: 1px solid #ddd;
  min-height: 24px;
  background-color: #fff;
  flex-direction: row;
}

//
//.ul-cals {
//  margin: 0.5px;
//  padding: 0;
//  list-style: none;
//  display: flex;
//  justify-content: space-between;
//  position: relative;
//  background: white;
//  float: right;
//  text-transform: capitalize;
//}
//
//.ul-cals.style2 li:not(:last-child) {
//  margin-right: 2px;
//}
//
//.ul-cals li {
//  position: relative;
//  max-width: 100%;
//  min-width: 78px;
//  height: 20px;
//  margin: 0;
//  cursor: pointer;
//  background: white;
//  border-radius: 0;
//  font-size: 11px;
//  text-align: center;
//  vertical-align: middle;
//  line-height: 20px;
//  border-bottom: 2px solid transparent;
//  flex-grow: 1;
//  transition: background 0.2s ease, color 0.2s ease;
//  padding: 0px 5px 0px;
//}
.ul-cals.style2 li.monthBetween {
  background-color: #daf6ff;
  color: #000000;
}

.monthBetween {
  background-color: #daf6ff;
  color: #000000;
}

.ul-cals.style2 li.active {
  background-color: #808080;
  color: #ffffff;
}

.ul-cals.style2 li:hover {
  background-color: #c7ddef;
}

.ul-filters {
  margin: 0px;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
  position: relative;
  background: white;
  float: right;
  text-transform: capitalize;
  max-width: calc(10%);
}

.ul-filters.style2 li:not(:last-child) {
  margin-right: 2px;
}

.ul-filters li {
  max-width: 100%;
  min-width: 96px;
  height: 39px;
  margin: 0;
  cursor: pointer;
  background: white;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  border-radius: 2px;
  line-height: 17px;
  //border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
  //padding: 0px 5px 0px;
  display: flex;
  flex-direction: column;
}

.ul-filters.style2 li.active {
  background-color: #a7a7a7;
  color: #ffffff;
}

.ul-filters.style2 li:hover {
  background-color: #d7d7d7;
}

.ul-years {
  margin: 0px;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
  position: relative;
  background: white;
  float: right;
  text-transform: capitalize;
}

.ul-years.style2 li:not(:last-child) {
  margin-right: 2px;
}

.ul-years li {
  max-width: 100%;
  min-width: 40px;
  height: 39px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 2px;
  font-size: 11px;
  text-align: center;
  vertical-align: middle;
  line-height: 20px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
  padding: 0px 5px 0px;
}

.ul-years.style2 li.active {
  background-color: #808080;
  color: #ffffff;
}

.ul-years.style2 li:hover {
  background-color: #c7ddef;
}
.reason_input{
  border: 1px none #333;
  border-bottom-style: solid;
  display: block;
  width: 100%;
  height: 32px;
  padding: 0;
  margin-bottom: 15px;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 0
}
.ul-months {
  margin: 0px;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
  position: relative;
  background: white;
  float: right;
  text-transform: capitalize;
}

.ul-months.style2 li:not(:last-child) {
  margin-right: 2px;
}

.ul-months li {
  max-width: 100%;
  min-width: 64px;
  height: 39px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 2px;
  font-size: 10px;
  text-align: center;
  vertical-align: middle;
  line-height: 17px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
  padding: 0px 5px 0px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.ul-months.style2 li.active {
  background-color: #808080;
  color: #ffffff;
}

.ul-months.style2 li.monthBetween {
  background-color: #daf6ff;
  color: #000000;
}

.ul-months.style2 li:hover {
  background-color: #d8e7f3;
}

.ul-presets {
  margin: 0px;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
  position: relative;
  background: white;
  float: right;
  text-transform: capitalize;
}

.ul-presets.style2 li:not(:last-child) {
  //margin-right: 2px;
}

.ul-presets li {
  max-width: 100%;
  min-width: 30px;
  height: 39px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 2px;
  font-size: 10px;
  text-align: center;
  vertical-align: middle;
  line-height: 20px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
  padding: 0px 0px 0px;
  font-weight: normal;
}

.ul-presets.style2 li.active {
  background-color: #808080;
  color: #ffffff;
}

.ul-presets.style2 li:hover {
  background-color: #d8e7f3;
}

.ul-hours {
  margin: 0px;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
  position: relative;
  background: white;
  float: right;
  text-transform: capitalize;
  letter-spacing: 1px;
}

.ul-hours.style2 li:not(:last-child) {
  //margin-right: 2px;
}

.ul-hours li {
  position: relative;
  max-width: 100%;
  min-width: 33px;
  height: 39px;
  margin: 0px 1px;
  cursor: pointer;
  background: white;
  border-radius: 2px;
  font-size: 10px;
  text-align: center;
  vertical-align: middle;
  line-height: 17px;
  //border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
  padding: 0px 0px 0px;
  font-weight: normal;
  display: flex;
  flex-direction: column;
}

.ul-hours.style2 li.active {
  background-color: #7eb5dd;
  color: #fff !important;
}

.ul-hours.style2 li.monthBetween {
  background-color: #daf6ff;
  color: #000000;
}

.ul-hours.style2 li.is_hour {
  background-color: #808080;
  color: #fff;
}

.ul-hours.style2 li:hover {
  background-color: #d8e7f3;
}

.ul-hours.style2 li.active:hover {
  background-color: #7eb5dd;
  color: #000 !important;
}

.loader-img {
  width: 20px;
}

.months-ranges {
  font-size: 8px;
  //font-weight: normal;
  color: #000;
  margin-top: 1px;
  //padding-top: 1px;
}

.hours-counter {
  font-size: 8px;
  font-weight: 700;
  max-height: 14%;
  /* line-height: 12px; */
  padding: 0px;
  margin-top: -2px;
}

.date-number-inline {
  border-radius: 50%;
  background: rgb(255, 255, 255);
  height: 13px;
  width: 13px;
  display: flex; /* or inline-flex */
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 9px;
}

.months-ranges.date-number-inline {
  font-weight: bold;
  background: #6bff00;
  font-size: 10px;
  padding: 8px;
}

.main-tabs-container {
  /*min-width: 145px;*/
  min-width: 115px;
  /*min-width: 8%;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 11px;
}

.main-tabs-container:hover {
  cursor: pointer;
  /*background-color: #8f8f8f;*/
}

.hours-label {
  max-height: 13px;
  //font-size: 8px;
  transform: scalex(1.2);
  font-family: "digital";
  font-weight: bold;
}

.inner-layer {
  border-top: 1px solid var(--br-color);
  color: #ffffff;
}

.main-tab-selector {
  background-color: var(--br-color);
  color: #fff;
}

.inner-layer-anim {
  animation: move_wave 1s linear;
}

@keyframes move_wave {
  0% {
    background-color: var(--br-color);
  }
  100% {
    background-color: #fff;
  }
}

.calendar-tab {
  text-align: left;
  width: 79%;
  white-space: nowrap;
  background-color: inherit;
  display: inline-flex;
}

.calendar-tab-number {
  color: #cbc26f;
  float: right;
  font-size: 11px;
  margin-right: 11px;
}

.dropdown-item {
  height: 28px;
  padding: 7px 0px;
  margin: 0px;
  border-radius: 0px;
  outline: none;
  font-size: 11px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
  font-weight: 500;
}

.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}

.gnm-menu {
  display: block;
}
.sub-menu-calTabs {
  border-radius: 0px;
  margin: 0px;
  padding: 0px;
  padding-left: 5px;
  z-index: 99999;
  background-color: #fff;
  min-width: 160px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.dropdown-item-left-callTabs {
  margin-left: 23px;
}

.btn-last-mod {
  color: #ffffff;
  background-color: #8a8c5b;
  border-color: #6e6f47;
}

.btn-last-mod:hover,
.btn-last-mod:focus,
.btn-last-mod:active,
.btn-last-mod.active,
.open .dropdown-toggle.btn-last-mod {
  color: #ffffff;
  background-color: #8a8c5b;
  border-color: #6e6f47;
}

.btn-last-mod-tag {
  color: #ffffff;
  background-color: #0092bc;
  border-color: #026f8e;
}

.btn-last-mod-tag:hover,
.btn-last-mod-tag:focus,
.btn-last-mod-tag:active,
.btn-last-mod-tag.active,
.open .dropdown-toggle.btn-last-mod-tag {
  color: #ffffff;
  background-color: #0092bc;
  border-color: #026f8e;
}

.btn-sc {
  color: #ffffff;
  background-color: #fa8100;
  border-color: #d16e04;
}

.btn-sc:hover,
.btn-sc:focus,
.btn-sc:active,
.btn-sc.active,
.open .dropdown-toggle.btn-sc {
  color: #ffffff;
  background-color: #fa8100;
  border-color: #d16e04;
}

.btn-ass {
  color: #ffffff;
  background-color: #abce40;
  border-color: #8aa733;
}

.btn-lead {
  color: #ffffff;
  background-color: #4275ec;
  border-color: #2d51a7;
}

.btn-na {
  color: #ffffff;
  background-color: #f4511e;
  border-color: #c14118;
}

.btn-ass:hover,
.btn-ass:focus,
.btn-ass:active,
.btn-ass.active,
.open .dropdown-toggle.btn-ass {
  color: #ffffff;
  background-color: #abce40;
  border-color: #8aa733;
}

.btn-transfer {
  color: #ffffff;
  background-color: #ab9b0c;
  border-color: #84780b;
}

.btn-transfer:hover,
.btn-transfer:focus,
.btn-transfer:active,
.btn-transfer.active,
.open .dropdown-toggle.btn-transfer {
  color: #ffffff;
  background-color: #ab9b0c;
  border-color: #84780b;
}

.btn-deposit {
  color: #ffffff;
  background-color: #ae3ede;
  border-color: #8b32b1;
}

.btn-deposit:hover,
.btn-deposit:focus,
.btn-deposit:active,
.btn-deposit.active,
.open .dropdown-toggle.btn-deposit {
  color: #ffffff;
  background-color: #ae3ede;
  border-color: #8b32b1;
}

.month-wrapper {
  display: flex;
  justify-content: center;
  height: 11px;
  position: relative;
}

.btn-success-header {
  color: #ffffff;
  background-color: #1bc51b;
  border-color: #1bc51b;
}

.btn-success-header:hover,
.btn-success-header:focus,
.btn-success-header:active,
.btn-success-header.active,
.open .dropdown-toggle.btn-success-header {
  color: #ffffff;
  background-color: #1bc51b;
  border-color: #1bc51b;
}

.btn-primary-header {
  color: #ffffff;
  background-color: #286090;
  border-color: #204d74;
}

.btn-primary-header:hover,
.btn-primary-header:focus,
.btn-primary-header:active,
.btn-primary-header.active,
.open .dropdown-toggle.btn-primary-header {
  color: #ffffff;
  background-color: #286090;
  border-color: #204d74;
}

.btn-danger-header {
  color: #ffffff;
  background-color: #c9302c;
  border-color: #ac2925;
}

.btn-danger-header:hover,
.btn-danger-header:focus,
.btn-danger-header:active,
.btn-danger-header.active,
.open .dropdown-toggle.btn-danger-header {
  color: #ffffff;
  background-color: #c9302c;
  border-color: #ac2925;
}

.btn-info-header {
  color: #ffffff;
  background-color: #2ba3cf;
  border-color: #33b5e5;
}

.btn-info-header:hover,
.btn-info-header:focus,
.btn-info-header:active,
.btn-info-header.active,
.open .dropdown-toggle.btn-info-header {
  color: #ffffff;
  background-color: #2ba3cf;
  border-color: #33b5e5;
}

.btn-na:hover,
.btn-na:focus,
.btn-na:active,
.btn-na.active,
.open .dropdown-toggle.btn-na {
  color: #ffffff;
  background-color: #f4511e;
  border-color: #c14118;
}

.btn-lead:hover,
.btn-lead:focus,
.btn-lead:active,
.btn-lead.active,
.open .dropdown-toggle.btn-lead {
  color: #ffffff;
  background-color: #4275ec;
  border-color: #2d51a7;
}

.btn-warning-header {
  color: #ffffff;
  background-color: #ec971f;
  border-color: #d58512;
}

.btn-warning-header:hover,
.btn-warning-header:focus,
.btn-warning-header:active,
.btn-warning-header.active,
.open .dropdown-toggle.btn-warning-header {
  color: #ffffff;
  background-color: #ec971f;
  border-color: #d58512;
}

.btn-dark {
  color: #fff;
  background-color: #000000;
  border-color: #343a40;
}

.btn-dark:hover,
.btn-dark:focus,
.btn-dark:active,
.btn-dark.active,
.open .dropdown-toggle.btn-dark {
  color: #ffffff;
  background-color: #000000;
  border-color: #444;
}

.fa-clock {
  position: absolute;
  left: 2px;
  top: 2px;
}

.above_the_avg {
  background-color: #44c13e !important;
}

.below_the_avg {
  background-color: #cf3430 !important;
}

.below_the_avg .date-number {
  color: #fff;
}

.same_as_avg {
  background-color: #c2d6ff !important;
}

.move-pop-up {
  right: -91px;
}

.move-pop-up-left {
  left: -137px;
}

.arrow {
  position: absolute;
  top: 26px;
  left: 15px;
  /* transform: translate(50%,50%); */
  -webkit-transform: rotate(45deg);
  transform: rotate(0deg);
  visibility: hidden;
}

.arrow span {
  display: block;
  width: 5px;
  height: 5px;
  border-bottom: 1px solid white;
  border-right: 1px solid white;
  transform: rotate(45deg);
  margin: -10px;
}

.main-cal-div:hover .arrow span:nth-child(1) {
  animation: animate 2s infinite;
}

.main-cal-div:hover .arrow span:nth-child(2) {
  animation: animate 2s infinite;

  animation-delay: -0.2s;
}

.main-cal-div:hover .arrow span:nth-child(3) {
  animation: animate 2s infinite;

  animation-delay: -0.4s;
}

@keyframes animate {
  0% {
    opacity: 0;
    transform: rotate(45deg) translate(-5px, -5px);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(45deg) translate(5px, 5px);
  }
}

.main-cal-div:hover .arrow {
  visibility: visible;
}

.pagination-callTab-wrapper {
  display: inline-block;
  float: right;
  margin-right: -1px;
}

.tab-pagination-right {
  margin-left: 5px;
}

.tab-pagination-left:hover,
.tab-pagination-right:hover {
  color: #808080;
}

.numInPercents {
  /*padding-left: 5px;*/
}

.toggle-left-side.numInPercents {
  /*min-width: 35px !important;*/
}

.bg-compare {
  background-color: #f0faff;
  border-radius: 5px;
}

.toggle-left-side-second {
  max-width: 50px;
  width: 50px;
  margin-left: 4px;
}

.t-l-s-second {
  margin-left: 9px;
}

.right-add-second {
  top: 0px;
  right: -30px;
  position: absolute;
  width: 38px;
  height: 44px;
  background-color: inherit;
  border-radius: 0px 5px 0px 0px;
}

.tag_from_tag {
  border: 2px solid #122b40 !important;
}

.presets-selector {
  position: relative;
  border: 1px solid #b5b5b5;
  color: #0a0a0a;
  font-size: 10px;
  border-radius: 5px;
  display: flex;
  justify-content: space-evenly;
}

.active_compare {
  background-color: #b6e3ff;
}

.presets-selector:hover {
  background-color: #d8e7f3;
  cursor: pointer;
}

.week-num {
  font-weight: bold;
  margin-right: 5px;
}

.presets-selector.active {
  background-color: #808080;
  color: #fff;
}

.days-wrapper {
  display: flex;
}

li:not(.day_is_future) > span > div.schedule-day-title:hover {
  cursor: progress;
}

.schedule-day-title:hover {
  background-color: orange;
}

.no-calls-tooltip {
  color: grey;
  border-radius: 7px;
  padding: 7px;
  font-weight: 800;
  transition: all 0.1s ease-in;
}

.select-date-for-request {
  background-color: #def2fb !important;
}

.merge-btn {
  width: 20px;
  height: 20px;
  margin-left: 5px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.new-btn {
  width: 20px;
  height: 20px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.week-com-buttons-wrapper {
  position: absolute;
  top: -22px;
  width: 100%;
  display: flex;
  margin-left: 5px;
  height: 30px;
}

.week-com-buttons-wrapper > .btn:focus {
  outline: none;
}

.active_arrow {
  background-color: #0fb97b;
}

.shift-costume-window {
  position: absolute;
  background-color: #ffffff;
  border: 1px solid black;
  color: black;
  right: -209px;
  top: 0px;
  height: 100%;
}

.shift-costume-window-inner {
  display: flex;
  flex-direction: column;
  margin: 0.5rem;
}

.bg-dp {
  background-color: rgba(189, 58, 255, 0.7);
}

.move-dep-pop-up-left {
  //left: -140px;
}

.modal-content {
  width: fit-content !important;
}

.modal-dialog {
  margin: 30px 22%;
}

.congrats-btn {
  margin-top: 2px;
}

.bd-container {
  cursor: default;
}

.btn-cong {
  cursor: pointer;
  margin-top: 7px;
  border: 0;
  margin-right: 3px;
}

.btn-cong-dis {
  cursor: default;
  margin-top: 7px;
  border: 0;
  margin-right: 3px;
  background-color: lightgrey;
}

.modal-stats {
  height: 175px;
  background-color: #ffffff;
  border-radius: 6px;
}

#approveTasksModal .modal-content {
  width: 800px !important;
}

#approveTasksModal .modal-dialog {
  margin: 100px auto;
}
</style>
